import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AddCityInput = {
  country?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  country: Scalars['String'];
  fullAddress: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  postalCode: Scalars['String'];
  state: Scalars['String'];
  streetAddress: Scalars['String'];
};

export enum AdjustmentType {
  AmountAdjustment = 'AmountAdjustment',
  PercentageAdjustment = 'PercentageAdjustment'
}

export type Amenity = {
  __typename?: 'Amenity';
  /** Internal code for amenity. You can use it to derive whether an amenity is standard (has ds_code) or non-standard (no ds_code) */
  code?: Maybe<Scalars['String']>;
  iconURL: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum AuthMethod {
  /** Passwordless email with no password. */
  Email = 'Email',
  Google = 'Google',
  Okta = 'Okta',
  /** Email with password */
  Password = 'Password'
}

export type AvailableDay = {
  __typename?: 'AvailableDay';
  availableFullDay: Scalars['Boolean'];
  closedAt: Scalars['String'];
  date: Scalars['String'];
  openAt: Scalars['String'];
};

export type AvailableTimeSlot = {
  __typename?: 'AvailableTimeSlot';
  endTimes: Array<Scalars['String']>;
  startTime: Scalars['String'];
};

export type BestDayRates = {
  __typename?: 'BestDayRates';
  date: Scalars['String'];
  price: Scalars['Float'];
};

export type BetterHourRateOption = {
  __typename?: 'BetterHourRateOption';
  adjustmentType?: Maybe<AdjustmentType>;
  adjustmentValue: Scalars['Float'];
  endTime?: Maybe<Scalars['String']>;
  minBookingUnit?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  unitPrice: Scalars['Float'];
};

export type BetterHourRates = {
  __typename?: 'BetterHourRates';
  currentUnitPrice: Scalars['Float'];
  date: Scalars['String'];
  options: Array<BetterHourRateOption>;
  originalUnitPrice: Scalars['Float'];
};

export type BillingDetails = {
  __typename?: 'BillingDetails';
  address: CardAddress;
  email?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type Booking = {
  __typename?: 'Booking';
  endDate: Scalars['String'];
  endTime?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  space: Space;
  startDate: Scalars['String'];
  startTime?: Maybe<Scalars['String']>;
  user: OrganizationUser;
};

export type BookingConfig = {
  __typename?: 'BookingConfig';
  enabled: Array<BookingType>;
  multiDayBookingAllowed: Scalars['Boolean'];
};

export type BookingHour = {
  __typename?: 'BookingHour';
  closedAt: Scalars['String'];
  dayOfWeek: DayOfWeek;
  openAt: Scalars['String'];
};

export type BookingRequest = {
  __typename?: 'BookingRequest';
  amount?: Maybe<Scalars['Float']>;
  bookedAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  endDate: Scalars['String'];
  endTime?: Maybe<Scalars['String']>;
  groupBudget?: Maybe<GroupBudget>;
  id: Scalars['ID'];
  organizationBudget?: Maybe<OrganizationBudget>;
  reason: Scalars['String'];
  requester: OrganizationUser;
  requesterTotalSpend: Scalars['Float'];
  reviewedAt?: Maybe<Scalars['String']>;
  reviewer?: Maybe<OrganizationUser>;
  reviewerNote?: Maybe<Scalars['String']>;
  space: Space;
  startDate: Scalars['String'];
  startTime?: Maybe<Scalars['String']>;
  status: BookingRequestStatus;
};


export type BookingRequestRequesterTotalSpendArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export enum BookingRequestStatus {
  Approved = 'Approved',
  Booked = 'Booked',
  Cancelled = 'Cancelled',
  Declined = 'Declined',
  Expired = 'Expired',
  Pending = 'Pending'
}

export enum BookingType {
  DailyBooking = 'DailyBooking',
  HourlyBooking = 'HourlyBooking'
}

export type BookingUser = {
  __typename?: 'BookingUser';
  avatar: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type BudgetPolicy = {
  __typename?: 'BudgetPolicy';
  applyToBudgets: Array<GroupBudget>;
  id: Scalars['ID'];
  isAppliedToNewBudget: Scalars['Boolean'];
  lastUpdated: Scalars['String'];
  locationItems?: Maybe<Array<BudgetPolicyLocationItem>>;
  name: Scalars['String'];
  spaceTypes: SpaceTypes;
};

export type BudgetPolicyAddress = {
  __typename?: 'BudgetPolicyAddress';
  id: Scalars['ID'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  street: Scalars['String'];
};

export type BudgetPolicyLocationItem = {
  __typename?: 'BudgetPolicyLocationItem';
  address: BudgetPolicyAddress;
  distance: Scalars['Float'];
  distanceUnit: BudgetPolicyLocationItemDistanceType;
  id: Scalars['ID'];
};

export enum BudgetPolicyLocationItemDistanceType {
  Km = 'KM',
  Mi = 'MI'
}

export type BudgetPolicyLocationItemInput = {
  addressId?: InputMaybe<Scalars['String']>;
  distance: Scalars['Float'];
  distanceUnit: BudgetPolicyLocationItemDistanceType;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  street: Scalars['String'];
};

export type BudgetPolicyLocationItemUpdateInput = {
  addressId?: InputMaybe<Scalars['String']>;
  distance?: InputMaybe<Scalars['Float']>;
  distanceUnit?: InputMaybe<BudgetPolicyLocationItemDistanceType>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  street?: InputMaybe<Scalars['String']>;
};

export type CancelBookingRequestInput = {
  id: Scalars['String'];
};

export type CancellationFeeTier = {
  __typename?: 'CancellationFeeTier';
  /** ISO 8601 instant the tier closes at */
  cancellationAllowedBefore?: Maybe<Scalars['String']>;
  refundPercentage: Scalars['Float'];
};

export type CardAddress = {
  __typename?: 'CardAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type CardPaymentMethod = {
  __typename?: 'CardPaymentMethod';
  id?: Maybe<Scalars['ID']>;
  last4: Scalars['String'];
  network: Scalars['String'];
  networkLogoUrl: Scalars['String'];
};

export type Category = {
  __typename?: 'Category';
  code: Scalars['String'];
  description: Scalars['String'];
  name: Scalars['String'];
};

export type ChangeUserPasswordInput = {
  currentPassword: Scalars['String'];
  email: Scalars['String'];
  newPassword: Scalars['String'];
  newPasswordConfirmation: Scalars['String'];
};

export type CheckinUser = {
  __typename?: 'CheckinUser';
  avatar: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type CheckoutInput = {
  guest: ContactInfoInput;
  memo?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  orderItems: Array<OrderItemInput>;
  partnerID?: InputMaybe<Scalars['String']>;
  promoCode?: InputMaybe<Scalars['String']>;
  quoteId: Scalars['ID'];
  subSource?: InputMaybe<OrderSubSource>;
};

export type City = {
  __typename?: 'City';
  country?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type ClaimUserPromotionInput = {
  promotionCode: Scalars['String'];
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  companyName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
};

export type ContactInfoInput = {
  companyName: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type Country = {
  __typename?: 'Country';
  cities: Array<City>;
  code: Scalars['String'];
  name: Scalars['String'];
};

export type CreateBookingRequestInput = {
  amount: Scalars['Float'];
  endDate: Scalars['String'];
  endTime?: InputMaybe<Scalars['String']>;
  quoteId: Scalars['String'];
  reason: Scalars['String'];
  spaceId: Scalars['String'];
  startDate: Scalars['String'];
  startTime?: InputMaybe<Scalars['String']>;
};

export type CreateBudgetPolicyInput = {
  applyToBudgetIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  isAppliedToNewBudget?: InputMaybe<Scalars['Boolean']>;
  locationItems?: InputMaybe<Array<InputMaybe<BudgetPolicyLocationItemInput>>>;
  name: Scalars['String'];
  spaceTypes: SpaceTypesInput;
};

export type CreateFavoriteLocationInput = {
  resourceId: Scalars['ID'];
};

export type CreateFavoriteSpaceInput = {
  resourceId: Scalars['ID'];
};

export type CreateGroupBudgetInput = {
  color: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  individualLimit?: InputMaybe<Scalars['Float']>;
  limit: Scalars['Float'];
  /** The people ids of the organization users that are managers of this group */
  managerIds: Array<Scalars['ID']>;
  /** The people ids of the organization users that are members of this group */
  memberIds?: InputMaybe<Array<Scalars['ID']>>;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  policyId?: InputMaybe<Scalars['ID']>;
};

export type CreateOrganizationBudgetInput = {
  individualLimit?: InputMaybe<Scalars['Float']>;
  limit: Scalars['Float'];
  policyId?: InputMaybe<Scalars['ID']>;
};

export type CreateOrganizationInput = {
  hasDomain: Scalars['Boolean'];
  organizationName: Scalars['String'];
};

export type CurrentUser = {
  __typename?: 'CurrentUser';
  auth0PrimaryEmail: Scalars['String'];
  auth0PrimaryEmailVerified: Scalars['Boolean'];
  authMethod: AuthMethod;
  bookingRequests?: Maybe<Array<BookingRequest>>;
  city?: Maybe<City>;
  /** @deprecated use flat fields instead */
  contactInfo: ContactInfo;
  createdAt?: Maybe<Scalars['String']>;
  createdWith: Scalars['String'];
  /** @deprecated use ipPlace instead */
  detectedCountry?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  favoriteLocations?: Maybe<Array<Location>>;
  favoriteSpaces?: Maybe<Array<Space>>;
  fullName: Scalars['String'];
  groupBudget?: Maybe<GroupBudget>;
  groupBudgetRole?: Maybe<GroupBudgetRole>;
  hasBookedBefore: Scalars['Boolean'];
  hasSignedUpWithSocialProvider: Scalars['Boolean'];
  id: Scalars['ID'];
  ipPlace: Place;
  orders: Array<Order>;
  organization?: Maybe<Organization>;
  paymentCustomerID?: Maybe<Scalars['ID']>;
  paymentMethod?: Maybe<PaymentMethod>;
  phoneNumber?: Maybe<Scalars['String']>;
  picture: Scalars['String'];
  promotions: Array<UserPromotion>;
  /** @deprecated use organizationUser field instead */
  role: UserRole;
  title?: Maybe<Scalars['String']>;
};


export type CurrentUserOrdersArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<OrderSort>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type DailyBooking = {
  __typename?: 'DailyBooking';
  arrivalTime?: Maybe<Scalars['String']>;
  attendees?: Maybe<Scalars['Int']>;
  cancellationAllowed: Scalars['Boolean'];
  cancellationAllowedBefore?: Maybe<Scalars['String']>;
  /** The tiers frozen onto the booking at checkout, each with the instant it closes. Empty when the booking is non-refundable; null when partners serves none (a recurring booking, a booking made before tiers were frozen). */
  cancellationFeeTiers?: Maybe<Array<CancellationFeeTier>>;
  days: Scalars['Int'];
  endDate: Scalars['String'];
  floor: Scalars['String'];
  id: Scalars['ID'];
  layoutID: Scalars['ID'];
  meetingContactInfo?: Maybe<ContactInfo>;
  meetingName?: Maybe<Scalars['String']>;
  orderID: Scalars['ID'];
  physicalSpaceID: Scalars['ID'];
  room: Scalars['String'];
  space: Space;
  spaceID: Scalars['ID'];
  startDate: Scalars['String'];
  time: Scalars['String'];
};

export enum DayOfWeek {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type DetachPaymentMethod = {
  __typename?: 'DetachPaymentMethod';
  status?: Maybe<Scalars['String']>;
};

export type DetachPaymentMethodInput = {
  paymentMethodID: Scalars['ID'];
};

export type DiscoverFilter = {
  city?: InputMaybe<Array<Scalars['String']>>;
  country?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  maxCapacity?: InputMaybe<Scalars['Int']>;
  minCapacity?: InputMaybe<Scalars['Int']>;
  radius?: InputMaybe<Scalars['Float']>;
  startTime?: InputMaybe<Scalars['String']>;
};

export type DynamicPriceRate = {
  __typename?: 'DynamicPriceRate';
  adjusmentType?: Maybe<AdjustmentType>;
  adjusmentValue?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type GroupBudget = {
  __typename?: 'GroupBudget';
  bookingRequests?: Maybe<Array<BookingRequest>>;
  color: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  individualLimit?: Maybe<Scalars['Float']>;
  limit: Scalars['Float'];
  /** both managers and members */
  members: Array<GroupBudgetMember>;
  name: Scalars['String'];
  ordersSummary: OrdersSummary;
  policy?: Maybe<BudgetPolicy>;
  remaining: Scalars['Float'];
  reporting: Reporting;
  spend: Scalars['Float'];
  status?: Maybe<GroupBudgetStatus>;
};


export type GroupBudgetOrdersSummaryArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type GroupBudgetReportingArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type GroupBudgetMember = {
  __typename?: 'GroupBudgetMember';
  role: GroupBudgetRole;
  user: OrganizationUser;
};

export enum GroupBudgetRole {
  Manager = 'Manager',
  Member = 'Member'
}

export enum GroupBudgetStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type HourlyBooking = {
  __typename?: 'HourlyBooking';
  arrivalTime?: Maybe<Scalars['String']>;
  attendees?: Maybe<Scalars['Int']>;
  cancellationAllowed: Scalars['Boolean'];
  cancellationAllowedBefore?: Maybe<Scalars['String']>;
  /** The tiers frozen onto the booking at checkout, each with the instant it closes. Empty when the booking is non-refundable; null when partners serves none (a recurring booking, a booking made before tiers were frozen). */
  cancellationFeeTiers?: Maybe<Array<CancellationFeeTier>>;
  date: Scalars['String'];
  endTime: Scalars['String'];
  floor: Scalars['String'];
  id: Scalars['ID'];
  layoutID: Scalars['ID'];
  meetingContactInfo?: Maybe<ContactInfo>;
  meetingName?: Maybe<Scalars['String']>;
  orderID: Scalars['ID'];
  physicalSpaceID: Scalars['ID'];
  room: Scalars['String'];
  space: Space;
  spaceID: Scalars['ID'];
  startTime: Scalars['String'];
};

export type Image = {
  __typename?: 'Image';
  large: ImageData;
  medium: ImageData;
  small: ImageData;
  thumb: ImageData;
  xlarge: ImageData;
};

export type ImageData = {
  __typename?: 'ImageData';
  height: Scalars['Int'];
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type Invite = {
  __typename?: 'Invite';
  acceptedAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  id: Scalars['String'];
  inviteeEmail?: Maybe<Scalars['String']>;
  inviterId?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type InviteRecipient = {
  __typename?: 'InviteRecipient';
  email: Scalars['String'];
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
};

export type InviteRecipientInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type InviteToTeamInput = {
  users?: InputMaybe<Array<UserToInvite>>;
};

export type InvitesInput = {
  message: Scalars['String'];
  recipients: Array<InviteRecipientInput>;
};

export type Location = {
  __typename?: 'Location';
  address: Address;
  amenities: Array<Amenity>;
  bookingHours: Array<BookingHour>;
  bookings: Array<Booking>;
  /** @deprecated should not use */
  capacity: Scalars['Int'];
  contactEmail?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  directions?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Int']>;
  homeLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images: Array<Image>;
  logo?: Maybe<ImageData>;
  name: Scalars['String'];
  numberOfVisitsByCurrentUser: Scalars['Int'];
  preferred?: Maybe<Scalars['Boolean']>;
  pricingInclusion?: Maybe<Scalars['String']>;
  savedByCurrentUser: Scalars['Boolean'];
  spaces: Array<Space>;
  timezone: Scalars['String'];
};


export type LocationBookingsArgs = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};


export type LocationDistanceArgs = {
  coordinates?: InputMaybe<SpaceSearchCoordinates>;
};


export type LocationSpacesArgs = {
  filter?: InputMaybe<DiscoverFilter>;
  spaceType?: InputMaybe<SpaceType>;
};

export type LocationsFilter = {
  amenities?: InputMaybe<Array<Scalars['String']>>;
  date?: InputMaybe<Scalars['String']>;
  partialMatch?: InputMaybe<Scalars['Boolean']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
};

export enum LocationsSort {
  Distance = 'Distance',
  PriceAsc = 'PriceAsc',
  PriceDesc = 'PriceDesc'
}

export type Market = {
  __typename?: 'Market';
  countries: Array<Country>;
};

export type MovingPeopleMessage = {
  __typename?: 'MovingPeopleMessage';
  messages: Array<MovingPeopleMessageType>;
  newManagerName?: Maybe<Scalars['String']>;
  personName: Scalars['String'];
  previousBudgetName: Scalars['String'];
};

export enum MovingPeopleMessageType {
  DeactivateGroupBudget = 'DeactivateGroupBudget',
  MoveManager = 'MoveManager',
  MoveMember = 'MoveMember',
  PromoteToManager = 'PromoteToManager'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvite: Scalars['Boolean'];
  addCity: City;
  approveBookingRequest: BookingRequest;
  bookOfficeSpaceOnDay: OfficeSpaceBooking;
  cancelBooking: Scalars['Boolean'];
  cancelBookingRequest: BookingRequest;
  cancelOrder: Scalars['Boolean'];
  changeUserPassword: Scalars['Boolean'];
  changeUserRole: Scalars['Boolean'];
  checkinOfficeSpaceToday: OfficeSpaceCheckin;
  checkout: Order;
  claimUserPromotion: UserPromotion;
  createBookingRequest: BookingRequest;
  createBudgetPolicy: BudgetPolicy;
  createGroupBudget: GroupBudget;
  /**
   * Creates organization for the current user.
   *   There will be a corresponding Person record created for the current user.
   *   The current user will be the admin of the organization.
   */
  createOrganization: Organization;
  createOrganizationBudget: OrganizationBudget;
  /** @deprecated Do not use this. Customer is now created automatically when they checkout (if not created before). */
  createPaymentCustomer: PaymentCustomer;
  deactivateGroupBudget: GroupBudget;
  declineBookingRequest: BookingRequest;
  deletePerson: Scalars['Boolean'];
  detachPaymentMethod: DetachPaymentMethod;
  inviteToTeam: Scalars['Boolean'];
  /**
   *
   *         Performs linking of Auth0 users of Passwordless and Database Connection.
   *         In our auth flow, we perform email passwordless login first, which will create a Auth0 user based on Passwordless connection.
   *         After which, the user will be prompted to set a password, which will create a Auth0 user based on Database Connection.
   *         Because these two Auth0 users are different, they represent 2 different Auth0 users.
   *         This mutation will link the two Auth0 users if the email address of the two Auth0 users are the same, after user set a password.
   */
  linkEmailAccountToPasswordAccountIfExists: Scalars['Boolean'];
  /**
   *
   *         Performs linking of Auth0 users of Google and Database Connection after signing up with Google.
   *         Users may choose to sign up with email and password first, which will create a Auth0 user based on Password connection.
   *         When the same user signs in with Google, it would create new Auth0 user based on Google connection.
   *         Because these two Auth0 users are different, they represent 2 different Auth0 users.
   *         This mutation will link the two Auth0 users if the email address of the two Auth0 users are the same, after user signed in with Google.
   */
  linkGoogleAccountToPasswordAccountIfExists: Scalars['Boolean'];
  postAuth: PostAuthResult;
  reactivateGroupBudget: GroupBudget;
  /**
   *
   *         Registers Auth0 user based on email-password provider to the organization that domain matches to the user's email.
   *         We call this when user signs in with email and password, but does not belong to any organization yet.
   *         We look for organization that matches the domain of the user's email
   *         and create a corresponding Person record of that organization.
   */
  registerEmailAccountToOrganizationIfExists: Scalars['Boolean'];
  /**
   *
   *   Registers Auth0 user based on Google authentication to the organization that domain matches to the user's Google email.
   *   We call this when user signs in with Google, but does not belong to any organization yet. We look for organization that matches the domain of the user's Google email
   *   and create a corresponding Person record of that organization.
   */
  registerGoogleAccountToOrganizationIfExists: Scalars['Boolean'];
  /**
   *
   *         Registers Auth0 user based on Okta provider to the organization that domain matches to the user's email.
   *         We call this when user signs in with Okta, but does not belong to any organization yet.
   *         We look for organization that matches the domain of the user's email
   *         and create a corresponding Person record of that organization.
   */
  registerOktaAccountToOrganizationIfExists: Scalars['Boolean'];
  registerOrganizationUserIfNotExists: RegisteredOrganizationUser;
  registerToOrganizationIfExists: Scalars['Boolean'];
  removeBudgetPolicyAddress: Scalars['Boolean'];
  removeFavoriteResource: Scalars['Boolean'];
  requestBudgetIncrease?: Maybe<Scalars['Boolean']>;
  revokeInvite: Scalars['Boolean'];
  sendInvites: OrderInvites;
  sendSupportTicket: Scalars['Boolean'];
  setFavoriteLocation: Scalars['String'];
  setFavoriteSpace: Scalars['String'];
  setupPaymentMethodUpdate: SetupPaymentMethodUpdate;
  unbookOfficeSpace: Scalars['Boolean'];
  updateBookingRequest: BookingRequest;
  updateBudgetPolicy: BudgetPolicy;
  updateGroupBudget: GroupBudget;
  updateOrderBudget: Scalars['Boolean'];
  updateOrderMemo: Scalars['Boolean'];
  updateOrganization: Organization;
  updateOrganizationBudget: OrganizationBudget;
  updateOrganizationName: Organization;
  updateUser?: Maybe<CurrentUser>;
};


export type MutationAcceptInviteArgs = {
  inviteID: Scalars['String'];
};


export type MutationAddCityArgs = {
  input: AddCityInput;
};


export type MutationApproveBookingRequestArgs = {
  input: UpdateBookingRequestStatusInput;
};


export type MutationBookOfficeSpaceOnDayArgs = {
  day: Scalars['String'];
  spaceID: Scalars['String'];
};


export type MutationCancelBookingArgs = {
  bookingID: Scalars['ID'];
};


export type MutationCancelBookingRequestArgs = {
  input: CancelBookingRequestInput;
};


export type MutationCancelOrderArgs = {
  orderID: Scalars['ID'];
};


export type MutationChangeUserPasswordArgs = {
  input: ChangeUserPasswordInput;
};


export type MutationChangeUserRoleArgs = {
  newRole: Scalars['String'];
  personId: Scalars['String'];
};


export type MutationCheckinOfficeSpaceTodayArgs = {
  spaceID: Scalars['String'];
};


export type MutationCheckoutArgs = {
  input: CheckoutInput;
};


export type MutationClaimUserPromotionArgs = {
  input: ClaimUserPromotionInput;
};


export type MutationCreateBookingRequestArgs = {
  input: CreateBookingRequestInput;
};


export type MutationCreateBudgetPolicyArgs = {
  input: CreateBudgetPolicyInput;
};


export type MutationCreateGroupBudgetArgs = {
  input: CreateGroupBudgetInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationBudgetArgs = {
  input: CreateOrganizationBudgetInput;
};


export type MutationDeactivateGroupBudgetArgs = {
  id: Scalars['ID'];
};


export type MutationDeclineBookingRequestArgs = {
  input: UpdateBookingRequestStatusInput;
};


export type MutationDeletePersonArgs = {
  personId: Scalars['String'];
};


export type MutationDetachPaymentMethodArgs = {
  input: DetachPaymentMethodInput;
};


export type MutationInviteToTeamArgs = {
  input: InviteToTeamInput;
};


export type MutationPostAuthArgs = {
  inviteId?: InputMaybe<Scalars['String']>;
};


export type MutationReactivateGroupBudgetArgs = {
  input: ReactivateGroupBudgetInput;
};


export type MutationRemoveBudgetPolicyAddressArgs = {
  addressId: Scalars['ID'];
};


export type MutationRemoveFavoriteResourceArgs = {
  input: RemoveFavoriteResourceInput;
};


export type MutationRequestBudgetIncreaseArgs = {
  input: RequestBudgetIncreaseInput;
};


export type MutationRevokeInviteArgs = {
  inviteID: Scalars['String'];
};


export type MutationSendInvitesArgs = {
  input: InvitesInput;
  orderID: Scalars['ID'];
};


export type MutationSendSupportTicketArgs = {
  content: Scalars['String'];
  subject: Scalars['String'];
  topic: Scalars['String'];
};


export type MutationSetFavoriteLocationArgs = {
  input: CreateFavoriteLocationInput;
};


export type MutationSetFavoriteSpaceArgs = {
  input: CreateFavoriteSpaceInput;
};


export type MutationUnbookOfficeSpaceArgs = {
  bookingID: Scalars['ID'];
  spaceID: Scalars['ID'];
};


export type MutationUpdateBookingRequestArgs = {
  input: UpdateBookingRequestInput;
};


export type MutationUpdateBudgetPolicyArgs = {
  input: UpdateBudgetPolicyInput;
};


export type MutationUpdateGroupBudgetArgs = {
  input: UpdateGroupBudgetInput;
};


export type MutationUpdateOrderBudgetArgs = {
  budgetId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationUpdateOrderMemoArgs = {
  memo?: InputMaybe<Scalars['String']>;
  orderID: Scalars['ID'];
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationBudgetArgs = {
  input: UpdateOrganizationBudgetInput;
};


export type MutationUpdateOrganizationNameArgs = {
  input: UpdateOrganizationNameInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type Office = {
  __typename?: 'Office';
  address?: Maybe<Address>;
  id: Scalars['ID'];
  spaces: Array<OfficeSpace>;
  timeZone: Scalars['String'];
};

export type OfficeSpace = {
  __typename?: 'OfficeSpace';
  bookings: Array<OfficeSpaceBooking>;
  capacity?: Maybe<Scalars['Int']>;
  capacityManaged: Scalars['Boolean'];
  checkins: Array<OfficeSpaceCheckin>;
  content: OfficeSpaceContent;
  id: Scalars['ID'];
  office: Office;
  remainingCapacity: Scalars['Int'];
};


export type OfficeSpaceBookingsArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type OfficeSpaceRemainingCapacityArgs = {
  date?: InputMaybe<Scalars['String']>;
};

export type OfficeSpaceBooking = {
  __typename?: 'OfficeSpaceBooking';
  bookableID: Scalars['String'];
  bookableType: Scalars['String'];
  day: Scalars['String'];
  id: Scalars['ID'];
  user: BookingUser;
};

export type OfficeSpaceCheckin = {
  __typename?: 'OfficeSpaceCheckin';
  checkinableID: Scalars['String'];
  checkinableType: Scalars['String'];
  id: Scalars['ID'];
  moment: Scalars['String'];
  user: CheckinUser;
};

export type OfficeSpaceContent = {
  __typename?: 'OfficeSpaceContent';
  description: Scalars['String'];
  id: Scalars['ID'];
  images: Array<Image>;
  title: Scalars['String'];
};

export type Order = {
  __typename?: 'Order';
  additionalNotes: Scalars['String'];
  cancellable: Scalars['Boolean'];
  confirmationID?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  guest?: Maybe<ContactInfo>;
  id: Scalars['ID'];
  invitees: Array<InviteRecipient>;
  invites: Array<OrderInvites>;
  memo?: Maybe<Scalars['String']>;
  orderItems: Array<OrderItem>;
  paymentDetail?: Maybe<PaymentDetail>;
  processingFee: Scalars['Float'];
  promotionLine?: Maybe<PromotionLine>;
  status: OrderStatus;
  stripeClientSecret?: Maybe<Scalars['String']>;
  subTotal: Scalars['Float'];
  taxLine?: Maybe<TaxLine>;
  totalPrice: Scalars['Float'];
  uncancellable_reason?: Maybe<Scalars['String']>;
  userID?: Maybe<Scalars['String']>;
};

export type OrderInvites = {
  __typename?: 'OrderInvites';
  id: Scalars['ID'];
  message: Scalars['String'];
  recipients: Array<InviteRecipient>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  details: OrderItemDetails;
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  subTotal: Scalars['Float'];
  totalPrice: Scalars['Float'];
  unitPrice: Scalars['Float'];
};

export type OrderItemDetails = DailyBooking | HourlyBooking;

export type OrderItemInput = {
  arrivalTime?: InputMaybe<Scalars['String']>;
  attendees?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['String']>;
  deliveryTime?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  layoutID?: InputMaybe<Scalars['String']>;
  meetingContact?: InputMaybe<ContactInfoInput>;
  meetingName?: InputMaybe<Scalars['String']>;
  physicalSpaceID?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  spaceID?: InputMaybe<Scalars['String']>;
  spaceOfferingID?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  type: OrderItemType;
};

export enum OrderItemType {
  DailyBooking = 'DailyBooking',
  HourlyBooking = 'HourlyBooking'
}

export enum OrderSort {
  CreatedTimeAsc = 'CreatedTimeAsc',
  CreatedTimeDesc = 'CreatedTimeDesc',
  StartDateTimeAsc = 'StartDateTimeAsc',
  StartDateTimeDesc = 'StartDateTimeDesc'
}

export enum OrderStatus {
  Canceled = 'Canceled',
  Confirmed = 'Confirmed',
  Created = 'Created',
  Paid = 'Paid'
}

export enum OrderSubSource {
  Android = 'Android',
  GCal = 'GCal',
  Web = 'Web',
  IOs = 'iOS'
}

export type OrderSummary = {
  __typename?: 'OrderSummary';
  bookingDate: Scalars['String'];
  bookingEndTime?: Maybe<Scalars['String']>;
  bookingRequest?: Maybe<BookingRequest>;
  bookingStartTime?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  groupBudget?: Maybe<GroupBudget>;
  hostFullName: Scalars['String'];
  hostTitle?: Maybe<Scalars['String']>;
  locationAddress: Scalars['String'];
  locationName: Scalars['String'];
  order: Order;
  orderCreatedAt: Scalars['String'];
  orderID: Scalars['ID'];
  organizationBudget?: Maybe<OrganizationBudget>;
  spaceName: Scalars['String'];
  spaceType?: Maybe<SpaceType>;
  totalPrice: Scalars['Float'];
  totalPriceInUsd: Scalars['String'];
};

export type OrdersSummary = {
  __typename?: 'OrdersSummary';
  lastUpdatedDate: Scalars['String'];
  orders: Array<OrderSummary>;
};

export type Organization = {
  __typename?: 'Organization';
  bookingRequests?: Maybe<Array<BookingRequest>>;
  bookings: Array<Booking>;
  /** Budget for the current month */
  budget?: Maybe<OrganizationBudget>;
  connectionName?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  createdWith?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  /** If current user is only budget manager, this will always be a list of single budget */
  groupBudgets: Array<GroupBudget>;
  id: Scalars['ID'];
  invitations: Array<OrganizationInvitee>;
  logoUrl?: Maybe<Scalars['String']>;
  monthlyBilling: Scalars['Boolean'];
  mostBookedSpaces: Array<Space>;
  name: Scalars['String'];
  offices: Array<Office>;
  ordersSummary?: Maybe<OrdersSummary>;
  paymentMode: PaymentMode;
  plan: Plan;
  policies: Array<BudgetPolicy>;
  reporting?: Maybe<Reporting>;
  requireSSO: Scalars['Boolean'];
  slug?: Maybe<Scalars['String']>;
  ssoProvider: Array<Scalars['String']>;
  subscription: Scalars['Boolean'];
  users: Array<OrganizationUser>;
};


export type OrganizationBookingRequestsArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type OrganizationBookingsArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type OrganizationInvitationsArgs = {
  status?: InputMaybe<Scalars['String']>;
};


export type OrganizationOrdersSummaryArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type OrganizationReportingArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type OrganizationUsersArgs = {
  role?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
};

export type OrganizationBudget = {
  __typename?: 'OrganizationBudget';
  /** @deprecated old budget control, use limit instead */
  budget: Scalars['Float'];
  id: Scalars['ID'];
  individualLimit?: Maybe<Scalars['Float']>;
  limit: Scalars['Float'];
  policy?: Maybe<BudgetPolicy>;
  remaining: Scalars['Float'];
  spend: Scalars['Float'];
  state: OrganizationBudgetState;
  /** @deprecated old budget control, use spend instead */
  totalSpend: Scalars['Float'];
};

export enum OrganizationBudgetState {
  AboveWarningThreshold = 'AboveWarningThreshold',
  BelowWarningThreshold = 'BelowWarningThreshold'
}

export type OrganizationInvitee = {
  __typename?: 'OrganizationInvitee';
  acceptedAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  id: Scalars['String'];
  inviteeEmail?: Maybe<Scalars['String']>;
  inviterId?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  role: UserRole;
  status: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type OrganizationUser = {
  __typename?: 'OrganizationUser';
  bookingRequests?: Maybe<Array<BookingRequest>>;
  bookings: Array<Booking>;
  city?: Maybe<City>;
  /** @deprecated use flat fields instead */
  contactInfo?: Maybe<ContactInfo>;
  email?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  groupBudget?: Maybe<GroupBudget>;
  groupBudgetRole?: Maybe<GroupBudgetRole>;
  id: Scalars['String'];
  inviteId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  role: UserRole;
  status: UserStatus;
  title?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};


export type OrganizationUserBookingRequestsArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};


export type OrganizationUserBookingsArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type PaymentCustomer = {
  __typename?: 'PaymentCustomer';
  paymentCustomerID: Scalars['ID'];
};

export type PaymentDetail = {
  __typename?: 'PaymentDetail';
  billingDetails?: Maybe<BillingDetails>;
  id?: Maybe<Scalars['ID']>;
  paymentMethodDetails?: Maybe<CardPaymentMethod>;
  receiptUrl?: Maybe<Scalars['String']>;
};

export type PaymentMethod = CardPaymentMethod;

export enum PaymentMode {
  OnDemand = 'OnDemand',
  PayAsYouGo = 'PayAsYouGo',
  Subscription = 'Subscription'
}

export type Person = {
  __typename?: 'Person';
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type PhysicalSpace = {
  __typename?: 'PhysicalSpace';
  floor: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  space: Space;
  spaceID: Scalars['ID'];
  withWindow: Scalars['Boolean'];
};

export type Place = {
  __typename?: 'Place';
  country?: Maybe<Scalars['String']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  placeName: Scalars['String'];
};

export enum Plan {
  Pro = 'Pro',
  Starter = 'Starter'
}

export type PostAuthResult = {
  __typename?: 'PostAuthResult';
  acceptedInvite: Scalars['Boolean'];
  linked: Scalars['Boolean'];
  orgRegistered: Scalars['Boolean'];
};

export type PreMovingGroupBudgetPeopleInput = {
  /** Id of group which will receive people */
  groupBudgetId?: InputMaybe<Scalars['ID']>;
  /** The people ids of the organization users that are moved as managers to this group */
  managerIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The people ids of the organization users that are moved as members to this group */
  memberIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type PriceRangesType = {
  __typename?: 'PriceRangesType';
  daily: RangeType;
  hourly: RangeType;
};

export type Pricing = {
  __typename?: 'Pricing';
  price: Scalars['Float'];
  type: PricingType;
};

export enum PricingType {
  Daily = 'Daily',
  Hourly = 'Hourly'
}

export type PromotionLine = {
  __typename?: 'PromotionLine';
  amount: Scalars['Float'];
  code?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  discount: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  amenities: Array<Amenity>;
  budgetPolicy: BudgetPolicy;
  budgetPolicyAddresses: Array<BudgetPolicyAddress>;
  currentUser?: Maybe<CurrentUser>;
  discoverLocations: Array<Location>;
  discoverSpaces: Array<Space>;
  groupBudget?: Maybe<GroupBudget>;
  inviteByEmail?: Maybe<Invite>;
  ipPlace: Place;
  isEmailTaken: Scalars['Boolean'];
  locations: Array<Location>;
  markets?: Maybe<Market>;
  /** @deprecated this query has no use at all (confirmed) */
  officeSpace?: Maybe<OfficeSpace>;
  offsiteLocation?: Maybe<Location>;
  order?: Maybe<Order>;
  organizationByDomain?: Maybe<Organization>;
  organizationByInvite: Invite;
  organizationBySlug?: Maybe<Organization>;
  /** @deprecated Should use TODO currentUser.savedPaymentMethod field */
  paymentMethod?: Maybe<PaymentMethod>;
  person?: Maybe<Person>;
  popularLocations: Array<Location>;
  preMovingGroupBudgetPeopleMessage?: Maybe<Array<MovingPeopleMessage>>;
  promoCodeIsValid: Scalars['Boolean'];
  quote: Quote;
  space?: Maybe<Space>;
  spaces: SpaceConnection;
};


export type QueryAmenitiesArgs = {
  spaceType?: InputMaybe<SpaceType>;
};


export type QueryBudgetPolicyArgs = {
  id: Scalars['ID'];
};


export type QueryDiscoverLocationsArgs = {
  filter?: InputMaybe<DiscoverFilter>;
  spaceSearchCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  spaceType: SpaceType;
  spacesFilter?: InputMaybe<SpacesFilter>;
};


export type QueryDiscoverSpacesArgs = {
  filter?: InputMaybe<DiscoverFilter>;
  spaceSearchCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  spaceType: SpaceType;
  spacesFilter?: InputMaybe<SpacesFilter>;
};


export type QueryGroupBudgetArgs = {
  id: Scalars['ID'];
};


export type QueryInviteByEmailArgs = {
  inviteeEmail: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
};


export type QueryIsEmailTakenArgs = {
  email: Scalars['String'];
};


export type QueryLocationsArgs = {
  centerMapCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  currentUserCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  filter?: InputMaybe<LocationsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  radius?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<LocationsSort>;
};


export type QueryMarketsArgs = {
  country?: InputMaybe<Scalars['String']>;
};


export type QueryOfficeSpaceArgs = {
  id: Scalars['ID'];
};


export type QueryOffsiteLocationArgs = {
  id: Scalars['ID'];
};


export type QueryOrderArgs = {
  id: Scalars['ID'];
};


export type QueryOrganizationByDomainArgs = {
  domain: Scalars['String'];
};


export type QueryOrganizationByInviteArgs = {
  inviteId: Scalars['String'];
};


export type QueryOrganizationBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryPopularLocationsArgs = {
  centerMapCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  currentUserCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  limit?: InputMaybe<Scalars['Int']>;
  radius?: InputMaybe<Scalars['Int']>;
};


export type QueryPreMovingGroupBudgetPeopleMessageArgs = {
  input: PreMovingGroupBudgetPeopleInput;
};


export type QueryPromoCodeIsValidArgs = {
  code: Scalars['String'];
  endDate: Scalars['String'];
  offsiteSpaceID: Scalars['ID'];
  startDate: Scalars['String'];
};


export type QueryQuoteArgs = {
  input: QuoteInput;
};


export type QuerySpaceArgs = {
  id: Scalars['ID'];
};


export type QuerySpacesArgs = {
  centerMapCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  currentUserCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  filter?: InputMaybe<SpacesFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  radius?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SpacesSort>;
  spaceType: SpaceType;
};

export type Quote = {
  __typename?: 'Quote';
  bookingRequestId?: Maybe<Scalars['String']>;
  /** Each tier with the instant it closes for the earliest booking on this quote. Null when partners serves none (e.g. a recurring quote). */
  cancellationFeeTiers?: Maybe<Array<CancellationFeeTier>>;
  orderItems: Array<OrderItem>;
  outOfPolicyMessage?: Maybe<Scalars['String']>;
  processingFee: Scalars['Float'];
  promotionLine?: Maybe<PromotionLine>;
  quoteId?: Maybe<Scalars['ID']>;
  quoteItems?: Maybe<Array<QuoteItem>>;
  subTotal: Scalars['Float'];
  taxLine?: Maybe<TaxLine>;
  totalPrice: Scalars['Float'];
};

export type QuoteInput = {
  bookingRequestId?: InputMaybe<Scalars['ID']>;
  orderItems: Array<OrderItemInput>;
  partnerId?: InputMaybe<Scalars['String']>;
  promoCode?: InputMaybe<Scalars['String']>;
  quoteId?: InputMaybe<Scalars['ID']>;
  subSource?: InputMaybe<OrderSubSource>;
};

export type QuoteItem = {
  __typename?: 'QuoteItem';
  dynamicPriceRate?: Maybe<DynamicPriceRate>;
  originalTotalPrice: Scalars['Float'];
  quoteId: Scalars['ID'];
  quoteItemPrices?: Maybe<Array<QuoteItemPrice>>;
  totalPrice: Scalars['Float'];
  unitPrice: Scalars['Float'];
};

export type QuoteItemPrice = {
  __typename?: 'QuoteItemPrice';
  dynamicPriceRate?: Maybe<DynamicPriceRate>;
  endDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  originalUnitPrice: Scalars['Float'];
  quoteItemId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['String']>;
  unitCount: Scalars['Float'];
  unitPrice: Scalars['Float'];
  unitType: Scalars['String'];
};

export type RangeType = {
  __typename?: 'RangeType';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type ReactivateGroupBudgetInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  individualLimit?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
  /** The people ids of the organization users that are managers of this group */
  managerIds: Array<Scalars['ID']>;
  /** The people ids of the organization users that are members of this group */
  memberIds: Array<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  policyId?: InputMaybe<Scalars['ID']>;
};

export type RegisteredOrganizationUser = {
  __typename?: 'RegisteredOrganizationUser';
  hasUserAccountLinked: Scalars['Boolean'];
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type RemoveFavoriteResourceInput = {
  resourceId: Scalars['ID'];
};

export type Reporting = {
  __typename?: 'Reporting';
  bookings: ReportingBookings;
  engagement: ReportingEngagement;
  frequency: ReportingFrequency;
  lastUpdatedDate: Scalars['String'];
  spend: ReportingSpend;
};

export type ReportingBookings = {
  __typename?: 'ReportingBookings';
  dayOffices: ReportingValue;
  dayPasses: ReportingValue;
  meetingRooms: ReportingValue;
  totalBookings: Scalars['Float'];
};

export type ReportingEngagement = {
  __typename?: 'ReportingEngagement';
  soloBookings: ReportingEngagementWeekBookings;
  teamBookings: ReportingEngagementWeekBookings;
};

export type ReportingEngagementWeekBookings = {
  __typename?: 'ReportingEngagementWeekBookings';
  friday: Scalars['Int'];
  monday: Scalars['Int'];
  saturday: Scalars['Int'];
  sunday: Scalars['Int'];
  thursday: Scalars['Int'];
  tuesday: Scalars['Int'];
  wednesday: Scalars['Int'];
};

export type ReportingFrequency = {
  __typename?: 'ReportingFrequency';
  fourOrMoreBookingsPerWeek: ReportingValue;
  totalEmployees: Scalars['Float'];
  twoOrThreeBookingsPerWeek: ReportingValue;
  zeroOrSingleBookingPerWeek: ReportingValue;
};

export type ReportingSpend = {
  __typename?: 'ReportingSpend';
  dayOffices: ReportingValue;
  dayPasses: ReportingValue;
  meetingRooms: ReportingValue;
  totalSpend: Scalars['Float'];
};

export type ReportingValue = {
  __typename?: 'ReportingValue';
  percentage: Scalars['Float'];
  value: Scalars['Float'];
};

export type RequestBudgetIncreaseInput = {
  note?: InputMaybe<Scalars['String']>;
};

export type SetupPaymentMethodUpdate = {
  __typename?: 'SetupPaymentMethodUpdate';
  customerID: Scalars['ID'];
  stripeClientSecret: Scalars['String'];
};

export type Space = {
  __typename?: 'Space';
  active: Scalars['Boolean'];
  amenities: Array<Amenity>;
  area?: Maybe<Scalars['Int']>;
  availableDays: Array<AvailableDay>;
  availableTimeSlots: Array<AvailableTimeSlot>;
  bestDayRates: Array<BestDayRates>;
  betterHourRates: BetterHourRates;
  bookingConfig: BookingConfig;
  bookingHours: Array<BookingHour>;
  bookingPolicy: SpaceBookingPolicy;
  bookingRequests?: Maybe<Array<BookingRequest>>;
  categories: Array<Category>;
  city: Scalars['String'];
  country: Scalars['String'];
  currency: Scalars['String'];
  defaultLayoutID: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images: Array<Image>;
  inventoryCapacity: Scalars['Int'];
  layouts: Array<SpaceLayout>;
  location: Location;
  locationID: Scalars['ID'];
  locationName: Scalars['String'];
  locationTimeZone: Scalars['String'];
  locked: Scalars['Boolean'];
  maxCapacity: Scalars['Int'];
  name: Scalars['String'];
  numberOfVisitsByCurrentUser: Scalars['Int'];
  partnerID?: Maybe<Scalars['String']>;
  physicalSpaces: Array<PhysicalSpace>;
  physicalSpacesCount: Scalars['Int'];
  preferred?: Maybe<Scalars['Boolean']>;
  priceRanges: PriceRangesType;
  pricings: Array<Pricing>;
  savedByCurrentUser: Scalars['Boolean'];
  spacePerks: Array<SpacePerk>;
  spaceType: SpaceType;
  streetAddress: Scalars['String'];
  withWindow: Scalars['Boolean'];
};


export type SpaceAmenitiesArgs = {
  mapNavigationFeatureFlag?: InputMaybe<Scalars['Boolean']>;
};


export type SpaceAvailableDaysArgs = {
  input?: InputMaybe<SpaceAvailableDaysInput>;
};


export type SpaceAvailableTimeSlotsArgs = {
  input?: InputMaybe<SpaceAvailableTimeSlotsInput>;
};


export type SpaceBestDayRatesArgs = {
  input?: InputMaybe<SpaceBestDayRatesInput>;
};


export type SpaceBetterHourRatesArgs = {
  input?: InputMaybe<SpaceBetterHourRatesInput>;
};


export type SpacePhysicalSpacesArgs = {
  first?: InputMaybe<Scalars['Int']>;
};

export type SpaceAvailableDaysInput = {
  endDate: Scalars['String'];
  physicalSpaceID?: InputMaybe<Scalars['String']>;
  startDate: Scalars['String'];
};

export type SpaceAvailableTimeSlotsInput = {
  date: Scalars['String'];
  physicalSpaceID?: InputMaybe<Scalars['String']>;
};

export type SpaceBestDayRatesInput = {
  bookingType?: InputMaybe<BookingType>;
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type SpaceBetterHourRatesInput = {
  date: Scalars['String'];
  endTime?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Float']>;
};

export type SpaceBookingPolicy = {
  __typename?: 'SpaceBookingPolicy';
  cancellationDays?: Maybe<Scalars['Int']>;
  cancellationHours?: Maybe<Scalars['Int']>;
  cancellationTime1DayBefore?: Maybe<Scalars['String']>;
  minDuration?: Maybe<Scalars['Float']>;
};

export type SpaceConnection = {
  __typename?: 'SpaceConnection';
  data: Array<Space>;
  totalCount: Scalars['Int'];
};

export type SpaceLayout = {
  __typename?: 'SpaceLayout';
  bestFor?: Maybe<Scalars['String']>;
  capacity: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['ID'];
  imageURL: Scalars['String'];
  name: Scalars['String'];
};

export type SpacePerk = {
  __typename?: 'SpacePerk';
  code: Scalars['ID'];
  description: Scalars['String'];
  iconURL: Scalars['String'];
  name: Scalars['String'];
};

export type SpaceSearchCoordinates = {
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
};

export enum SpaceType {
  DayOffice = 'DayOffice',
  DayPass = 'DayPass',
  MeetingRoom = 'MeetingRoom'
}

export type SpaceTypes = {
  __typename?: 'SpaceTypes';
  dayPass: Scalars['Boolean'];
  meetingRoom: Scalars['Boolean'];
  privateOffice: Scalars['Boolean'];
};

export type SpaceTypesInput = {
  dayPass: Scalars['Boolean'];
  meetingRoom: Scalars['Boolean'];
  privateOffice: Scalars['Boolean'];
};

export type SpacesFilter = {
  amenities?: InputMaybe<Array<Scalars['String']>>;
  date?: InputMaybe<Scalars['String']>;
  /** not applicable for day offices */
  endTime?: InputMaybe<Scalars['String']>;
  maxCapacity?: InputMaybe<Scalars['Int']>;
  minCapacity?: InputMaybe<Scalars['Int']>;
  partialMatch?: InputMaybe<Scalars['Boolean']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  /** not applicable for day offices */
  startTime?: InputMaybe<Scalars['String']>;
};

export enum SpacesSort {
  Distance = 'Distance',
  PriceAsc = 'PriceAsc',
  PriceDesc = 'PriceDesc'
}

export type TaxLine = {
  __typename?: 'TaxLine';
  amount: Scalars['Float'];
  description: Scalars['String'];
  percentage: Scalars['Float'];
};

export type UpdateBookingRequestInput = {
  id: Scalars['String'];
  reason: Scalars['String'];
};

export type UpdateBookingRequestStatusInput = {
  id: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
};

export type UpdateBudgetPolicyInput = {
  applyToBudgetIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id: Scalars['ID'];
  isAppliedToNewBudget?: InputMaybe<Scalars['Boolean']>;
  locationItems?: InputMaybe<Array<InputMaybe<BudgetPolicyLocationItemUpdateInput>>>;
  name?: InputMaybe<Scalars['String']>;
  spaceTypes?: InputMaybe<SpaceTypesInput>;
};

export type UpdateGroupBudgetInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  individualLimit?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
  /** The people ids of the organization users that are managers of this group */
  managerIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The people ids of the organization users that are members of this group */
  memberIds?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  policyId?: InputMaybe<Scalars['ID']>;
};

export type UpdateOrganizationBudgetInput = {
  individualLimit?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Float']>;
  policyId?: InputMaybe<Scalars['ID']>;
};

export type UpdateOrganizationInput = {
  organizationName?: InputMaybe<Scalars['String']>;
  sso?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOrganizationNameInput = {
  organizationName: Scalars['String'];
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  paymentCustomerID?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UserPromotion = {
  __typename?: 'UserPromotion';
  description: Scalars['String'];
  id: Scalars['ID'];
  longDescription: Scalars['String'];
  ordersUsed: Scalars['Int'];
  promotionCode: Scalars['String'];
  promotionKind: Scalars['String'];
  userID: Scalars['ID'];
};

export enum UserRole {
  Admin = 'Admin',
  Member = 'Member'
}

export enum UserStatus {
  Active = 'Active',
  Pending = 'Pending'
}

export type UserToInvite = {
  email: Scalars['String'];
  isAdmin: Scalars['Boolean'];
};

export type AppHeaderV3DesktopQueryVariables = Exact<{ [key: string]: never; }>;


export type AppHeaderV3DesktopQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, role: UserRole, picture: string, fullName: string, groupBudgetRole?: GroupBudgetRole | null, groupBudget?: { __typename?: 'GroupBudget', id: string, name: string } | null, organization?: { __typename?: 'Organization', id: string, paymentMode: PaymentMode, plan: Plan } | null } | null };

export type UserSpacePolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSpacePolicyQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', budget?: { __typename?: 'OrganizationBudget', policy?: { __typename?: 'BudgetPolicy', spaceTypes: { __typename?: 'SpaceTypes', meetingRoom: boolean, dayPass: boolean, privateOffice: boolean } } | null } | null } | null, groupBudget?: { __typename?: 'GroupBudget', policy?: { __typename?: 'BudgetPolicy', spaceTypes: { __typename?: 'SpaceTypes', meetingRoom: boolean, dayPass: boolean, privateOffice: boolean } } | null } | null } | null };

export type InviteToTeamInAppMutationVariables = Exact<{
  input: InviteToTeamInput;
}>;


export type InviteToTeamInAppMutation = { __typename?: 'Mutation', inviteToTeam: boolean };

export type InAppInviteCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type InAppInviteCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', role: UserRole, organization?: { __typename?: 'Organization', id: string, name: string } | null } | null };

export type SidebarQueryVariables = Exact<{ [key: string]: never; }>;


export type SidebarQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, role: UserRole, organization?: { __typename?: 'Organization', id: string, name: string } | null } | null };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', createdAt: string, createdWith?: string | null } };

export type UserDomainQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDomainQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', email?: string | null } | null };

export type CurrentUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserInfoQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, hasBookedBefore: boolean, hasSignedUpWithSocialProvider: boolean, fullName: string, email?: string | null, phoneNumber?: string | null, organization?: { __typename?: 'Organization', id: string, name: string, plan: Plan } | null } | null };

export type BetterHourRatesQueryVariables = Exact<{
  spaceId: Scalars['ID'];
  date: Scalars['String'];
  startTime?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Float']>;
}>;


export type BetterHourRatesQuery = { __typename?: 'Query', space?: { __typename?: 'Space', betterHourRates: { __typename?: 'BetterHourRates', currentUnitPrice: number, options: Array<{ __typename?: 'BetterHourRateOption', minBookingUnit?: string | null, unitPrice: number, startTime?: string | null, endTime?: string | null }> } } | null };

export type UpdateOrderMemoMutationVariables = Exact<{
  orderID: Scalars['ID'];
  memo?: InputMaybe<Scalars['String']>;
}>;


export type UpdateOrderMemoMutation = { __typename?: 'Mutation', updateOrderMemo: boolean };

export type SpaceAvailableDaysQueryVariables = Exact<{
  id: Scalars['ID'];
  input: SpaceAvailableDaysInput;
}>;


export type SpaceAvailableDaysQuery = { __typename?: 'Query', space?: { __typename?: 'Space', id: string, availableDays: Array<{ __typename?: 'AvailableDay', date: string, openAt: string, closedAt: string, availableFullDay: boolean }> } | null };

export type SpaceAvailableTimeSlotsQueryVariables = Exact<{
  id: Scalars['ID'];
  input: SpaceAvailableTimeSlotsInput;
}>;


export type SpaceAvailableTimeSlotsQuery = { __typename?: 'Query', space?: { __typename?: 'Space', id: string, availableTimeSlots: Array<{ __typename?: 'AvailableTimeSlot', startTime: string, endTimes: Array<string> }> } | null };

export type BookingUtilsOrderDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BookingUtilsOrderDetailsQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, totalPrice: number, currency: string, status: OrderStatus, memo?: string | null, guest?: { __typename?: 'ContactInfo', fullName: string, companyName?: string | null, email?: string | null, phoneNumber?: string | null } | null, orderItems: Array<{ __typename?: 'OrderItem', id: string, details: { __typename: 'DailyBooking', startDate: string, endDate: string, time: string, space: { __typename?: 'Space', id: string, locationName: string, name: string, city: string, country: string } } | { __typename: 'HourlyBooking', date: string, startTime: string, endTime: string, space: { __typename?: 'Space', id: string, locationName: string, name: string, city: string, country: string } } }> } | null };

export type CheckoutMutationVariables = Exact<{
  input: CheckoutInput;
}>;


export type CheckoutMutation = { __typename?: 'Mutation', checkout: { __typename?: 'Order', id: string, stripeClientSecret?: string | null, totalPrice: number } };

export type BookingUpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type BookingUpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'CurrentUser', id: string, hasBookedBefore: boolean, fullName: string, email?: string | null, phoneNumber?: string | null } | null };

export type SpaceCheckoutCurrentUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type SpaceCheckoutCurrentUserInfoQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, hasBookedBefore: boolean, hasSignedUpWithSocialProvider: boolean, fullName: string, email?: string | null, phoneNumber?: string | null, organization?: { __typename?: 'Organization', id: string, name: string } | null } | null };

export type SpaceCheckoutSpaceInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SpaceCheckoutSpaceInfoQuery = { __typename?: 'Query', space?: { __typename?: 'Space', id: string, partnerID?: string | null, maxCapacity: number } | null };

export type BottomBarAdminNavigationQueryVariables = Exact<{ [key: string]: never; }>;


export type BottomBarAdminNavigationQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, organization?: { __typename?: 'Organization', id: string, plan: Plan } | null } | null };

export type UserAvatarQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAvatarQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, picture: string, fullName: string } | null };

export type DetachPaymentMethodMutationVariables = Exact<{
  input: DetachPaymentMethodInput;
}>;


export type DetachPaymentMethodMutation = { __typename?: 'Mutation', detachPaymentMethod: { __typename?: 'DetachPaymentMethod', status?: string | null } };

export type SetupPaymentMethodUpdateMutationVariables = Exact<{ [key: string]: never; }>;


export type SetupPaymentMethodUpdateMutation = { __typename?: 'Mutation', setupPaymentMethodUpdate: { __typename?: 'SetupPaymentMethodUpdate', customerID: string, stripeClientSecret: string } };

export type BookingPaymentMethodQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingPaymentMethodQuery = { __typename?: 'Query', paymentMethod?: { __typename?: 'CardPaymentMethod', id?: string | null, last4: string, network: string, networkLogoUrl: string } | null };

export type CheckOutPaymentDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckOutPaymentDetailsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, fullName: string } | null };

export type OffsiteLocationWhosHereQueryVariables = Exact<{
  offsiteLocationID: Scalars['ID'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type OffsiteLocationWhosHereQuery = { __typename?: 'Query', offsiteLocation?: { __typename?: 'Location', id: string, bookings: Array<{ __typename?: 'Booking', id: string, startDate: string, endDate: string, user: { __typename?: 'OrganizationUser', id: string, fullName: string, title?: string | null, picture?: string | null } }> } | null };

export type OffsiteLocationWhosHere__BookingDetailsFragment = { __typename?: 'Booking', id: string, startDate: string, endDate: string, user: { __typename?: 'OrganizationUser', id: string, fullName: string, title?: string | null, picture?: string | null } };

export type OffsiteDetailsWhosHereQueryVariables = Exact<{ [key: string]: never; }>;


export type OffsiteDetailsWhosHereQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string } | null };

export type BookingRequestsAdminStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingRequestsAdminStatusesQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, organization?: { __typename?: 'Organization', id: string, bookingRequests?: Array<{ __typename?: 'BookingRequest', id: string, status: BookingRequestStatus }> | null } | null } | null };

export type BookingRequestsManagerStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingRequestsManagerStatusesQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, groupBudget?: { __typename?: 'GroupBudget', id: string, bookingRequests?: Array<{ __typename?: 'BookingRequest', id: string, status: BookingRequestStatus }> | null } | null } | null };

export type PromoCodeIsValidQueryVariables = Exact<{
  code: Scalars['String'];
  offsiteSpaceID: Scalars['ID'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type PromoCodeIsValidQuery = { __typename?: 'Query', promoCodeIsValid: boolean };

export type CancellationFeeTier__DetailsFragment = { __typename?: 'CancellationFeeTier', refundPercentage: number, cancellationAllowedBefore?: string | null };

export type QuoteDetailsQueryVariables = Exact<{
  input: QuoteInput;
}>;


export type QuoteDetailsQuery = { __typename?: 'Query', quote: { __typename?: 'Quote', quoteId?: string | null, totalPrice: number, subTotal: number, processingFee: number, outOfPolicyMessage?: string | null, promotionLine?: { __typename?: 'PromotionLine', amount: number, description: string, code?: string | null, discount: number } | null, taxLine?: { __typename?: 'TaxLine', amount: number, description: string, percentage: number } | null, orderItems: Array<{ __typename?: 'OrderItem', id: string, totalPrice: number, subTotal: number, unitPrice: number, quantity: number, details: { __typename: 'DailyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, startDate: string, endDate: string, days: number, time: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType }, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null } | { __typename: 'HourlyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, date: string, startTime: string, endTime: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType }, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null } }>, cancellationFeeTiers?: Array<{ __typename?: 'CancellationFeeTier', refundPercentage: number, cancellationAllowedBefore?: string | null }> | null, quoteItems?: Array<{ __typename?: 'QuoteItem', quoteId: string, unitPrice: number, totalPrice: number, originalTotalPrice: number, quoteItemPrices?: Array<{ __typename?: 'QuoteItemPrice', quoteItemId?: string | null, unitPrice: number, unitCount: number, unitType: string, originalUnitPrice: number, startDate?: string | null, endDate?: string | null, dynamicPriceRate?: { __typename?: 'DynamicPriceRate', id?: string | null } | null }> | null, dynamicPriceRate?: { __typename?: 'DynamicPriceRate', id?: string | null } | null }> | null } };

export type QuoteDetail__OrderItemFragment = { __typename?: 'OrderItem', id: string, totalPrice: number, subTotal: number, unitPrice: number, quantity: number, details: { __typename: 'DailyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, startDate: string, endDate: string, days: number, time: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType }, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null } | { __typename: 'HourlyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, date: string, startTime: string, endTime: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType }, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null } };

export type QuoteDetails__HourlyBookingDetailsFragment = { __typename?: 'HourlyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, date: string, startTime: string, endTime: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType }, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null };

export type QuoteDetails__DailyBookingDetailsFragment = { __typename?: 'DailyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, startDate: string, endDate: string, days: number, time: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType }, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null };

export type SpaceDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SpaceDetailsQuery = { __typename?: 'Query', space?: { __typename?: 'Space', id: string, partnerID?: string | null, name: string, spaceType: SpaceType, description?: string | null, currency: string, defaultLayoutID: string, savedByCurrentUser: boolean, inventoryCapacity: number, area?: number | null, maxCapacity: number, locationID: string, locationTimeZone: string, bookingConfig: { __typename?: 'BookingConfig', enabled: Array<BookingType>, multiDayBookingAllowed: boolean }, categories: Array<{ __typename?: 'Category', code: string, name: string, description: string }>, location: { __typename?: 'Location', id: string, name: string, timezone: string, pricingInclusion?: string | null, directions?: string | null, logo?: { __typename?: 'ImageData', url: string } | null, address: { __typename?: 'Address', fullAddress: string, streetAddress: string, postalCode: string, country: string, city: string, state: string, latitude?: number | null, longitude?: number | null } }, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, layouts: Array<{ __typename?: 'SpaceLayout', id: string, name: string, description: string, bestFor?: string | null, capacity: number, imageURL: string }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, bookingHours: Array<{ __typename?: 'BookingHour', dayOfWeek: DayOfWeek, closedAt: string, openAt: string }>, bookingPolicy: { __typename?: 'SpaceBookingPolicy', minDuration?: number | null }, spacePerks: Array<{ __typename?: 'SpacePerk', code: string, name: string, description: string, iconURL: string }> } | null };

export type SpaceDetails__AllDetailsFragment = { __typename?: 'Space', id: string, partnerID?: string | null, name: string, spaceType: SpaceType, description?: string | null, currency: string, defaultLayoutID: string, savedByCurrentUser: boolean, inventoryCapacity: number, area?: number | null, maxCapacity: number, locationID: string, locationTimeZone: string, bookingConfig: { __typename?: 'BookingConfig', enabled: Array<BookingType>, multiDayBookingAllowed: boolean }, categories: Array<{ __typename?: 'Category', code: string, name: string, description: string }>, location: { __typename?: 'Location', id: string, name: string, timezone: string, pricingInclusion?: string | null, directions?: string | null, logo?: { __typename?: 'ImageData', url: string } | null, address: { __typename?: 'Address', fullAddress: string, streetAddress: string, postalCode: string, country: string, city: string, state: string, latitude?: number | null, longitude?: number | null } }, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, layouts: Array<{ __typename?: 'SpaceLayout', id: string, name: string, description: string, bestFor?: string | null, capacity: number, imageURL: string }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, bookingHours: Array<{ __typename?: 'BookingHour', dayOfWeek: DayOfWeek, closedAt: string, openAt: string }>, bookingPolicy: { __typename?: 'SpaceBookingPolicy', minDuration?: number | null }, spacePerks: Array<{ __typename?: 'SpacePerk', code: string, name: string, description: string, iconURL: string }> };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, role: UserRole, fullName: string, email?: string | null, phoneNumber?: string | null, title?: string | null, auth0PrimaryEmail: string, auth0PrimaryEmailVerified: boolean, paymentCustomerID?: string | null, picture: string, hasSignedUpWithSocialProvider: boolean, hasBookedBefore: boolean, createdWith: string, promotions: Array<{ __typename?: 'UserPromotion', id: string, promotionCode: string, promotionKind: string, description: string, longDescription: string }>, organization?: { __typename?: 'Organization', id: string, name: string, domain?: string | null, monthlyBilling: boolean, createdAt: string, paymentMode: PaymentMode, createdWith?: string | null } | null } | null };

export type CurrentUser__MainDetailsFragment = { __typename?: 'CurrentUser', id: string, role: UserRole, fullName: string, email?: string | null, phoneNumber?: string | null, title?: string | null, auth0PrimaryEmail: string, auth0PrimaryEmailVerified: boolean, paymentCustomerID?: string | null, picture: string, hasSignedUpWithSocialProvider: boolean, hasBookedBefore: boolean, createdWith: string };

export type CurrentUser__PromotionsFragment = { __typename?: 'CurrentUser', promotions: Array<{ __typename?: 'UserPromotion', id: string, promotionCode: string, promotionKind: string, description: string, longDescription: string }> };

export type CurrentUser__OrganizationFragment = { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', id: string, name: string, domain?: string | null, monthlyBilling: boolean, createdAt: string, paymentMode: PaymentMode, createdWith?: string | null } | null };

export type PersonQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: string, userId: string, organizationId: string } | null };

export type SideBarQueryVariables = Exact<{ [key: string]: never; }>;


export type SideBarQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, role: UserRole, fullName: string, email?: string | null, phoneNumber?: string | null, picture: string, organization?: { __typename?: 'Organization', id: string } | null } | null };

export type SendInvitesMutationVariables = Exact<{
  orderID: Scalars['ID'];
  input: InvitesInput;
}>;


export type SendInvitesMutation = { __typename?: 'Mutation', sendInvites: { __typename?: 'OrderInvites', id: string, message: string, recipients: Array<{ __typename?: 'InviteRecipient', name: string, email: string, phoneNumber?: string | null }> } };

export type HookUserRoleQueryVariables = Exact<{ [key: string]: never; }>;


export type HookUserRoleQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', role: UserRole, groupBudgetRole?: GroupBudgetRole | null } | null };

export type OrganizationByInviteQueryQueryVariables = Exact<{
  inviteId: Scalars['String'];
}>;


export type OrganizationByInviteQueryQuery = { __typename?: 'Query', organizationByInvite: { __typename?: 'Invite', id: string, inviteeEmail?: string | null, status: string, organization?: { __typename?: 'Organization', name: string, domain?: string | null, requireSSO: boolean, ssoProvider: Array<string>, logoUrl?: string | null, slug?: string | null, users: Array<{ __typename?: 'OrganizationUser', userId?: string | null, id: string, role: UserRole, picture?: string | null, fullName: string, email?: string | null }> } | null } };

export type AcceptInviteCodeVerifiedQueryVariables = Exact<{ [key: string]: never; }>;


export type AcceptInviteCodeVerifiedQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string } | null };

export type LinkEmailAccountToPasswordAccountIfExistsMutationVariables = Exact<{ [key: string]: never; }>;


export type LinkEmailAccountToPasswordAccountIfExistsMutation = { __typename?: 'Mutation', linkEmailAccountToPasswordAccountIfExists: boolean };

export type CurrentUserStepCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserStepCodeQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, organization?: { __typename?: 'Organization', id: string } | null } | null };

export type AcceptInviteMutationVariables = Exact<{
  inviteID: Scalars['String'];
}>;


export type AcceptInviteMutation = { __typename?: 'Mutation', acceptInvite: boolean };

export type UserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInfoQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', fullName: string, email?: string | null, phoneNumber?: string | null, city?: { __typename?: 'City', displayName?: string | null } | null } | null };

export type BookingDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BookingDetailsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', monthlyBilling: boolean } | null } | null, order?: { __typename?: 'Order', id: string, totalPrice: number, subTotal: number, processingFee: number, confirmationID?: string | null, memo?: string | null, status: OrderStatus, cancellable: boolean, currency: string, taxLine?: { __typename?: 'TaxLine', amount: number, description: string, percentage: number } | null, promotionLine?: { __typename?: 'PromotionLine', amount: number, description: string, discount: number, code?: string | null } | null, invitees: Array<{ __typename?: 'InviteRecipient', name: string, email: string }>, paymentDetail?: { __typename?: 'PaymentDetail', id?: string | null, receiptUrl?: string | null, paymentMethodDetails?: { __typename?: 'CardPaymentMethod', last4: string, network: string, networkLogoUrl: string } | null, billingDetails?: { __typename?: 'BillingDetails', name: string, email?: string | null, phone?: string | null, address: { __typename?: 'CardAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null } } | null } | null, orderItems: Array<{ __typename?: 'OrderItem', id: string, totalPrice: number, subTotal: number, unitPrice: number, quantity: number, details: { __typename: 'DailyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, startDate: string, endDate: string, days: number, time: string, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null, space: { __typename?: 'Space', id: string, name: string, partnerID?: string | null, spaceType: SpaceType, description?: string | null, preferred?: boolean | null, maxCapacity: number, location: { __typename?: 'Location', name: string, directions?: string | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', fullAddress: string, latitude?: number | null, longitude?: number | null } }, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, bookingHours: Array<{ __typename?: 'BookingHour', dayOfWeek: DayOfWeek, closedAt: string, openAt: string }> } } | { __typename: 'HourlyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, date: string, startTime: string, endTime: string, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null, space: { __typename?: 'Space', id: string, name: string, partnerID?: string | null, spaceType: SpaceType, description?: string | null, preferred?: boolean | null, maxCapacity: number, location: { __typename?: 'Location', name: string, directions?: string | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', fullAddress: string, latitude?: number | null, longitude?: number | null } }, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, bookingHours: Array<{ __typename?: 'BookingHour', dayOfWeek: DayOfWeek, closedAt: string, openAt: string }> } } }> } | null };

export type BookingDetails__OrderItemDetailsFragment = { __typename?: 'OrderItem', id: string, totalPrice: number, subTotal: number, unitPrice: number, quantity: number, details: { __typename: 'DailyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, startDate: string, endDate: string, days: number, time: string, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null, space: { __typename?: 'Space', id: string, name: string, partnerID?: string | null, spaceType: SpaceType, description?: string | null, preferred?: boolean | null, maxCapacity: number, location: { __typename?: 'Location', name: string, directions?: string | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', fullAddress: string, latitude?: number | null, longitude?: number | null } }, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, bookingHours: Array<{ __typename?: 'BookingHour', dayOfWeek: DayOfWeek, closedAt: string, openAt: string }> } } | { __typename: 'HourlyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, date: string, startTime: string, endTime: string, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null, space: { __typename?: 'Space', id: string, name: string, partnerID?: string | null, spaceType: SpaceType, description?: string | null, preferred?: boolean | null, maxCapacity: number, location: { __typename?: 'Location', name: string, directions?: string | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', fullAddress: string, latitude?: number | null, longitude?: number | null } }, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, bookingHours: Array<{ __typename?: 'BookingHour', dayOfWeek: DayOfWeek, closedAt: string, openAt: string }> } } };

export type BookingDetails__HourlyBookingDetailsFragment = { __typename?: 'HourlyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, date: string, startTime: string, endTime: string, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null, space: { __typename?: 'Space', id: string, name: string, partnerID?: string | null, spaceType: SpaceType, description?: string | null, preferred?: boolean | null, maxCapacity: number, location: { __typename?: 'Location', name: string, directions?: string | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', fullAddress: string, latitude?: number | null, longitude?: number | null } }, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, bookingHours: Array<{ __typename?: 'BookingHour', dayOfWeek: DayOfWeek, closedAt: string, openAt: string }> } };

export type BookingDetails__DailyBookingDetailsFragment = { __typename?: 'DailyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, startDate: string, endDate: string, days: number, time: string, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null, space: { __typename?: 'Space', id: string, name: string, partnerID?: string | null, spaceType: SpaceType, description?: string | null, preferred?: boolean | null, maxCapacity: number, location: { __typename?: 'Location', name: string, directions?: string | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', fullAddress: string, latitude?: number | null, longitude?: number | null } }, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, bookingHours: Array<{ __typename?: 'BookingHour', dayOfWeek: DayOfWeek, closedAt: string, openAt: string }> } };

export type BookingDetails_SpaceDetailsFragment = { __typename?: 'Space', id: string, name: string, partnerID?: string | null, spaceType: SpaceType, description?: string | null, preferred?: boolean | null, maxCapacity: number, location: { __typename?: 'Location', name: string, directions?: string | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', fullAddress: string, latitude?: number | null, longitude?: number | null } }, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, bookingHours: Array<{ __typename?: 'BookingHour', dayOfWeek: DayOfWeek, closedAt: string, openAt: string }> };

export type CancelBookingMutationVariables = Exact<{
  orderID: Scalars['ID'];
}>;


export type CancelBookingMutation = { __typename?: 'Mutation', cancelOrder: boolean };

export type ApproveBookingRequestMutationVariables = Exact<{
  input: UpdateBookingRequestStatusInput;
}>;


export type ApproveBookingRequestMutation = { __typename?: 'Mutation', approveBookingRequest: { __typename?: 'BookingRequest', id: string } };

export type DeclineBookingRequestMutationVariables = Exact<{
  input: UpdateBookingRequestStatusInput;
}>;


export type DeclineBookingRequestMutation = { __typename?: 'Mutation', declineBookingRequest: { __typename?: 'BookingRequest', id: string } };

export type BookingRequests__RequestDetailsFragment = { __typename?: 'BookingRequest', id: string, amount?: number | null, currency?: string | null, createdAt: string, bookedAt?: string | null, startDate: string, status: BookingRequestStatus, reason: string, reviewerNote?: string | null, reviewedAt?: string | null, requesterTotalSpend: number, requester: { __typename?: 'OrganizationUser', id: string, fullName: string, bookingRequests?: Array<{ __typename?: 'BookingRequest', status: BookingRequestStatus }> | null, groupBudget?: { __typename?: 'GroupBudget', id: string, limit: number, individualLimit?: number | null } | null }, reviewer?: { __typename?: 'OrganizationUser', fullName: string } | null, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, location: { __typename?: 'Location', name: string } }, groupBudget?: { __typename?: 'GroupBudget', name: string, id: string } | null, organizationBudget?: { __typename?: 'OrganizationBudget', id: string } | null };

export type BookingRequestsQueryVariables = Exact<{
  requesterStartDate?: InputMaybe<Scalars['String']>;
  requesterEndDate?: InputMaybe<Scalars['String']>;
}>;


export type BookingRequestsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, role: UserRole, organization?: { __typename?: 'Organization', id: string, name: string, budget?: { __typename?: 'OrganizationBudget', limit: number, individualLimit?: number | null } | null, bookingRequests?: Array<{ __typename?: 'BookingRequest', id: string, amount?: number | null, currency?: string | null, createdAt: string, bookedAt?: string | null, startDate: string, status: BookingRequestStatus, reason: string, reviewerNote?: string | null, reviewedAt?: string | null, requesterTotalSpend: number, requester: { __typename?: 'OrganizationUser', id: string, fullName: string, bookingRequests?: Array<{ __typename?: 'BookingRequest', status: BookingRequestStatus }> | null, groupBudget?: { __typename?: 'GroupBudget', id: string, limit: number, individualLimit?: number | null } | null }, reviewer?: { __typename?: 'OrganizationUser', fullName: string } | null, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, location: { __typename?: 'Location', name: string } }, groupBudget?: { __typename?: 'GroupBudget', name: string, id: string } | null, organizationBudget?: { __typename?: 'OrganizationBudget', id: string } | null }> | null } | null } | null };

export type BookingRequests__CurrentUserFragment = { __typename?: 'CurrentUser', id: string, role: UserRole, organization?: { __typename?: 'Organization', id: string, name: string, budget?: { __typename?: 'OrganizationBudget', limit: number, individualLimit?: number | null } | null, bookingRequests?: Array<{ __typename?: 'BookingRequest', id: string, amount?: number | null, currency?: string | null, createdAt: string, bookedAt?: string | null, startDate: string, status: BookingRequestStatus, reason: string, reviewerNote?: string | null, reviewedAt?: string | null, requesterTotalSpend: number, requester: { __typename?: 'OrganizationUser', id: string, fullName: string, bookingRequests?: Array<{ __typename?: 'BookingRequest', status: BookingRequestStatus }> | null, groupBudget?: { __typename?: 'GroupBudget', id: string, limit: number, individualLimit?: number | null } | null }, reviewer?: { __typename?: 'OrganizationUser', fullName: string } | null, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, location: { __typename?: 'Location', name: string } }, groupBudget?: { __typename?: 'GroupBudget', name: string, id: string } | null, organizationBudget?: { __typename?: 'OrganizationBudget', id: string } | null }> | null } | null };

export type BudgetBookingRequestsQueryVariables = Exact<{
  requesterStartDate?: InputMaybe<Scalars['String']>;
  requesterEndDate?: InputMaybe<Scalars['String']>;
}>;


export type BudgetBookingRequestsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, role: UserRole, organization?: { __typename?: 'Organization', id: string, name: string } | null, groupBudget?: { __typename?: 'GroupBudget', id: string, name: string, bookingRequests?: Array<{ __typename?: 'BookingRequest', id: string, amount?: number | null, currency?: string | null, createdAt: string, bookedAt?: string | null, startDate: string, status: BookingRequestStatus, reason: string, reviewerNote?: string | null, reviewedAt?: string | null, requesterTotalSpend: number, requester: { __typename?: 'OrganizationUser', id: string, fullName: string, bookingRequests?: Array<{ __typename?: 'BookingRequest', status: BookingRequestStatus }> | null, groupBudget?: { __typename?: 'GroupBudget', id: string, limit: number, individualLimit?: number | null } | null }, reviewer?: { __typename?: 'OrganizationUser', fullName: string } | null, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, location: { __typename?: 'Location', name: string } }, groupBudget?: { __typename?: 'GroupBudget', name: string, id: string } | null, organizationBudget?: { __typename?: 'OrganizationBudget', id: string } | null }> | null } | null } | null };

export type BudgetBookingRequests__CurrentUserFragment = { __typename?: 'CurrentUser', id: string, role: UserRole, organization?: { __typename?: 'Organization', id: string, name: string } | null, groupBudget?: { __typename?: 'GroupBudget', id: string, name: string, bookingRequests?: Array<{ __typename?: 'BookingRequest', id: string, amount?: number | null, currency?: string | null, createdAt: string, bookedAt?: string | null, startDate: string, status: BookingRequestStatus, reason: string, reviewerNote?: string | null, reviewedAt?: string | null, requesterTotalSpend: number, requester: { __typename?: 'OrganizationUser', id: string, fullName: string, bookingRequests?: Array<{ __typename?: 'BookingRequest', status: BookingRequestStatus }> | null, groupBudget?: { __typename?: 'GroupBudget', id: string, limit: number, individualLimit?: number | null } | null }, reviewer?: { __typename?: 'OrganizationUser', fullName: string } | null, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, location: { __typename?: 'Location', name: string } }, groupBudget?: { __typename?: 'GroupBudget', name: string, id: string } | null, organizationBudget?: { __typename?: 'OrganizationBudget', id: string } | null }> | null } | null };

export type BookingsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<OrderSort>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}>;


export type BookingsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', orders: Array<{ __typename?: 'Order', id: string, status: OrderStatus, confirmationID?: string | null, invitees: Array<{ __typename?: 'InviteRecipient', name: string }>, orderItems: Array<{ __typename?: 'OrderItem', details: { __typename: 'DailyBooking', startDate: string, endDate: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, preferred?: boolean | null, images: Array<{ __typename?: 'Image', medium: { __typename?: 'ImageData', url: string } }>, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', streetAddress: string, city: string, state: string, latitude?: number | null, longitude?: number | null } } } } | { __typename: 'HourlyBooking', date: string, startTime: string, endTime: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, preferred?: boolean | null, inventoryCapacity: number, images: Array<{ __typename?: 'Image', medium: { __typename?: 'ImageData', url: string } }>, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', streetAddress: string, city: string, state: string, latitude?: number | null, longitude?: number | null } } } } }> }> } | null };

export type Bookings__OrderDetailsFragment = { __typename?: 'Order', id: string, status: OrderStatus, confirmationID?: string | null, invitees: Array<{ __typename?: 'InviteRecipient', name: string }>, orderItems: Array<{ __typename?: 'OrderItem', details: { __typename: 'DailyBooking', startDate: string, endDate: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, preferred?: boolean | null, images: Array<{ __typename?: 'Image', medium: { __typename?: 'ImageData', url: string } }>, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', streetAddress: string, city: string, state: string, latitude?: number | null, longitude?: number | null } } } } | { __typename: 'HourlyBooking', date: string, startTime: string, endTime: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, preferred?: boolean | null, inventoryCapacity: number, images: Array<{ __typename?: 'Image', medium: { __typename?: 'ImageData', url: string } }>, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', streetAddress: string, city: string, state: string, latitude?: number | null, longitude?: number | null } } } } }> };

export type Bookings__OrderItemDetailsFragment = { __typename?: 'OrderItem', details: { __typename: 'DailyBooking', startDate: string, endDate: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, preferred?: boolean | null, images: Array<{ __typename?: 'Image', medium: { __typename?: 'ImageData', url: string } }>, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', streetAddress: string, city: string, state: string, latitude?: number | null, longitude?: number | null } } } } | { __typename: 'HourlyBooking', date: string, startTime: string, endTime: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, preferred?: boolean | null, inventoryCapacity: number, images: Array<{ __typename?: 'Image', medium: { __typename?: 'ImageData', url: string } }>, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', streetAddress: string, city: string, state: string, latitude?: number | null, longitude?: number | null } } } } };

export type Bookings__DailyBookingDetailsFragment = { __typename?: 'DailyBooking', startDate: string, endDate: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, preferred?: boolean | null, images: Array<{ __typename?: 'Image', medium: { __typename?: 'ImageData', url: string } }>, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', streetAddress: string, city: string, state: string, latitude?: number | null, longitude?: number | null } } } };

export type Bookings__HourlyBookingDetailsFragment = { __typename?: 'HourlyBooking', date: string, startTime: string, endTime: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, preferred?: boolean | null, inventoryCapacity: number, images: Array<{ __typename?: 'Image', medium: { __typename?: 'ImageData', url: string } }>, location: { __typename?: 'Location', id: string, name: string, address: { __typename?: 'Address', streetAddress: string, city: string, state: string, latitude?: number | null, longitude?: number | null } } } };

export type InviteesRemainingQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type InviteesRemainingQuery = { __typename?: 'Query', order?: { __typename?: 'Order', invitees: Array<{ __typename?: 'InviteRecipient', name: string }>, orderItems: Array<{ __typename?: 'OrderItem', details: { __typename?: 'DailyBooking', space: { __typename?: 'Space', maxCapacity: number } } | { __typename?: 'HourlyBooking', space: { __typename?: 'Space', maxCapacity: number } } }> } | null };

export type InviteesRemaining__DailyBookingDetailsFragment = { __typename?: 'DailyBooking', space: { __typename?: 'Space', maxCapacity: number } };

export type InviteesRemaining__HourlyBookingDetailsFragment = { __typename?: 'HourlyBooking', space: { __typename?: 'Space', maxCapacity: number } };

export type GetOrgNameQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgNameQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', name: string } | null } | null };

export type OrgBudgetQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgBudgetQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', id: string, name: string, groupBudgets: Array<{ __typename?: 'GroupBudget', id: string, name: string }> } | null } | null };

export type UpdateOrderBudgetMutationVariables = Exact<{
  orderId: Scalars['ID'];
  budgetId: Scalars['ID'];
}>;


export type UpdateOrderBudgetMutation = { __typename?: 'Mutation', updateOrderBudget: boolean };

export type PeoplePickerQueryVariables = Exact<{ [key: string]: never; }>;


export type PeoplePickerQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, groupBudgetRole?: GroupBudgetRole | null, organization?: { __typename?: 'Organization', id: string, users: Array<{ __typename?: 'OrganizationUser', id: string, userId?: string | null, role: UserRole, fullName: string, email?: string | null, picture?: string | null, groupBudgetRole?: GroupBudgetRole | null, groupBudget?: { __typename?: 'GroupBudget', id: string, name: string, members: Array<{ __typename?: 'GroupBudgetMember', role: GroupBudgetRole, user: { __typename?: 'OrganizationUser', id: string } }> } | null }> } | null } | null };

export type BudgetQueryVariables = Exact<{ [key: string]: never; }>;


export type BudgetQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, role: UserRole, organization?: { __typename?: 'Organization', id: string, name: string, budget?: { __typename?: 'OrganizationBudget', id: string, state: OrganizationBudgetState, remaining: number, spend: number, limit: number, individualLimit?: number | null } | null, groupBudgets: Array<{ __typename?: 'GroupBudget', id: string, status?: GroupBudgetStatus | null, name: string, description?: string | null, color: string, spend: number, remaining: number, limit: number }> } | null } | null };

export type PreMovingGroupBudgetPeopleMessageQueryQueryVariables = Exact<{
  input: PreMovingGroupBudgetPeopleInput;
}>;


export type PreMovingGroupBudgetPeopleMessageQueryQuery = { __typename?: 'Query', preMovingGroupBudgetPeopleMessage?: Array<{ __typename?: 'MovingPeopleMessage', messages: Array<MovingPeopleMessageType>, personName: string, previousBudgetName: string, newManagerName?: string | null }> | null };

export type UpdateGroupBudgetAddMemberMutationVariables = Exact<{
  input: UpdateGroupBudgetInput;
}>;


export type UpdateGroupBudgetAddMemberMutation = { __typename?: 'Mutation', updateGroupBudget: { __typename?: 'GroupBudget', id: string, members: Array<{ __typename?: 'GroupBudgetMember', role: GroupBudgetRole, user: { __typename?: 'OrganizationUser', id: string } }> } };

export type ReactivateGroupBudgetMutationVariables = Exact<{
  input: ReactivateGroupBudgetInput;
}>;


export type ReactivateGroupBudgetMutation = { __typename?: 'Mutation', reactivateGroupBudget: { __typename?: 'GroupBudget', id: string, name: string, description?: string | null, limit: number, individualLimit?: number | null, status?: GroupBudgetStatus | null, policy?: { __typename?: 'BudgetPolicy', id: string, name: string } | null } };

export type CreateGroupBudgetMutationVariables = Exact<{
  input: CreateGroupBudgetInput;
}>;


export type CreateGroupBudgetMutation = { __typename?: 'Mutation', createGroupBudget: { __typename?: 'GroupBudget', id: string, name: string, description?: string | null, limit: number, individualLimit?: number | null, status?: GroupBudgetStatus | null, policy?: { __typename?: 'BudgetPolicy', id: string, name: string } | null } };

export type CreateGroupBudgetOrganizationBudgetQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateGroupBudgetOrganizationBudgetQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, role: UserRole, organization?: { __typename?: 'Organization', id: string, budget?: { __typename?: 'OrganizationBudget', limit: number } | null, groupBudgets: Array<{ __typename?: 'GroupBudget', id: string, name: string }>, policies: Array<{ __typename?: 'BudgetPolicy', id: string, name: string, isAppliedToNewBudget: boolean }> } | null } | null };

export type UserRoleAndOrgInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserRoleAndOrgInfoQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, role: UserRole, organization?: { __typename?: 'Organization', id: string, budget?: { __typename?: 'OrganizationBudget', id: string, limit: number } | null, groupBudgets: Array<{ __typename?: 'GroupBudget', id: string, name: string }> } | null } | null, groupBudget?: { __typename?: 'GroupBudget', id: string, status?: GroupBudgetStatus | null, name: string, description?: string | null, color: string, spend: number, remaining: number, limit: number, individualLimit?: number | null, members: Array<{ __typename?: 'GroupBudgetMember', role: GroupBudgetRole, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, role: UserRole, fullName: string, email?: string | null, picture?: string | null, title?: string | null, groupBudgetRole?: GroupBudgetRole | null } }> } | null };

export type GroupBudgetDetailPeopleQueryVariables = Exact<{
  groupBudgetId: Scalars['ID'];
}>;


export type GroupBudgetDetailPeopleQuery = { __typename?: 'Query', groupBudget?: { __typename?: 'GroupBudget', id: string, status?: GroupBudgetStatus | null, members: Array<{ __typename?: 'GroupBudgetMember', role: GroupBudgetRole, user: { __typename?: 'OrganizationUser', id: string, fullName: string, email?: string | null, picture?: string | null, groupBudgetRole?: GroupBudgetRole | null } }> } | null };

export type GroupBudgetDetailQueryVariables = Exact<{
  id: Scalars['ID'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type GroupBudgetDetailQuery = { __typename?: 'Query', groupBudget?: { __typename?: 'GroupBudget', id: string, status?: GroupBudgetStatus | null, color: string, spend: number, remaining: number, limit: number, reporting: { __typename?: 'Reporting', lastUpdatedDate: string, spend: { __typename?: 'ReportingSpend', totalSpend: number, dayPasses: { __typename?: 'ReportingValue', value: number, percentage: number }, dayOffices: { __typename?: 'ReportingValue', value: number, percentage: number }, meetingRooms: { __typename?: 'ReportingValue', value: number, percentage: number } }, bookings: { __typename?: 'ReportingBookings', totalBookings: number, dayPasses: { __typename?: 'ReportingValue', value: number, percentage: number }, dayOffices: { __typename?: 'ReportingValue', value: number, percentage: number }, meetingRooms: { __typename?: 'ReportingValue', value: number, percentage: number } }, frequency: { __typename?: 'ReportingFrequency', totalEmployees: number, zeroOrSingleBookingPerWeek: { __typename?: 'ReportingValue', value: number, percentage: number }, twoOrThreeBookingsPerWeek: { __typename?: 'ReportingValue', value: number, percentage: number }, fourOrMoreBookingsPerWeek: { __typename?: 'ReportingValue', value: number, percentage: number } }, engagement: { __typename?: 'ReportingEngagement', soloBookings: { __typename?: 'ReportingEngagementWeekBookings', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number, saturday: number, sunday: number }, teamBookings: { __typename?: 'ReportingEngagementWeekBookings', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number, saturday: number, sunday: number } } } } | null };

export type BudgetDetail__ReportingFragment = { __typename?: 'Reporting', lastUpdatedDate: string, spend: { __typename?: 'ReportingSpend', totalSpend: number, dayPasses: { __typename?: 'ReportingValue', value: number, percentage: number }, dayOffices: { __typename?: 'ReportingValue', value: number, percentage: number }, meetingRooms: { __typename?: 'ReportingValue', value: number, percentage: number } }, bookings: { __typename?: 'ReportingBookings', totalBookings: number, dayPasses: { __typename?: 'ReportingValue', value: number, percentage: number }, dayOffices: { __typename?: 'ReportingValue', value: number, percentage: number }, meetingRooms: { __typename?: 'ReportingValue', value: number, percentage: number } }, frequency: { __typename?: 'ReportingFrequency', totalEmployees: number, zeroOrSingleBookingPerWeek: { __typename?: 'ReportingValue', value: number, percentage: number }, twoOrThreeBookingsPerWeek: { __typename?: 'ReportingValue', value: number, percentage: number }, fourOrMoreBookingsPerWeek: { __typename?: 'ReportingValue', value: number, percentage: number } }, engagement: { __typename?: 'ReportingEngagement', soloBookings: { __typename?: 'ReportingEngagementWeekBookings', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number, saturday: number, sunday: number }, teamBookings: { __typename?: 'ReportingEngagementWeekBookings', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number, saturday: number, sunday: number } } };

export type GroupBudgetDetailTransactionsQueryVariables = Exact<{
  id: Scalars['ID'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type GroupBudgetDetailTransactionsQuery = { __typename?: 'Query', groupBudget?: { __typename?: 'GroupBudget', id: string, name: string, ordersSummary: { __typename?: 'OrdersSummary', lastUpdatedDate: string, orders: Array<{ __typename?: 'OrderSummary', orderID: string, hostFullName: string, hostTitle?: string | null, locationName: string, locationAddress: string, spaceName: string, spaceType?: SpaceType | null, bookingDate: string, bookingStartTime?: string | null, bookingEndTime?: string | null, orderCreatedAt: string, totalPrice: number, currency: string, order: { __typename?: 'Order', memo?: string | null }, bookingRequest?: { __typename?: 'BookingRequest', id: string } | null }> } } | null };

export type UpdateGroupBudgetMutationVariables = Exact<{
  input: UpdateGroupBudgetInput;
}>;


export type UpdateGroupBudgetMutation = { __typename?: 'Mutation', updateGroupBudget: { __typename?: 'GroupBudget', id: string, name: string, description?: string | null, limit: number, individualLimit?: number | null, status?: GroupBudgetStatus | null, policy?: { __typename?: 'BudgetPolicy', id: string, name: string } | null } };

export type UpdateGroupBudgetOrganizationBudgetQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UpdateGroupBudgetOrganizationBudgetQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, role: UserRole, organization?: { __typename?: 'Organization', id: string, budget?: { __typename?: 'OrganizationBudget', id: string, limit: number } | null, groupBudgets: Array<{ __typename?: 'GroupBudget', id: string, name: string }> } | null } | null, groupBudget?: { __typename?: 'GroupBudget', id: string, status?: GroupBudgetStatus | null, name: string, description?: string | null, color: string, spend: number, remaining: number, limit: number, individualLimit?: number | null, members: Array<{ __typename?: 'GroupBudgetMember', role: GroupBudgetRole, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, role: UserRole, fullName: string, email?: string | null, picture?: string | null, title?: string | null, groupBudgetRole?: GroupBudgetRole | null } }>, policy?: { __typename?: 'BudgetPolicy', id: string } | null } | null };

export type DeactivateGroupBudgetMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeactivateGroupBudgetMutation = { __typename?: 'Mutation', deactivateGroupBudget: { __typename?: 'GroupBudget', id: string, status?: GroupBudgetStatus | null, name: string, description?: string | null, spend: number, remaining: number, limit: number, members: Array<{ __typename?: 'GroupBudgetMember', role: GroupBudgetRole, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, role: UserRole, fullName: string, email?: string | null, picture?: string | null, title?: string | null, groupBudgetRole?: GroupBudgetRole | null } }> } };

export type CreateOrganizationBudgetMutationVariables = Exact<{
  input: CreateOrganizationBudgetInput;
}>;


export type CreateOrganizationBudgetMutation = { __typename?: 'Mutation', createOrganizationBudget: { __typename?: 'OrganizationBudget', id: string, remaining: number, spend: number, limit: number, individualLimit?: number | null, policy?: { __typename?: 'BudgetPolicy', id: string, name: string } | null } };

export type OrganizationBudgetDetailQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type OrganizationBudgetDetailQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, organization?: { __typename?: 'Organization', id: string, name: string, createdAt: string, reporting?: { __typename?: 'Reporting', lastUpdatedDate: string, spend: { __typename?: 'ReportingSpend', totalSpend: number, dayPasses: { __typename?: 'ReportingValue', value: number, percentage: number }, dayOffices: { __typename?: 'ReportingValue', value: number, percentage: number }, meetingRooms: { __typename?: 'ReportingValue', value: number, percentage: number } }, bookings: { __typename?: 'ReportingBookings', totalBookings: number, dayPasses: { __typename?: 'ReportingValue', value: number, percentage: number }, dayOffices: { __typename?: 'ReportingValue', value: number, percentage: number }, meetingRooms: { __typename?: 'ReportingValue', value: number, percentage: number } }, frequency: { __typename?: 'ReportingFrequency', totalEmployees: number, zeroOrSingleBookingPerWeek: { __typename?: 'ReportingValue', value: number, percentage: number }, twoOrThreeBookingsPerWeek: { __typename?: 'ReportingValue', value: number, percentage: number }, fourOrMoreBookingsPerWeek: { __typename?: 'ReportingValue', value: number, percentage: number } }, engagement: { __typename?: 'ReportingEngagement', soloBookings: { __typename?: 'ReportingEngagementWeekBookings', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number, saturday: number, sunday: number }, teamBookings: { __typename?: 'ReportingEngagementWeekBookings', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number, saturday: number, sunday: number } } } | null, budget?: { __typename?: 'OrganizationBudget', id: string, state: OrganizationBudgetState, remaining: number, spend: number, limit: number, individualLimit?: number | null } | null, groupBudgets: Array<{ __typename?: 'GroupBudget', id: string, status?: GroupBudgetStatus | null, name: string, description?: string | null, color: string, spend: number, remaining: number, limit: number }> } | null } | null };

export type OrganizationBudgetDetailTransactionsQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type OrganizationBudgetDetailTransactionsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', id: string, name: string, ordersSummary?: { __typename?: 'OrdersSummary', lastUpdatedDate: string, orders: Array<{ __typename?: 'OrderSummary', hostFullName: string, hostTitle?: string | null, locationName: string, locationAddress: string, spaceName: string, spaceType?: SpaceType | null, bookingDate: string, bookingStartTime?: string | null, bookingEndTime?: string | null, orderCreatedAt: string, orderID: string, totalPrice: number, currency: string, order: { __typename?: 'Order', memo?: string | null }, groupBudget?: { __typename?: 'GroupBudget', id: string, name: string } | null, bookingRequest?: { __typename?: 'BookingRequest', id: string } | null }> } | null } | null } | null };

export type UpdateOrganizationBudgetMutationVariables = Exact<{
  input: UpdateOrganizationBudgetInput;
}>;


export type UpdateOrganizationBudgetMutation = { __typename?: 'Mutation', updateOrganizationBudget: { __typename?: 'OrganizationBudget', id: string, remaining: number, spend: number, limit: number, individualLimit?: number | null, policy?: { __typename?: 'BudgetPolicy', id: string, name: string } | null } };

export type EditOrganizationBudgetQueryVariables = Exact<{ [key: string]: never; }>;


export type EditOrganizationBudgetQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, organization?: { __typename?: 'Organization', id: string, budget?: { __typename?: 'OrganizationBudget', limit: number, individualLimit?: number | null, policy?: { __typename?: 'BudgetPolicy', id: string } | null } | null } | null } | null };

export type PoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type PoliciesQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', policies: Array<{ __typename?: 'BudgetPolicy', id: string, name: string, lastUpdated: string }> } | null } | null };

export type RemoveAddressMutationVariables = Exact<{
  addressId: Scalars['ID'];
}>;


export type RemoveAddressMutation = { __typename?: 'Mutation', removeBudgetPolicyAddress: boolean };

export type CreatePolicyMutationVariables = Exact<{
  input: CreateBudgetPolicyInput;
}>;


export type CreatePolicyMutation = { __typename?: 'Mutation', createBudgetPolicy: { __typename?: 'BudgetPolicy', id: string, name: string } };

export type BudgetPolicyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BudgetPolicyQuery = { __typename?: 'Query', budgetPolicy: { __typename?: 'BudgetPolicy', name: string, isAppliedToNewBudget: boolean, applyToBudgets: Array<{ __typename?: 'GroupBudget', id: string }>, spaceTypes: { __typename?: 'SpaceTypes', meetingRoom: boolean, privateOffice: boolean, dayPass: boolean }, locationItems?: Array<{ __typename?: 'BudgetPolicyLocationItem', id: string, distance: number, distanceUnit: BudgetPolicyLocationItemDistanceType, address: { __typename?: 'BudgetPolicyAddress', id: string, street: string, latitude: number, longitude: number } }> | null } };

export type UpdateBudgetPolicyMutationVariables = Exact<{
  input: UpdateBudgetPolicyInput;
}>;


export type UpdateBudgetPolicyMutation = { __typename?: 'Mutation', updateBudgetPolicy: { __typename?: 'BudgetPolicy', id: string } };

export type GroupBudgetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GroupBudgetsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', groupBudgets: Array<{ __typename?: 'GroupBudget', id: string, name: string, policy?: { __typename?: 'BudgetPolicy', name: string } | null }> } | null } | null };

export type BudgetPoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type BudgetPoliciesQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', policies: Array<{ __typename?: 'BudgetPolicy', id: string, name: string }> } | null } | null };

export type BudgetPolicyAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type BudgetPolicyAddressesQuery = { __typename?: 'Query', budgetPolicyAddresses: Array<{ __typename?: 'BudgetPolicyAddress', id: string, street: string, latitude: number, longitude: number }> };

export type OrgBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type OrgBySlugQuery = { __typename?: 'Query', organizationBySlug?: { __typename?: 'Organization', id: string, name: string, requireSSO: boolean, ssoProvider: Array<string>, logoUrl?: string | null, slug?: string | null, connectionName?: string | null } | null };

export type SendSupportTicketMutationVariables = Exact<{
  topic: Scalars['String'];
  subject: Scalars['String'];
  content: Scalars['String'];
}>;


export type SendSupportTicketMutation = { __typename?: 'Mutation', sendSupportTicket: boolean };

export type LocationPreviewSpacesQueryVariables = Exact<{
  offsiteLocationID: Scalars['ID'];
  filter?: InputMaybe<DiscoverFilter>;
  dayPassFilter?: InputMaybe<DiscoverFilter>;
}>;


export type LocationPreviewSpacesQuery = { __typename?: 'Query', locations?: { __typename?: 'Location', id: string, name: string, timezone: string, address: { __typename?: 'Address', fullAddress: string, streetAddress: string, city: string, latitude?: number | null, longitude?: number | null }, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }> } | null, meetingRooms?: { __typename?: 'Location', id: string, name: string, spaces: Array<{ __typename?: 'Space', id: string, currency: string, name: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } }> } | null, dayPasses?: { __typename?: 'Location', id: string, name: string, spaces: Array<{ __typename?: 'Space', id: string, currency: string, name: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } }> } | null, dayOffices?: { __typename?: 'Location', id: string, name: string, spaces: Array<{ __typename?: 'Space', locked: boolean, id: string, name: string, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean, space: { __typename?: 'Space', id: string, name: string, currency: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } } }> }> } | null };

export type LocationPreviewCardLocationSpaces__LocationDetailsFragment = { __typename?: 'Location', spaces: Array<{ __typename?: 'Space', id: string, currency: string, name: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } }> };

export type LocationPreviewCardLocationSpaces__DayPassLocationDetailsFragment = { __typename?: 'Location', spaces: Array<{ __typename?: 'Space', id: string, currency: string, name: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } }> };

export type LocationPreviewCardLocationSpaces__SpaceDetailsFragment = { __typename?: 'Space', id: string, currency: string, name: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } };

export type LocationPreviewCardLocationPhysicalSpaces__LocationDetailsFragment = { __typename?: 'Location', spaces: Array<{ __typename?: 'Space', locked: boolean, id: string, name: string, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean, space: { __typename?: 'Space', id: string, name: string, currency: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } } }> }> };

export type LocationPreviewCardLocationPhysicalSpaces__SpaceDetailsFragment = { __typename?: 'Space', id: string, name: string, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean, space: { __typename?: 'Space', id: string, name: string, currency: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } } }> };

export type LocationPreviewCardLocationPhysicalSpaces__PhysicalSpaceDetailsFragment = { __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean, space: { __typename?: 'Space', id: string, name: string, currency: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } } };

export type Location_Preview_Space_CommonsFragment = { __typename?: 'Space', maxCapacity: number, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } };

export type LocationPreview__LocationSpacesFragment = { __typename?: 'Location', id: string, name: string, timezone: string, address: { __typename?: 'Address', fullAddress: string, streetAddress: string, city: string, latitude?: number | null, longitude?: number | null }, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }> };

export type SpaceCardCurrentUserCountryQueryVariables = Exact<{ [key: string]: never; }>;


export type SpaceCardCurrentUserCountryQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, ipPlace: { __typename?: 'Place', country?: string | null } } | null };

export type SpaceTypeFilterAmenitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type SpaceTypeFilterAmenitiesQuery = { __typename?: 'Query', MeetingRoomAmenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, DayPassAmenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, DayOfficeAmenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, LocationAmenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }> };

export type EmptyStateTileBQueryVariables = Exact<{ [key: string]: never; }>;


export type EmptyStateTileBQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, fullName: string, email?: string | null } | null };

export type RecommendedSpaceListQueryVariables = Exact<{
  spaceType: SpaceType;
  filter?: InputMaybe<SpacesFilter>;
  centerMapCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  currentUserCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SpacesSort>;
  bookingsDate: Scalars['String'];
}>;


export type RecommendedSpaceListQuery = { __typename?: 'Query', spaces: { __typename?: 'SpaceConnection', data: Array<{ __typename?: 'Space', id: string, name: string, currency: string, locked: boolean, savedByCurrentUser: boolean, maxCapacity: number, physicalSpacesCount: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, timezone: string, centerMapDistance?: number | null, currentUserDistance?: number | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, bookings: Array<{ __typename?: 'Booking', id: string, startTime?: string | null, endTime?: string | null, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null } }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } }> } };

export type RecommendedSpaceList_FragmentFragment = { __typename?: 'Space', id: string, name: string, currency: string, locked: boolean, savedByCurrentUser: boolean, maxCapacity: number, physicalSpacesCount: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, timezone: string, centerMapDistance?: number | null, currentUserDistance?: number | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, bookings: Array<{ __typename?: 'Booking', id: string, startTime?: string | null, endTime?: string | null, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null } }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } };

export type RecommendedSpaceListLocationDetail_FragmentFragment = { __typename?: 'Location', id: string, name: string, timezone: string, centerMapDistance?: number | null, currentUserDistance?: number | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, bookings: Array<{ __typename?: 'Booking', id: string, startTime?: string | null, endTime?: string | null, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null } }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } };

export type RecommendedLocationListQueryVariables = Exact<{
  filter?: InputMaybe<LocationsFilter>;
  centerMapCoordinates?: InputMaybe<SpaceSearchCoordinates>;
}>;


export type RecommendedLocationListQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'Location', id: string, name: string, timezone: string, savedByCurrentUser: boolean, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }> };

export type RecommendedLocationList_FragmentFragment = { __typename?: 'Location', id: string, name: string, timezone: string, savedByCurrentUser: boolean, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } };

export type EmptyStatesOtherSpacesQueryVariables = Exact<{
  filter?: InputMaybe<SpacesFilter>;
  centerMapCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  currentUserCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SpacesSort>;
}>;


export type EmptyStatesOtherSpacesQuery = { __typename?: 'Query', MeetingRoom: { __typename?: 'SpaceConnection', data: Array<{ __typename?: 'Space', id: string }> }, DayPass: { __typename?: 'SpaceConnection', data: Array<{ __typename?: 'Space', id: string }> }, DayOffice: { __typename?: 'SpaceConnection', data: Array<{ __typename?: 'Space', id: string, physicalSpacesCount: number }> } };

export type HomePageQueryVariables = Exact<{
  spaceType: SpaceType;
  filter?: InputMaybe<SpacesFilter>;
  centerMapCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  currentUserCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  radius?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SpacesSort>;
  bookingsDate: Scalars['String'];
}>;


export type HomePageQuery = { __typename?: 'Query', spaces: { __typename?: 'SpaceConnection', totalCount: number, data: Array<{ __typename?: 'Space', id: string, name: string, currency: string, maxCapacity: number, locked: boolean, preferred?: boolean | null, savedByCurrentUser: boolean, physicalSpacesCount: number, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, timezone: string, centerMapDistance?: number | null, currentUserDistance?: number | null, bookings: Array<{ __typename?: 'Booking', id: string, startTime?: string | null, endTime?: string | null, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } }> } };

export type HomePage__SpaceDetailsFragment = { __typename?: 'Space', id: string, name: string, currency: string, maxCapacity: number, locked: boolean, preferred?: boolean | null, savedByCurrentUser: boolean, physicalSpacesCount: number, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, timezone: string, centerMapDistance?: number | null, currentUserDistance?: number | null, bookings: Array<{ __typename?: 'Booking', id: string, startTime?: string | null, endTime?: string | null, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } };

export type HomePage__LocationDetailsFragment = { __typename?: 'Location', id: string, name: string, timezone: string, centerMapDistance?: number | null, currentUserDistance?: number | null, bookings: Array<{ __typename?: 'Booking', id: string, startTime?: string | null, endTime?: string | null, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } };

export type HomePageLocationsQueryVariables = Exact<{
  filter?: InputMaybe<LocationsFilter>;
  centerMapCoordinates?: InputMaybe<SpaceSearchCoordinates>;
}>;


export type HomePageLocationsQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'Location', id: string, name: string, timezone: string, savedByCurrentUser: boolean, preferred?: boolean | null, centerMapDistance?: number | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }> };

export type HomePageLocations__LocationDetailsFragment = { __typename?: 'Location', id: string, name: string, timezone: string, savedByCurrentUser: boolean, preferred?: boolean | null, centerMapDistance?: number | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } };

export type CurrentUserIpPlaceCoordinatesHookQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserIpPlaceCoordinatesHookQuery = { __typename?: 'Query', ipPlace: { __typename?: 'Place', latitude: number, longitude: number, placeName: string } };

export type GetLocationAmenitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationAmenitiesQuery = { __typename?: 'Query', amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }> };

export type BookingSpaceDetailFragment = { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, locked: boolean, preferred?: boolean | null, currency: string, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, preferred?: boolean | null, currentUserDistance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string }, medium: { __typename?: 'ImageData', url: string } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } };

export type SpaceLocationDetailFragment = { __typename?: 'Location', id: string, name: string, preferred?: boolean | null, currentUserDistance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string }, medium: { __typename?: 'ImageData', url: string } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } };

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInfoQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, hasBookedBefore: boolean } | null };

export type GetLocationNearByQueryVariables = Exact<{
  filter?: InputMaybe<LocationsFilter>;
  centerMapCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  currentUserCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  limit?: InputMaybe<Scalars['Int']>;
  radius?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<LocationsSort>;
}>;


export type GetLocationNearByQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'Location', id: string, name: string, preferred?: boolean | null, currentUserDistance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string }, medium: { __typename?: 'ImageData', url: string } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }> };

export type GetOrgBookingQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  currentUserCoordinates?: InputMaybe<SpaceSearchCoordinates>;
}>;


export type GetOrgBookingQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, organization?: { __typename?: 'Organization', bookings: Array<{ __typename?: 'Booking', id: string, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string }, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, locked: boolean, preferred?: boolean | null, currency: string, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, preferred?: boolean | null, currentUserDistance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string }, medium: { __typename?: 'ImageData', url: string } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } } }> } | null } | null };

export type OrgBookingFragment = { __typename?: 'Booking', id: string, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string }, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, locked: boolean, preferred?: boolean | null, currency: string, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, preferred?: boolean | null, currentUserDistance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string }, medium: { __typename?: 'ImageData', url: string } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } } };

export type GetPopularLocationQueryVariables = Exact<{
  centerMapCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  currentUserCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  limit?: InputMaybe<Scalars['Int']>;
  radius?: InputMaybe<Scalars['Int']>;
}>;


export type GetPopularLocationQuery = { __typename?: 'Query', popularLocations: Array<{ __typename?: 'Location', id: string, name: string, preferred?: boolean | null, currentUserDistance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string }, medium: { __typename?: 'ImageData', url: string } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }> };

export type GetSpaceNearByQueryVariables = Exact<{
  spaceType: SpaceType;
  hasSpaceType: Scalars['Boolean'];
  filter?: InputMaybe<SpacesFilter>;
  centerMapCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  currentUserCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  radius?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SpacesSort>;
}>;


export type GetSpaceNearByQuery = { __typename?: 'Query', spaces: { __typename?: 'SpaceConnection', data: Array<{ __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, locked: boolean, preferred?: boolean | null, currency: string, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, preferred?: boolean | null, currentUserDistance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string }, medium: { __typename?: 'ImageData', url: string } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } }> }, dayPasses: { __typename?: 'SpaceConnection', data: Array<{ __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, locked: boolean, preferred?: boolean | null, currency: string, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, preferred?: boolean | null, currentUserDistance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string }, medium: { __typename?: 'ImageData', url: string } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } }> }, meetingRooms: { __typename?: 'SpaceConnection', data: Array<{ __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, locked: boolean, preferred?: boolean | null, currency: string, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, preferred?: boolean | null, currentUserDistance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string }, medium: { __typename?: 'ImageData', url: string } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } }> }, dayOffices: { __typename?: 'SpaceConnection', data: Array<{ __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, locked: boolean, preferred?: boolean | null, currency: string, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, preferred?: boolean | null, currentUserDistance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string }, medium: { __typename?: 'ImageData', url: string } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } }> } };

export type GetUserOrderQueryVariables = Exact<{
  currentUserCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<OrderSort>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}>;


export type GetUserOrderQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, orders: Array<{ __typename?: 'Order', id: string, status: OrderStatus, confirmationID?: string | null, invites: Array<{ __typename?: 'OrderInvites', recipients: Array<{ __typename?: 'InviteRecipient', name: string, email: string }> }>, orderItems: Array<{ __typename?: 'OrderItem', details: { __typename: 'DailyBooking', startDate: string, endDate: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, locked: boolean, preferred?: boolean | null, currency: string, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, preferred?: boolean | null, currentUserDistance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string }, medium: { __typename?: 'ImageData', url: string } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } } } | { __typename: 'HourlyBooking', date: string, startTime: string, endTime: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, locked: boolean, preferred?: boolean | null, currency: string, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, preferred?: boolean | null, currentUserDistance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string }, medium: { __typename?: 'ImageData', url: string } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } } } }> }> } | null };

export type CurrentUserOrderFragment = { __typename?: 'Order', id: string, status: OrderStatus, confirmationID?: string | null, invites: Array<{ __typename?: 'OrderInvites', recipients: Array<{ __typename?: 'InviteRecipient', name: string, email: string }> }>, orderItems: Array<{ __typename?: 'OrderItem', details: { __typename: 'DailyBooking', startDate: string, endDate: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, locked: boolean, preferred?: boolean | null, currency: string, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, preferred?: boolean | null, currentUserDistance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string }, medium: { __typename?: 'ImageData', url: string } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } } } | { __typename: 'HourlyBooking', date: string, startTime: string, endTime: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, locked: boolean, preferred?: boolean | null, currency: string, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, preferred?: boolean | null, currentUserDistance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string }, medium: { __typename?: 'ImageData', url: string } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } } } }> };

export type OrderItemDailyBookingDetailFragment = { __typename?: 'DailyBooking', startDate: string, endDate: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, locked: boolean, preferred?: boolean | null, currency: string, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, preferred?: boolean | null, currentUserDistance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string }, medium: { __typename?: 'ImageData', url: string } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } } };

export type OrderItemHourlyBookingDetailFragment = { __typename?: 'HourlyBooking', date: string, startTime: string, endTime: string, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, locked: boolean, preferred?: boolean | null, currency: string, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, preferred?: boolean | null, currentUserDistance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string }, medium: { __typename?: 'ImageData', url: string } }>, address: { __typename?: 'Address', city: string, streetAddress: string, latitude?: number | null, longitude?: number | null } }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } } };

export type GetUserTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserTypeQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, hasBookedBefore: boolean } | null };

export type LocationDetailsQueryVariables = Exact<{
  locationId: Scalars['ID'];
}>;


export type LocationDetailsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', budget?: { __typename?: 'OrganizationBudget', id: string, policy?: { __typename?: 'BudgetPolicy', id: string, spaceTypes: { __typename?: 'SpaceTypes', meetingRoom: boolean, dayPass: boolean, privateOffice: boolean } } | null } | null } | null, groupBudget?: { __typename?: 'GroupBudget', id: string, policy?: { __typename?: 'BudgetPolicy', id: string, spaceTypes: { __typename?: 'SpaceTypes', meetingRoom: boolean, dayPass: boolean, privateOffice: boolean } } | null } | null } | null, location?: { __typename?: 'Location', id: string, name: string, directions?: string | null, description?: string | null, savedByCurrentUser: boolean, preferred?: boolean | null, distance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, address: { __typename?: 'Address', fullAddress: string, latitude?: number | null, longitude?: number | null, city: string, streetAddress: string }, bookingHours: Array<{ __typename?: 'BookingHour', dayOfWeek: DayOfWeek, closedAt: string, openAt: string }> } | null, meetingRooms?: { __typename?: 'Location', id: string, spaces: Array<{ __typename?: 'Space', id: string, name: string, locked: boolean, maxCapacity: number, currency: string, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } }> } | null, dayPasses?: { __typename?: 'Location', id: string, spaces: Array<{ __typename?: 'Space', id: string, name: string, locked: boolean, maxCapacity: number, currency: string, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } }> } | null, dayOffices?: { __typename?: 'Location', id: string, spaces: Array<{ __typename?: 'Space', id: string, name: string, locked: boolean, maxCapacity: number, currency: string, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } }> } | null };

export type LocationDetails__SpaceDetailsFragment = { __typename?: 'Space', id: string, name: string, locked: boolean, maxCapacity: number, currency: string, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } };

export type LocationDetails__SpacePriceDetailsFragment = { __typename?: 'Space', currency: string, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } };

export type LocationDetails__LocationFragment = { __typename?: 'Location', id: string, name: string, directions?: string | null, description?: string | null, savedByCurrentUser: boolean, preferred?: boolean | null, distance?: number | null, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, address: { __typename?: 'Address', fullAddress: string, latitude?: number | null, longitude?: number | null, city: string, streetAddress: string }, bookingHours: Array<{ __typename?: 'BookingHour', dayOfWeek: DayOfWeek, closedAt: string, openAt: string }> };

export type LocationDetails__SpaceTypePolicyFragment = { __typename?: 'SpaceTypes', meetingRoom: boolean, dayPass: boolean, privateOffice: boolean };

export type ManageUsersListQueryVariables = Exact<{ [key: string]: never; }>;


export type ManageUsersListQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, role: UserRole, organization?: { __typename?: 'Organization', id: string, name: string, invitations: Array<{ __typename?: 'OrganizationInvitee', id: string, inviteeEmail?: string | null }>, users: Array<{ __typename?: 'OrganizationUser', userId?: string | null, id: string, role: UserRole, picture?: string | null, title?: string | null, email?: string | null, fullName: string }> } | null } | null };

export type ManageUsers__UserDetailsFragment = { __typename?: 'OrganizationUser', userId?: string | null, id: string, role: UserRole, picture?: string | null, title?: string | null, email?: string | null, fullName: string };

export type RevokeInviteMutationVariables = Exact<{
  inviteID: Scalars['String'];
}>;


export type RevokeInviteMutation = { __typename?: 'Mutation', revokeInvite: boolean };

export type ChangeUserRoleMutationVariables = Exact<{
  personId: Scalars['String'];
  newRole: Scalars['String'];
}>;


export type ChangeUserRoleMutation = { __typename?: 'Mutation', changeUserRole: boolean };

export type DeletePersonMutationVariables = Exact<{
  personId: Scalars['String'];
}>;


export type DeletePersonMutation = { __typename?: 'Mutation', deletePerson: boolean };

export type OfficePageBookingsQueryVariables = Exact<{
  officeSpaceID: Scalars['ID'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type OfficePageBookingsQuery = { __typename?: 'Query', officeSpace?: { __typename?: 'OfficeSpace', id: string, capacity?: number | null, bookings: Array<{ __typename?: 'OfficeSpaceBooking', id: string, day: string, bookableID: string, bookableType: string, user: { __typename?: 'BookingUser', id: string, name: string, title?: string | null, avatar: string } }>, checkins: Array<{ __typename?: 'OfficeSpaceCheckin', id: string, moment: string, checkinableID: string, checkinableType: string, user: { __typename?: 'CheckinUser', id: string, name: string, title?: string | null, avatar: string } }> } | null };

export type OfficePage__OfficeSpaceBookingsFragment = { __typename?: 'OfficeSpace', id: string, capacity?: number | null, bookings: Array<{ __typename?: 'OfficeSpaceBooking', id: string, day: string, bookableID: string, bookableType: string, user: { __typename?: 'BookingUser', id: string, name: string, title?: string | null, avatar: string } }>, checkins: Array<{ __typename?: 'OfficeSpaceCheckin', id: string, moment: string, checkinableID: string, checkinableType: string, user: { __typename?: 'CheckinUser', id: string, name: string, title?: string | null, avatar: string } }> };

export type OfficePage__OfficeSpaceBookingDetailsFragment = { __typename?: 'OfficeSpaceBooking', id: string, day: string, bookableID: string, bookableType: string, user: { __typename?: 'BookingUser', id: string, name: string, title?: string | null, avatar: string } };

export type OfficePage__OfficeSpaceCheckinDetailsFragment = { __typename?: 'OfficeSpaceCheckin', id: string, moment: string, checkinableID: string, checkinableType: string, user: { __typename?: 'CheckinUser', id: string, name: string, title?: string | null, avatar: string } };

export type OfficePageDetailsCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type OfficePageDetailsCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string } | null };

export type OfficePageDetailsQueryVariables = Exact<{
  officeSpaceID: Scalars['ID'];
}>;


export type OfficePageDetailsQuery = { __typename?: 'Query', officeSpace?: { __typename?: 'OfficeSpace', id: string, capacity?: number | null, office: { __typename?: 'Office', timeZone: string, address?: { __typename?: 'Address', latitude?: number | null, longitude?: number | null } | null }, content: { __typename?: 'OfficeSpaceContent', id: string, title: string, description: string, images: Array<{ __typename?: 'Image', large: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number } }> } } | null };

export type OfficePage__OfficeSpaceDetailsFragment = { __typename?: 'OfficeSpace', id: string, capacity?: number | null, office: { __typename?: 'Office', timeZone: string, address?: { __typename?: 'Address', latitude?: number | null, longitude?: number | null } | null }, content: { __typename?: 'OfficeSpaceContent', id: string, title: string, description: string, images: Array<{ __typename?: 'Image', large: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number } }> } };

export type BookOfficeSpaceOnDayMutationVariables = Exact<{
  spaceID: Scalars['String'];
  day: Scalars['String'];
}>;


export type BookOfficeSpaceOnDayMutation = { __typename?: 'Mutation', bookOfficeSpaceOnDay: { __typename?: 'OfficeSpaceBooking', day: string, bookableID: string, bookableType: string } };

export type UnbookOfficeSpaceMutationVariables = Exact<{
  spaceID: Scalars['ID'];
  bookingID: Scalars['ID'];
}>;


export type UnbookOfficeSpaceMutation = { __typename?: 'Mutation', unbookOfficeSpace: boolean };

export type CheckinOfficeSpaceTodayMutationVariables = Exact<{
  spaceID: Scalars['String'];
}>;


export type CheckinOfficeSpaceTodayMutation = { __typename?: 'Mutation', checkinOfficeSpaceToday: { __typename?: 'OfficeSpaceCheckin', id: string, moment: string, checkinableID: string, checkinableType: string } };

export type RequestToBookBannerQueryVariables = Exact<{ [key: string]: never; }>;


export type RequestToBookBannerQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, role: UserRole } | null };

export type RequestBudgetIncreaseMutationVariables = Exact<{
  input: RequestBudgetIncreaseInput;
}>;


export type RequestBudgetIncreaseMutation = { __typename?: 'Mutation', requestBudgetIncrease?: boolean | null };

export type RequestToBookQueryVariables = Exact<{
  role: Scalars['String'];
  status?: InputMaybe<UserStatus>;
}>;


export type RequestToBookQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', users: Array<{ __typename?: 'OrganizationUser', userId?: string | null, role: UserRole, fullName: string, phoneNumber?: string | null, email?: string | null }> } | null } | null };

export type OffsiteOrderPage__OrderDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OffsiteOrderPage__OrderDetailsQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, totalPrice: number, subTotal: number, processingFee: number, confirmationID?: string | null, memo?: string | null, additionalNotes: string, stripeClientSecret?: string | null, status: OrderStatus, cancellable: boolean, uncancellable_reason?: string | null, currency: string, invites: Array<{ __typename?: 'OrderInvites', id: string, message: string, recipients: Array<{ __typename?: 'InviteRecipient', name: string, email: string, phoneNumber?: string | null }> }>, invitees: Array<{ __typename?: 'InviteRecipient', name: string, email: string }>, taxLine?: { __typename?: 'TaxLine', amount: number, description: string, percentage: number } | null, promotionLine?: { __typename?: 'PromotionLine', amount: number, description: string, discount: number, code?: string | null } | null, guest?: { __typename?: 'ContactInfo', fullName: string, companyName?: string | null, email?: string | null, phoneNumber?: string | null } | null, paymentDetail?: { __typename?: 'PaymentDetail', id?: string | null, receiptUrl?: string | null, paymentMethodDetails?: { __typename?: 'CardPaymentMethod', last4: string, network: string, networkLogoUrl: string } | null, billingDetails?: { __typename?: 'BillingDetails', name: string, email?: string | null, phone?: string | null, address: { __typename?: 'CardAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null } } | null } | null, orderItems: Array<{ __typename?: 'OrderItem', id: string, totalPrice: number, subTotal: number, unitPrice: number, quantity: number, details: { __typename: 'DailyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, startDate: string, endDate: string, days: number, time: string, cancellationFeeTiers?: Array<{ __typename?: 'CancellationFeeTier', refundPercentage: number, cancellationAllowedBefore?: string | null }> | null, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, inventoryCapacity: number, layouts: Array<{ __typename?: 'SpaceLayout', id: string, name: string, description: string, bestFor?: string | null, capacity: number, imageURL: string }>, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, location: { __typename?: 'Location', id: string, name: string, timezone: string } } } | { __typename: 'HourlyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, date: string, startTime: string, endTime: string, cancellationFeeTiers?: Array<{ __typename?: 'CancellationFeeTier', refundPercentage: number, cancellationAllowedBefore?: string | null }> | null, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, inventoryCapacity: number, layouts: Array<{ __typename?: 'SpaceLayout', id: string, name: string, description: string, bestFor?: string | null, capacity: number, imageURL: string }>, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, location: { __typename?: 'Location', id: string, name: string, timezone: string } } } }> } | null };

export type OffsiteOrderPage__OrderItemDetailsFragment = { __typename?: 'OrderItem', id: string, totalPrice: number, subTotal: number, unitPrice: number, quantity: number, details: { __typename: 'DailyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, startDate: string, endDate: string, days: number, time: string, cancellationFeeTiers?: Array<{ __typename?: 'CancellationFeeTier', refundPercentage: number, cancellationAllowedBefore?: string | null }> | null, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, inventoryCapacity: number, layouts: Array<{ __typename?: 'SpaceLayout', id: string, name: string, description: string, bestFor?: string | null, capacity: number, imageURL: string }>, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, location: { __typename?: 'Location', id: string, name: string, timezone: string } } } | { __typename: 'HourlyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, date: string, startTime: string, endTime: string, cancellationFeeTiers?: Array<{ __typename?: 'CancellationFeeTier', refundPercentage: number, cancellationAllowedBefore?: string | null }> | null, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, inventoryCapacity: number, layouts: Array<{ __typename?: 'SpaceLayout', id: string, name: string, description: string, bestFor?: string | null, capacity: number, imageURL: string }>, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, location: { __typename?: 'Location', id: string, name: string, timezone: string } } } };

export type OffsiteOrderPage__OrderInvitesFragment = { __typename?: 'OrderInvites', id: string, message: string, recipients: Array<{ __typename?: 'InviteRecipient', name: string, email: string, phoneNumber?: string | null }> };

export type OrderDetails__HourlyBookingDetailsFragment = { __typename?: 'HourlyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, date: string, startTime: string, endTime: string, cancellationFeeTiers?: Array<{ __typename?: 'CancellationFeeTier', refundPercentage: number, cancellationAllowedBefore?: string | null }> | null, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, inventoryCapacity: number, layouts: Array<{ __typename?: 'SpaceLayout', id: string, name: string, description: string, bestFor?: string | null, capacity: number, imageURL: string }>, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, location: { __typename?: 'Location', id: string, name: string, timezone: string } } };

export type OrderDetails__DailyBookingDetailsFragment = { __typename?: 'DailyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, startDate: string, endDate: string, days: number, time: string, cancellationFeeTiers?: Array<{ __typename?: 'CancellationFeeTier', refundPercentage: number, cancellationAllowedBefore?: string | null }> | null, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, maxCapacity: number, inventoryCapacity: number, layouts: Array<{ __typename?: 'SpaceLayout', id: string, name: string, description: string, bestFor?: string | null, capacity: number, imageURL: string }>, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, location: { __typename?: 'Location', id: string, name: string, timezone: string } } };

export type OffsiteOrderOtherSpacesQueryVariables = Exact<{
  offsiteLocationID: Scalars['ID'];
}>;


export type OffsiteOrderOtherSpacesQuery = { __typename?: 'Query', meetingRooms?: { __typename?: 'Location', id: string, name: string, spaces: Array<{ __typename?: 'Space', id: string, currency: string, name: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean, space: { __typename?: 'Space', id: string, name: string, currency: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } }> } | null, dayPasses?: { __typename?: 'Location', id: string, name: string, spaces: Array<{ __typename?: 'Space', id: string, currency: string, name: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean, space: { __typename?: 'Space', id: string, name: string, currency: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } }> } | null, privateOffices?: { __typename?: 'Location', id: string, name: string, spaces: Array<{ __typename?: 'Space', locked: boolean, id: string, currency: string, name: string, spaceType: SpaceType, maxCapacity: number, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean, space: { __typename?: 'Space', id: string, name: string, currency: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } }> } | null };

export type OffsiteOrderLocationSpaces__MeetingRoomsFragment = { __typename?: 'Location', spaces: Array<{ __typename?: 'Space', id: string, currency: string, name: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean, space: { __typename?: 'Space', id: string, name: string, currency: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } }> };

export type OffsiteOrderLocationSpaces__DayPassesFragment = { __typename?: 'Location', spaces: Array<{ __typename?: 'Space', id: string, currency: string, name: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean, space: { __typename?: 'Space', id: string, name: string, currency: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } }> };

export type OffsiteOrderLocationSpaces__PrivateOfficesFragment = { __typename?: 'Location', spaces: Array<{ __typename?: 'Space', locked: boolean, id: string, currency: string, name: string, spaceType: SpaceType, maxCapacity: number, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean, space: { __typename?: 'Space', id: string, name: string, currency: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } }> };

export type OffsiteOrderLocationSpaces__SpaceDetailsFragment = { __typename?: 'Space', id: string, currency: string, name: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean, space: { __typename?: 'Space', id: string, name: string, currency: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } };

export type OffsiteOrderLocationSpacesPhysicalSpaces__PhysicalSpaceDetailsFragment = { __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean, space: { __typename?: 'Space', id: string, name: string, currency: string, locked: boolean, spaceType: SpaceType, maxCapacity: number, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } } };

export type OffisetOrderOtherSpaces_Space_CommonsFragment = { __typename?: 'Space', maxCapacity: number, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, layouts: Array<{ __typename?: 'SpaceLayout', capacity: number }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, location: { __typename?: 'Location', amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }> } };

export type OrderPageQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderPageQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, organization?: { __typename?: 'Organization', monthlyBilling: boolean } | null } | null };

export type SpaceCheckoutCurrentUserPaymentMethodQueryVariables = Exact<{ [key: string]: never; }>;


export type SpaceCheckoutCurrentUserPaymentMethodQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, organization?: { __typename?: 'Organization', id: string, monthlyBilling: boolean } | null, paymentMethod?: { __typename?: 'CardPaymentMethod', id?: string | null, last4: string, network: string, networkLogoUrl: string } | null } | null };

export type SpaceDetailsCurrentUserPaymentMethodQueryVariables = Exact<{ [key: string]: never; }>;


export type SpaceDetailsCurrentUserPaymentMethodQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, paymentMethod?: { __typename?: 'CardPaymentMethod', id?: string | null, last4: string, network: string, networkLogoUrl: string } | null } | null };

export type CreateBookingRequestMutationVariables = Exact<{
  input: CreateBookingRequestInput;
}>;


export type CreateBookingRequestMutation = { __typename?: 'Mutation', createBookingRequest: { __typename?: 'BookingRequest', id: string } };

export type CancelBookingRequestMutationVariables = Exact<{
  input: CancelBookingRequestInput;
}>;


export type CancelBookingRequestMutation = { __typename?: 'Mutation', cancelBookingRequest: { __typename?: 'BookingRequest', id: string } };

export type UserBookingRequestsQueryVariables = Exact<{
  spaceId: Scalars['ID'];
}>;


export type UserBookingRequestsQuery = { __typename?: 'Query', space?: { __typename?: 'Space', id: string, bookingRequests?: Array<{ __typename?: 'BookingRequest', id: string, startDate: string, endDate: string, startTime?: string | null, endTime?: string | null, reason: string, status: BookingRequestStatus }> | null } | null };

export type BestDayRatesQueryVariables = Exact<{
  spaceId: Scalars['ID'];
  bookingType: BookingType;
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type BestDayRatesQuery = { __typename?: 'Query', space?: { __typename?: 'Space', bestDayRates: Array<{ __typename?: 'BestDayRates', date: string, price: number }> } | null };

export type SetFavoriteSpaceMutationVariables = Exact<{
  input: CreateFavoriteSpaceInput;
}>;


export type SetFavoriteSpaceMutation = { __typename?: 'Mutation', setFavoriteSpace: string };

export type SetFavoriteLocationMutationVariables = Exact<{
  input: CreateFavoriteLocationInput;
}>;


export type SetFavoriteLocationMutation = { __typename?: 'Mutation', setFavoriteLocation: string };

export type RemoveFavoriteMutationVariables = Exact<{
  input: RemoveFavoriteResourceInput;
}>;


export type RemoveFavoriteMutation = { __typename?: 'Mutation', removeFavoriteResource: boolean };

export type OffsiteSpacePageV2QueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OffsiteSpacePageV2Query = { __typename?: 'Query', space?: { __typename?: 'Space', id: string, name: string, partnerID?: string | null, spaceType: SpaceType, description?: string | null, defaultLayoutID: string, currency: string, locked: boolean, preferred?: boolean | null, savedByCurrentUser: boolean, inventoryCapacity: number, area?: number | null, maxCapacity: number, locationID: string, locationTimeZone: string, bookingConfig: { __typename?: 'BookingConfig', enabled: Array<BookingType>, multiDayBookingAllowed: boolean }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean }>, categories: Array<{ __typename?: 'Category', code: string, name: string, description: string }>, location: { __typename?: 'Location', id: string, name: string, timezone: string, pricingInclusion?: string | null, directions?: string | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, logo?: { __typename?: 'ImageData', url: string } | null, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', fullAddress: string, streetAddress: string, postalCode: string, country: string, city: string, state: string, latitude?: number | null, longitude?: number | null } }, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, layouts: Array<{ __typename?: 'SpaceLayout', id: string, name: string, description: string, bestFor?: string | null, capacity: number, imageURL: string }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null }, daily: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, bookingHours: Array<{ __typename?: 'BookingHour', dayOfWeek: DayOfWeek, closedAt: string, openAt: string }>, bookingPolicy: { __typename?: 'SpaceBookingPolicy', minDuration?: number | null }, spacePerks: Array<{ __typename?: 'SpacePerk', code: string, name: string, description: string, iconURL: string }> } | null };

export type OffsiteSpacePage__SpaceDetailsV2Fragment = { __typename?: 'Space', id: string, name: string, partnerID?: string | null, spaceType: SpaceType, description?: string | null, defaultLayoutID: string, currency: string, locked: boolean, preferred?: boolean | null, savedByCurrentUser: boolean, inventoryCapacity: number, area?: number | null, maxCapacity: number, locationID: string, locationTimeZone: string, bookingConfig: { __typename?: 'BookingConfig', enabled: Array<BookingType>, multiDayBookingAllowed: boolean }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean }>, categories: Array<{ __typename?: 'Category', code: string, name: string, description: string }>, location: { __typename?: 'Location', id: string, name: string, timezone: string, pricingInclusion?: string | null, directions?: string | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, logo?: { __typename?: 'ImageData', url: string } | null, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', fullAddress: string, streetAddress: string, postalCode: string, country: string, city: string, state: string, latitude?: number | null, longitude?: number | null } }, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, layouts: Array<{ __typename?: 'SpaceLayout', id: string, name: string, description: string, bestFor?: string | null, capacity: number, imageURL: string }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null }, daily: { __typename?: 'RangeType', min?: number | null, max?: number | null } }, bookingHours: Array<{ __typename?: 'BookingHour', dayOfWeek: DayOfWeek, closedAt: string, openAt: string }>, bookingPolicy: { __typename?: 'SpaceBookingPolicy', minDuration?: number | null }, spacePerks: Array<{ __typename?: 'SpacePerk', code: string, name: string, description: string, iconURL: string }> };

export type OffsitePage__PhysicalSpaceDetailsV2Fragment = { __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean };

export type OffsiteSpaceDetailsWhosHereV2QueryVariables = Exact<{
  offsiteLocationID: Scalars['ID'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type OffsiteSpaceDetailsWhosHereV2Query = { __typename?: 'Query', offsiteLocation?: { __typename?: 'Location', id: string, bookings: Array<{ __typename?: 'Booking', id: string, startDate: string, endDate: string, user: { __typename?: 'OrganizationUser', id: string, fullName: string, title?: string | null, picture?: string | null } }> } | null };

export type OffsiteSpaceDetailsWhosHere__BookingDetailsV2Fragment = { __typename?: 'Booking', id: string, startDate: string, endDate: string, user: { __typename?: 'OrganizationUser', id: string, fullName: string, title?: string | null, picture?: string | null } };

export type SpaceDetailsCurrentUserMonthlyBillingV2QueryVariables = Exact<{ [key: string]: never; }>;


export type SpaceDetailsCurrentUserMonthlyBillingV2Query = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, organization?: { __typename?: 'Organization', monthlyBilling: boolean } | null } | null };

export type CurrentUserOrganizationNameQueryVariables = Exact<{
  status?: InputMaybe<UserStatus>;
}>;


export type CurrentUserOrganizationNameQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, role: UserRole, email?: string | null, authMethod: AuthMethod, organization?: { __typename?: 'Organization', id: string, name: string, domain?: string | null, requireSSO: boolean, ssoProvider: Array<string>, logoUrl?: string | null, slug?: string | null, monthlyBilling: boolean, plan: Plan, createdAt: string, users: Array<{ __typename?: 'OrganizationUser', userId?: string | null }> } | null } | null };

export type UpdateOrganizationNameMutationVariables = Exact<{
  input: UpdateOrganizationNameInput;
}>;


export type UpdateOrganizationNameMutation = { __typename?: 'Mutation', updateOrganizationName: { __typename?: 'Organization', id: string, name: string } };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: string, name: string, domain?: string | null } };

export type RecentActivityOrdersSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type RecentActivityOrdersSummaryQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', ordersSummary?: { __typename?: 'OrdersSummary', lastUpdatedDate: string, orders: Array<{ __typename?: 'OrderSummary', orderID: string, hostFullName: string, locationName: string, spaceType?: SpaceType | null, bookingDate: string, orderCreatedAt: string }> } | null } | null } | null };

export type ReportingPageOrderSummaryFragment = { __typename?: 'OrderSummary', orderID: string, hostFullName: string, locationName: string, spaceType?: SpaceType | null, bookingDate: string, orderCreatedAt: string };

export type ReportingPageOrganizationReportingQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type ReportingPageOrganizationReportingQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', reporting?: { __typename?: 'Reporting', lastUpdatedDate: string, spend: { __typename?: 'ReportingSpend', totalSpend: number, dayPasses: { __typename?: 'ReportingValue', value: number, percentage: number }, dayOffices: { __typename?: 'ReportingValue', value: number, percentage: number }, meetingRooms: { __typename?: 'ReportingValue', value: number, percentage: number } }, bookings: { __typename?: 'ReportingBookings', totalBookings: number, dayPasses: { __typename?: 'ReportingValue', value: number, percentage: number }, dayOffices: { __typename?: 'ReportingValue', value: number, percentage: number }, meetingRooms: { __typename?: 'ReportingValue', value: number, percentage: number } }, frequency: { __typename?: 'ReportingFrequency', totalEmployees: number, zeroOrSingleBookingPerWeek: { __typename?: 'ReportingValue', value: number, percentage: number }, twoOrThreeBookingsPerWeek: { __typename?: 'ReportingValue', value: number, percentage: number }, fourOrMoreBookingsPerWeek: { __typename?: 'ReportingValue', value: number, percentage: number } }, engagement: { __typename?: 'ReportingEngagement', soloBookings: { __typename?: 'ReportingEngagementWeekBookings', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number, saturday: number, sunday: number }, teamBookings: { __typename?: 'ReportingEngagementWeekBookings', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number, saturday: number, sunday: number } } } | null } | null } | null };

export type ReportingPageReportingDataFragment = { __typename?: 'Reporting', lastUpdatedDate: string, spend: { __typename?: 'ReportingSpend', totalSpend: number, dayPasses: { __typename?: 'ReportingValue', value: number, percentage: number }, dayOffices: { __typename?: 'ReportingValue', value: number, percentage: number }, meetingRooms: { __typename?: 'ReportingValue', value: number, percentage: number } }, bookings: { __typename?: 'ReportingBookings', totalBookings: number, dayPasses: { __typename?: 'ReportingValue', value: number, percentage: number }, dayOffices: { __typename?: 'ReportingValue', value: number, percentage: number }, meetingRooms: { __typename?: 'ReportingValue', value: number, percentage: number } }, frequency: { __typename?: 'ReportingFrequency', totalEmployees: number, zeroOrSingleBookingPerWeek: { __typename?: 'ReportingValue', value: number, percentage: number }, twoOrThreeBookingsPerWeek: { __typename?: 'ReportingValue', value: number, percentage: number }, fourOrMoreBookingsPerWeek: { __typename?: 'ReportingValue', value: number, percentage: number } }, engagement: { __typename?: 'ReportingEngagement', soloBookings: { __typename?: 'ReportingEngagementWeekBookings', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number, saturday: number, sunday: number }, teamBookings: { __typename?: 'ReportingEngagementWeekBookings', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number, saturday: number, sunday: number } } };

export type ReportingPageOrganizationBudgetQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportingPageOrganizationBudgetQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', budget?: { __typename?: 'OrganizationBudget', state: OrganizationBudgetState, totalSpend: number, remaining: number, budget: number } | null } | null } | null };

export type ReportingPageBudgetDataFragment = { __typename?: 'OrganizationBudget', state: OrganizationBudgetState, totalSpend: number, remaining: number, budget: number };

export type ReportingPageOrganizationTotalSpendQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type ReportingPageOrganizationTotalSpendQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', reporting?: { __typename?: 'Reporting', spend: { __typename?: 'ReportingSpend', totalSpend: number } } | null } | null } | null };

export type ReportingPageReportingTotalFragment = { __typename?: 'Reporting', spend: { __typename?: 'ReportingSpend', totalSpend: number } };

export type UpdateOrganizationBudgetReportingBudgetCardHookMutationVariables = Exact<{
  input: UpdateOrganizationBudgetInput;
}>;


export type UpdateOrganizationBudgetReportingBudgetCardHookMutation = { __typename?: 'Mutation', updateOrganizationBudget: { __typename?: 'OrganizationBudget', budget: number } };

export type ReportingPageCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportingPageCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, organization?: { __typename?: 'Organization', monthlyBilling: boolean, paymentMode: PaymentMode, createdAt: string } | null } | null };

export type SavedSpacesQueryVariables = Exact<{ [key: string]: never; }>;


export type SavedSpacesQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, favoriteSpaces?: Array<{ __typename?: 'Space', id: string, spaceType: SpaceType, savedByCurrentUser: boolean, name: string, streetAddress: string, city: string, preferred?: boolean | null, locationName: string, numberOfVisitsByCurrentUser: number, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }> }> | null } | null };

export type SavedSpaces__SpaceDetailsFragment = { __typename?: 'Space', id: string, spaceType: SpaceType, savedByCurrentUser: boolean, name: string, streetAddress: string, city: string, preferred?: boolean | null, locationName: string, numberOfVisitsByCurrentUser: number, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }> };

export type SavedLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type SavedLocationsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, favoriteLocations?: Array<{ __typename?: 'Location', id: string, savedByCurrentUser: boolean, name: string, preferred?: boolean | null, numberOfVisitsByCurrentUser: number, address: { __typename?: 'Address', streetAddress: string, city: string, latitude?: number | null, longitude?: number | null }, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number } }> }> | null } | null };

export type SavedLocations__LocationDetailsFragment = { __typename?: 'Location', id: string, savedByCurrentUser: boolean, name: string, preferred?: boolean | null, numberOfVisitsByCurrentUser: number, address: { __typename?: 'Address', streetAddress: string, city: string, latitude?: number | null, longitude?: number | null }, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number } }> };

export type StepFinalQueryVariables = Exact<{ [key: string]: never; }>;


export type StepFinalQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, createdWith: string, createdAt?: string | null, role: UserRole, auth0PrimaryEmail: string, fullName: string, email?: string | null, organization?: { __typename?: 'Organization', id: string, name: string, createdAt: string, createdWith?: string | null } | null } | null };

export type IsEmailTakenQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type IsEmailTakenQuery = { __typename?: 'Query', isEmailTaken: boolean };

export type InviteToTeamMutationVariables = Exact<{
  input: InviteToTeamInput;
}>;


export type InviteToTeamMutation = { __typename?: 'Mutation', inviteToTeam: boolean };

export type StepInviteOthersQueryVariables = Exact<{ [key: string]: never; }>;


export type StepInviteOthersQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, organization?: { __typename?: 'Organization', id: string, name: string } | null } | null };

export type InviteByEmailQueryVariables = Exact<{
  inviteeEmail: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
}>;


export type InviteByEmailQuery = { __typename?: 'Query', inviteByEmail?: { __typename?: 'Invite', id: string, status: string, organization?: { __typename?: 'Organization', id: string, name: string, users: Array<{ __typename?: 'OrganizationUser', id: string, picture?: string | null, role: UserRole, userId?: string | null, fullName: string }> } | null } | null };

export type OrganizationByDomainQueryVariables = Exact<{
  domain: Scalars['String'];
}>;


export type OrganizationByDomainQuery = { __typename?: 'Query', organizationByDomain?: { __typename?: 'Organization', id: string, name: string, users: Array<{ __typename?: 'OrganizationUser', id: string, picture?: string | null, userId?: string | null, role: UserRole, fullName: string }> } | null };

export type StepTeamQueryVariables = Exact<{ [key: string]: never; }>;


export type StepTeamQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, auth0PrimaryEmail: string, fullName: string, organization?: { __typename?: 'Organization', id: string } | null } | null };

export type RegisterGoogleAccountToOrganizationIfExistsMutationVariables = Exact<{ [key: string]: never; }>;


export type RegisterGoogleAccountToOrganizationIfExistsMutation = { __typename?: 'Mutation', registerGoogleAccountToOrganizationIfExists: boolean };

export type TeamUserInfoCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamUserInfoCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string } | null };

export type AddCityMutationVariables = Exact<{
  input: AddCityInput;
}>;


export type AddCityMutation = { __typename?: 'Mutation', addCity: { __typename?: 'City', name?: string | null } };

export type OrgUsersQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  currentUserCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  status?: InputMaybe<UserStatus>;
}>;


export type OrgUsersQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', city?: { __typename?: 'City', name?: string | null, state?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, displayName?: string | null } | null, organization?: { __typename?: 'Organization', users: Array<{ __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null, bookings: Array<{ __typename?: 'Booking', id: string, startTime?: string | null, endTime?: string | null, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null, city?: { __typename?: 'City', name?: string | null, state?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, displayName?: string | null } | null }, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, locked: boolean, currency: string, maxCapacity: number, country: string, physicalSpacesCount: number, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, timezone: string, currentUserDistance?: number | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', city: string, state: string, streetAddress: string, latitude?: number | null, longitude?: number | null }, bookings: Array<{ __typename?: 'Booking', id: string, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null, city?: { __typename?: 'City', name?: string | null, state?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, displayName?: string | null } | null } }> }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } } }>, city?: { __typename?: 'City', name?: string | null, state?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, displayName?: string | null } | null }> } | null } | null };

export type OrgUserDetailsFragment = { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null, bookings: Array<{ __typename?: 'Booking', id: string, startTime?: string | null, endTime?: string | null, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null, city?: { __typename?: 'City', name?: string | null, state?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, displayName?: string | null } | null }, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, locked: boolean, currency: string, maxCapacity: number, country: string, physicalSpacesCount: number, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, timezone: string, currentUserDistance?: number | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', city: string, state: string, streetAddress: string, latitude?: number | null, longitude?: number | null }, bookings: Array<{ __typename?: 'Booking', id: string, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null, city?: { __typename?: 'City', name?: string | null, state?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, displayName?: string | null } | null } }> }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } } }>, city?: { __typename?: 'City', name?: string | null, state?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, displayName?: string | null } | null };

export type CityDetailsFragment = { __typename?: 'City', name?: string | null, state?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, displayName?: string | null };

export type TeamsUserDetailsFragment = { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null, city?: { __typename?: 'City', name?: string | null, state?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, displayName?: string | null } | null };

export type TeamsLocationDetailsFragment = { __typename?: 'Location', id: string, name: string, timezone: string, currentUserDistance?: number | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', city: string, state: string, streetAddress: string, latitude?: number | null, longitude?: number | null }, bookings: Array<{ __typename?: 'Booking', id: string, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null, city?: { __typename?: 'City', name?: string | null, state?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, displayName?: string | null } | null } }> };

export type TeamsSpaceDetailsFragment = { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, locked: boolean, currency: string, maxCapacity: number, country: string, physicalSpacesCount: number, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, timezone: string, currentUserDistance?: number | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', city: string, state: string, streetAddress: string, latitude?: number | null, longitude?: number | null }, bookings: Array<{ __typename?: 'Booking', id: string, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null, city?: { __typename?: 'City', name?: string | null, state?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, displayName?: string | null } | null } }> }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } };

export type TeamsBookingDetailsFragment = { __typename?: 'Booking', id: string, startTime?: string | null, endTime?: string | null, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null, city?: { __typename?: 'City', name?: string | null, state?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, displayName?: string | null } | null }, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, locked: boolean, currency: string, maxCapacity: number, country: string, physicalSpacesCount: number, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, timezone: string, currentUserDistance?: number | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', city: string, state: string, streetAddress: string, latitude?: number | null, longitude?: number | null }, bookings: Array<{ __typename?: 'Booking', id: string, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null, city?: { __typename?: 'City', name?: string | null, state?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, displayName?: string | null } | null } }> }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } } };

export type TeamUsersQueryVariables = Exact<{
  status?: InputMaybe<UserStatus>;
}>;


export type TeamUsersQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, organization?: { __typename?: 'Organization', id: string, name: string, users: Array<{ __typename?: 'OrganizationUser', id: string, userId?: string | null, role: UserRole, picture?: string | null, title?: string | null, email?: string | null, fullName: string }> } | null } | null };

export type GetOrgDataQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  currentUserCoordinates?: InputMaybe<SpaceSearchCoordinates>;
  status?: InputMaybe<UserStatus>;
}>;


export type GetOrgDataQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', users: Array<{ __typename?: 'OrganizationUser', id: string }>, bookings: Array<{ __typename?: 'Booking', id: string, startTime?: string | null, endTime?: string | null, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null, city?: { __typename?: 'City', name?: string | null, state?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, displayName?: string | null } | null }, space: { __typename?: 'Space', id: string, name: string, spaceType: SpaceType, locked: boolean, currency: string, maxCapacity: number, country: string, physicalSpacesCount: number, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, timezone: string, currentUserDistance?: number | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', city: string, state: string, streetAddress: string, latitude?: number | null, longitude?: number | null }, bookings: Array<{ __typename?: 'Booking', id: string, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null, city?: { __typename?: 'City', name?: string | null, state?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, displayName?: string | null } | null } }> }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } } }>, mostBookedSpaces: Array<{ __typename?: 'Space', id: string, name: string, spaceType: SpaceType, locked: boolean, currency: string, maxCapacity: number, country: string, physicalSpacesCount: number, amenities: Array<{ __typename?: 'Amenity', id: string, iconURL: string, name: string, code?: string | null }>, location: { __typename?: 'Location', id: string, name: string, timezone: string, currentUserDistance?: number | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, iconURL: string, code?: string | null }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, address: { __typename?: 'Address', city: string, state: string, streetAddress: string, latitude?: number | null, longitude?: number | null }, bookings: Array<{ __typename?: 'Booking', id: string, user: { __typename?: 'OrganizationUser', id: string, userId?: string | null, picture?: string | null, fullName: string, title?: string | null, email?: string | null, city?: { __typename?: 'City', name?: string | null, state?: string | null, country?: string | null, latitude?: number | null, longitude?: number | null, displayName?: string | null } | null } }> }, physicalSpaces: Array<{ __typename?: 'PhysicalSpace', id: string, name: string, floor: string, withWindow: boolean }>, images: Array<{ __typename?: 'Image', small: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, priceRanges: { __typename?: 'PriceRangesType', daily: { __typename?: 'RangeType', min?: number | null, max?: number | null }, hourly: { __typename?: 'RangeType', min?: number | null, max?: number | null } } }> } | null } | null };

export type TodayRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type TodayRequestsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', bookingRequests?: Array<{ __typename?: 'BookingRequest', id: string, startDate: string, reason: string, status: BookingRequestStatus, requester: { __typename?: 'OrganizationUser', picture?: string | null, fullName: string } }> | null } | null, groupBudget?: { __typename?: 'GroupBudget', bookingRequests?: Array<{ __typename?: 'BookingRequest', id: string, startDate: string, reason: string, status: BookingRequestStatus, requester: { __typename?: 'OrganizationUser', picture?: string | null, fullName: string } }> | null } | null } | null };

export type TodayPage__RequestDetailsFragment = { __typename?: 'BookingRequest', id: string, startDate: string, reason: string, status: BookingRequestStatus, requester: { __typename?: 'OrganizationUser', picture?: string | null, fullName: string } };

export type TodayCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type TodayCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, fullName: string } | null };

export type MenuCardListQueryVariables = Exact<{ [key: string]: never; }>;


export type MenuCardListQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, role: UserRole, groupBudgetRole?: GroupBudgetRole | null, organization?: { __typename?: 'Organization', id: string, paymentMode: PaymentMode, plan: Plan } | null } | null };

export type UserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type UserProfileQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, role: UserRole, groupBudgetRole?: GroupBudgetRole | null, groupBudget?: { __typename?: 'GroupBudget', id: string, name: string } | null, organization?: { __typename?: 'Organization', id: string, paymentMode: PaymentMode, plan: Plan } | null } | null };

export type BookingPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingPolicyQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', organization?: { __typename?: 'Organization', users: Array<{ __typename?: 'OrganizationUser', id: string, fullName: string, email?: string | null, picture?: string | null }>, budget?: { __typename?: 'OrganizationBudget', limit: number, individualLimit?: number | null, policy?: { __typename?: 'BudgetPolicy', spaceTypes: { __typename?: 'SpaceTypes', meetingRoom: boolean, dayPass: boolean, privateOffice: boolean }, locationItems?: Array<{ __typename?: 'BudgetPolicyLocationItem', id: string, distance: number, distanceUnit: BudgetPolicyLocationItemDistanceType, address: { __typename?: 'BudgetPolicyAddress', id: string, street: string } }> | null } | null } | null } | null, groupBudget?: { __typename?: 'GroupBudget', limit: number, individualLimit?: number | null, members: Array<{ __typename?: 'GroupBudgetMember', role: GroupBudgetRole, user: { __typename?: 'OrganizationUser', id: string, fullName: string, email?: string | null, picture?: string | null } }>, policy?: { __typename?: 'BudgetPolicy', spaceTypes: { __typename?: 'SpaceTypes', meetingRoom: boolean, dayPass: boolean, privateOffice: boolean }, locationItems?: Array<{ __typename?: 'BudgetPolicyLocationItem', id: string, distance: number, distanceUnit: BudgetPolicyLocationItemDistanceType, address: { __typename?: 'BudgetPolicyAddress', id: string, street: string } }> | null } | null } | null } | null };

export type PolicyFragment = { __typename?: 'BudgetPolicy', spaceTypes: { __typename?: 'SpaceTypes', meetingRoom: boolean, dayPass: boolean, privateOffice: boolean }, locationItems?: Array<{ __typename?: 'BudgetPolicyLocationItem', id: string, distance: number, distanceUnit: BudgetPolicyLocationItemDistanceType, address: { __typename?: 'BudgetPolicyAddress', id: string, street: string } }> | null };

export type UserFragment = { __typename?: 'OrganizationUser', id: string, fullName: string, email?: string | null, picture?: string | null };

export type ProfileUpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type ProfileUpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'CurrentUser', id: string, title?: string | null, hasBookedBefore: boolean, fullName: string, email?: string | null, phoneNumber?: string | null } | null };

export type ProfileCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, title?: string | null, hasBookedBefore: boolean, hasSignedUpWithSocialProvider: boolean, fullName: string, email?: string | null, phoneNumber?: string | null, organization?: { __typename?: 'Organization', id: string, name: string } | null } | null };

export type PaymentMethodQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodQuery = { __typename?: 'Query', paymentMethod?: { __typename?: 'CardPaymentMethod', id?: string | null, last4: string, network: string, networkLogoUrl: string } | null };

export type CancelOrderMutationVariables = Exact<{
  orderID: Scalars['ID'];
}>;


export type CancelOrderMutation = { __typename?: 'Mutation', cancelOrder: boolean };

export type ReservationDetailsCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type ReservationDetailsCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, organization?: { __typename?: 'Organization', monthlyBilling: boolean } | null } | null };

export type ReservationsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ReservationsPageQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', orders: Array<{ __typename?: 'Order', id: string, status: OrderStatus, orderItems: Array<{ __typename?: 'OrderItem', id: string, totalPrice: number, unitPrice: number, details: { __typename: 'DailyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, startDate: string, endDate: string, days: number, time: string, space: { __typename?: 'Space', id: string, name: string, maxCapacity: number, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, location: { __typename?: 'Location', name: string } }, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null } | { __typename: 'HourlyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, date: string, startTime: string, endTime: string, space: { __typename?: 'Space', id: string, name: string, maxCapacity: number, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, location: { __typename?: 'Location', name: string } }, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null } }> }> } | null };

export type ReservationPage__OrderDetailsFragment = { __typename?: 'Order', id: string, status: OrderStatus, orderItems: Array<{ __typename?: 'OrderItem', id: string, totalPrice: number, unitPrice: number, details: { __typename: 'DailyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, startDate: string, endDate: string, days: number, time: string, space: { __typename?: 'Space', id: string, name: string, maxCapacity: number, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, location: { __typename?: 'Location', name: string } }, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null } | { __typename: 'HourlyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, date: string, startTime: string, endTime: string, space: { __typename?: 'Space', id: string, name: string, maxCapacity: number, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, location: { __typename?: 'Location', name: string } }, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null } }> };

export type ReservationPage__OrderItemDetailsFragment = { __typename?: 'OrderItem', id: string, totalPrice: number, unitPrice: number, details: { __typename: 'DailyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, startDate: string, endDate: string, days: number, time: string, space: { __typename?: 'Space', id: string, name: string, maxCapacity: number, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, location: { __typename?: 'Location', name: string } }, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null } | { __typename: 'HourlyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, date: string, startTime: string, endTime: string, space: { __typename?: 'Space', id: string, name: string, maxCapacity: number, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, location: { __typename?: 'Location', name: string } }, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null } };

export type ReservationPage__HourlyBookingDetailsFragment = { __typename?: 'HourlyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, date: string, startTime: string, endTime: string, space: { __typename?: 'Space', id: string, name: string, maxCapacity: number, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, location: { __typename?: 'Location', name: string } }, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null };

export type ReservationPage__DailyBookingDetailsFragment = { __typename?: 'DailyBooking', id: string, spaceID: string, orderID: string, layoutID: string, physicalSpaceID: string, room: string, floor: string, cancellationAllowed: boolean, cancellationAllowedBefore?: string | null, meetingName?: string | null, arrivalTime?: string | null, startDate: string, endDate: string, days: number, time: string, space: { __typename?: 'Space', id: string, name: string, maxCapacity: number, images: Array<{ __typename?: 'Image', thumb: { __typename?: 'ImageData', url: string, width: number, height: number }, small: { __typename?: 'ImageData', url: string, width: number, height: number }, medium: { __typename?: 'ImageData', url: string, width: number, height: number }, large: { __typename?: 'ImageData', url: string, width: number, height: number } }>, pricings: Array<{ __typename?: 'Pricing', type: PricingType, price: number }>, location: { __typename?: 'Location', name: string } }, meetingContactInfo?: { __typename?: 'ContactInfo', fullName: string, email?: string | null, companyName?: string | null, phoneNumber?: string | null } | null };

export type CurrentUserAnalyticsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAnalyticsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, createdWith: string, createdAt?: string | null, role: UserRole, auth0PrimaryEmail: string, fullName: string, email?: string | null, organization?: { __typename?: 'Organization', id: string, name: string, createdAt: string, createdWith?: string | null } | null } | null };

export type LinkGoogleAccountToPasswordAccountIfExistsMutationVariables = Exact<{ [key: string]: never; }>;


export type LinkGoogleAccountToPasswordAccountIfExistsMutation = { __typename?: 'Mutation', linkGoogleAccountToPasswordAccountIfExists: boolean };

export type RegisterPasswordAccountToOrganizationIfExistsMutationVariables = Exact<{ [key: string]: never; }>;


export type RegisterPasswordAccountToOrganizationIfExistsMutation = { __typename?: 'Mutation', registerEmailAccountToOrganizationIfExists: boolean };

export type RegisterOktaAccountToOrganizationIfExistsMutationVariables = Exact<{ [key: string]: never; }>;


export type RegisterOktaAccountToOrganizationIfExistsMutation = { __typename?: 'Mutation', registerOktaAccountToOrganizationIfExists: boolean };

export type AuthLoaderQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthLoaderQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, authMethod: AuthMethod, fullName: string, email?: string | null, auth0PrimaryEmail: string, organization?: { __typename?: 'Organization', id: string, name: string } | null } | null };

export type OrgByDomainQueryVariables = Exact<{
  domain: Scalars['String'];
}>;


export type OrgByDomainQuery = { __typename?: 'Query', organizationByDomain?: { __typename?: 'Organization', id: string, name: string, requireSSO: boolean, ssoProvider: Array<string>, logoUrl?: string | null, slug?: string | null, connectionName?: string | null } | null };

export type PostAuthMutationVariables = Exact<{
  inviteId?: InputMaybe<Scalars['String']>;
}>;


export type PostAuthMutation = { __typename?: 'Mutation', postAuth: { __typename?: 'PostAuthResult', linked: boolean, orgRegistered: boolean, acceptedInvite: boolean } };

export type CurrentUserIdQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserIdQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentUser', id: string, organization?: { __typename?: 'Organization', id: string } | null } | null };

export const OffsiteLocationWhosHere__BookingDetailsFragmentDoc = gql`
    fragment OffsiteLocationWhosHere__BookingDetails on Booking {
  id
  startDate
  endDate
  user {
    id
    fullName
    title
    picture
  }
}
    `;
export const QuoteDetails__DailyBookingDetailsFragmentDoc = gql`
    fragment QuoteDetails__DailyBookingDetails on DailyBooking {
  id
  spaceID
  orderID
  layoutID
  physicalSpaceID
  room
  floor
  cancellationAllowed
  cancellationAllowedBefore
  meetingName
  arrivalTime
  startDate
  endDate
  days
  time
  space {
    id
    name
    spaceType
  }
  meetingContactInfo {
    fullName
    email
    companyName
    phoneNumber
  }
}
    `;
export const QuoteDetails__HourlyBookingDetailsFragmentDoc = gql`
    fragment QuoteDetails__HourlyBookingDetails on HourlyBooking {
  id
  spaceID
  orderID
  layoutID
  physicalSpaceID
  room
  floor
  cancellationAllowed
  cancellationAllowedBefore
  meetingName
  arrivalTime
  date
  startTime
  endTime
  space {
    id
    name
    spaceType
  }
  meetingContactInfo {
    fullName
    email
    companyName
    phoneNumber
  }
}
    `;
export const QuoteDetail__OrderItemFragmentDoc = gql`
    fragment QuoteDetail__OrderItem on OrderItem {
  id
  totalPrice
  subTotal
  unitPrice
  quantity
  details {
    __typename
    ...QuoteDetails__DailyBookingDetails
    ...QuoteDetails__HourlyBookingDetails
  }
}
    ${QuoteDetails__DailyBookingDetailsFragmentDoc}
${QuoteDetails__HourlyBookingDetailsFragmentDoc}`;
export const SpaceDetails__AllDetailsFragmentDoc = gql`
    fragment SpaceDetails__AllDetails on Space {
  id
  partnerID
  name
  spaceType
  description
  currency
  defaultLayoutID
  savedByCurrentUser
  bookingConfig {
    enabled
    multiDayBookingAllowed
  }
  categories {
    code
    name
    description
  }
  location {
    id
    name
    logo {
      url
    }
    timezone
    address {
      fullAddress
      streetAddress
      postalCode
      country
      city
      state
      latitude
      longitude
    }
    pricingInclusion
    directions
  }
  images {
    thumb {
      url
      width
      height
    }
    small {
      url
      width
      height
    }
    medium {
      url
      width
      height
    }
    large {
      url
      width
      height
    }
  }
  amenities {
    id
    name
    iconURL
    code
  }
  layouts {
    id
    name
    description
    bestFor
    capacity
    imageURL
  }
  inventoryCapacity
  area
  maxCapacity
  pricings {
    type
    price
  }
  bookingHours {
    dayOfWeek
    closedAt
    openAt
  }
  bookingPolicy {
    minDuration
  }
  locationID
  locationTimeZone
  spacePerks {
    code
    name
    description
    iconURL
  }
}
    `;
export const CurrentUser__MainDetailsFragmentDoc = gql`
    fragment CurrentUser__MainDetails on CurrentUser {
  id
  role
  fullName
  email
  phoneNumber
  title
  auth0PrimaryEmail
  auth0PrimaryEmailVerified
  paymentCustomerID
  picture
  hasSignedUpWithSocialProvider
  hasBookedBefore
  createdWith
}
    `;
export const CurrentUser__PromotionsFragmentDoc = gql`
    fragment CurrentUser__Promotions on CurrentUser {
  promotions {
    id
    promotionCode
    promotionKind
    description
    longDescription
  }
}
    `;
export const CurrentUser__OrganizationFragmentDoc = gql`
    fragment CurrentUser__Organization on CurrentUser {
  organization {
    id
    name
    domain
    monthlyBilling
    createdAt
    paymentMode
    createdWith
  }
}
    `;
export const BookingDetails_SpaceDetailsFragmentDoc = gql`
    fragment BookingDetails_SpaceDetails on Space {
  id
  name
  partnerID
  spaceType
  description
  location {
    name
    amenities {
      id
      name
      iconURL
      code
    }
    images {
      small {
        url
        width
        height
      }
      medium {
        url
        width
        height
      }
      large {
        url
        width
        height
      }
    }
    address {
      fullAddress
      latitude
      longitude
    }
    directions
  }
  images {
    small {
      url
      width
      height
    }
    medium {
      url
      width
      height
    }
    large {
      url
      width
      height
    }
  }
  amenities {
    id
    name
    iconURL
    code
  }
  preferred
  maxCapacity
  bookingHours {
    dayOfWeek
    closedAt
    openAt
  }
}
    `;
export const BookingDetails__HourlyBookingDetailsFragmentDoc = gql`
    fragment BookingDetails__HourlyBookingDetails on HourlyBooking {
  id
  spaceID
  orderID
  layoutID
  physicalSpaceID
  room
  floor
  cancellationAllowed
  cancellationAllowedBefore
  meetingName
  arrivalTime
  date
  startTime
  endTime
  meetingContactInfo {
    fullName
    email
    companyName
    phoneNumber
  }
  space {
    ...BookingDetails_SpaceDetails
  }
}
    ${BookingDetails_SpaceDetailsFragmentDoc}`;
export const BookingDetails__DailyBookingDetailsFragmentDoc = gql`
    fragment BookingDetails__DailyBookingDetails on DailyBooking {
  id
  spaceID
  orderID
  layoutID
  physicalSpaceID
  room
  floor
  cancellationAllowed
  cancellationAllowedBefore
  meetingName
  arrivalTime
  startDate
  endDate
  days
  time
  meetingContactInfo {
    fullName
    email
    companyName
    phoneNumber
  }
  space {
    ...BookingDetails_SpaceDetails
  }
}
    ${BookingDetails_SpaceDetailsFragmentDoc}`;
export const BookingDetails__OrderItemDetailsFragmentDoc = gql`
    fragment BookingDetails__OrderItemDetails on OrderItem {
  id
  totalPrice
  subTotal
  unitPrice
  quantity
  details {
    __typename
    ...BookingDetails__HourlyBookingDetails
    ...BookingDetails__DailyBookingDetails
  }
}
    ${BookingDetails__HourlyBookingDetailsFragmentDoc}
${BookingDetails__DailyBookingDetailsFragmentDoc}`;
export const BookingRequests__RequestDetailsFragmentDoc = gql`
    fragment BookingRequests__RequestDetails on BookingRequest {
  id
  amount
  currency
  createdAt
  bookedAt
  startDate
  status
  reason
  reviewerNote
  reviewedAt
  requesterTotalSpend(startDate: $requesterStartDate, endDate: $requesterEndDate)
  requester {
    id
    fullName
    bookingRequests(startDate: $requesterStartDate, endDate: $requesterEndDate) {
      status
    }
    groupBudget {
      id
      limit
      individualLimit
    }
  }
  reviewer {
    fullName
  }
  space {
    id
    name
    location {
      name
    }
    spaceType
  }
  groupBudget {
    name
    id
  }
  organizationBudget {
    id
  }
}
    `;
export const BookingRequests__CurrentUserFragmentDoc = gql`
    fragment BookingRequests__CurrentUser on CurrentUser {
  id
  role
  organization {
    id
    name
    budget {
      limit
      individualLimit
    }
    bookingRequests {
      ...BookingRequests__RequestDetails
    }
  }
}
    ${BookingRequests__RequestDetailsFragmentDoc}`;
export const BudgetBookingRequests__CurrentUserFragmentDoc = gql`
    fragment BudgetBookingRequests__CurrentUser on CurrentUser {
  id
  role
  organization {
    id
    name
  }
  groupBudget {
    id
    name
    bookingRequests {
      ...BookingRequests__RequestDetails
    }
  }
}
    ${BookingRequests__RequestDetailsFragmentDoc}`;
export const Bookings__DailyBookingDetailsFragmentDoc = gql`
    fragment Bookings__DailyBookingDetails on DailyBooking {
  startDate
  endDate
  space {
    id
    name
    spaceType
    maxCapacity
    preferred
    images {
      medium {
        url
      }
    }
    location {
      id
      address {
        streetAddress
        city
        state
        latitude
        longitude
      }
      name
    }
  }
}
    `;
export const Bookings__HourlyBookingDetailsFragmentDoc = gql`
    fragment Bookings__HourlyBookingDetails on HourlyBooking {
  date
  startTime
  endTime
  space {
    id
    name
    spaceType
    maxCapacity
    preferred
    inventoryCapacity
    images {
      medium {
        url
      }
    }
    location {
      id
      address {
        streetAddress
        city
        state
        latitude
        longitude
      }
      name
    }
  }
}
    `;
export const Bookings__OrderItemDetailsFragmentDoc = gql`
    fragment Bookings__OrderItemDetails on OrderItem {
  details {
    __typename
    ...Bookings__DailyBookingDetails
    ...Bookings__HourlyBookingDetails
  }
}
    ${Bookings__DailyBookingDetailsFragmentDoc}
${Bookings__HourlyBookingDetailsFragmentDoc}`;
export const Bookings__OrderDetailsFragmentDoc = gql`
    fragment Bookings__OrderDetails on Order {
  id
  status
  confirmationID
  invitees {
    name
  }
  orderItems {
    ...Bookings__OrderItemDetails
  }
}
    ${Bookings__OrderItemDetailsFragmentDoc}`;
export const InviteesRemaining__DailyBookingDetailsFragmentDoc = gql`
    fragment InviteesRemaining__DailyBookingDetails on DailyBooking {
  space {
    maxCapacity
  }
}
    `;
export const InviteesRemaining__HourlyBookingDetailsFragmentDoc = gql`
    fragment InviteesRemaining__HourlyBookingDetails on HourlyBooking {
  space {
    maxCapacity
  }
}
    `;
export const BudgetDetail__ReportingFragmentDoc = gql`
    fragment BudgetDetail__Reporting on Reporting {
  spend {
    totalSpend
    dayPasses {
      value
      percentage
    }
    dayOffices {
      value
      percentage
    }
    meetingRooms {
      value
      percentage
    }
  }
  bookings {
    totalBookings
    dayPasses {
      value
      percentage
    }
    dayOffices {
      value
      percentage
    }
    meetingRooms {
      value
      percentage
    }
  }
  frequency {
    totalEmployees
    zeroOrSingleBookingPerWeek {
      value
      percentage
    }
    twoOrThreeBookingsPerWeek {
      value
      percentage
    }
    fourOrMoreBookingsPerWeek {
      value
      percentage
    }
  }
  engagement {
    soloBookings {
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
    }
    teamBookings {
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
    }
  }
  lastUpdatedDate
}
    `;
export const Location_Preview_Space_CommonsFragmentDoc = gql`
    fragment Location_Preview_Space_Commons on Space {
  pricings {
    type
    price
  }
  priceRanges {
    daily {
      min
      max
    }
    hourly {
      min
      max
    }
  }
  layouts {
    capacity
  }
  maxCapacity
  images {
    small {
      url
      width
      height
    }
  }
  location {
    amenities {
      id
      name
      iconURL
      code
    }
  }
}
    `;
export const LocationPreviewCardLocationSpaces__SpaceDetailsFragmentDoc = gql`
    fragment LocationPreviewCardLocationSpaces__SpaceDetails on Space {
  id
  currency
  name
  locked
  spaceType
  amenities {
    id
    name
    iconURL
    code
  }
  ...Location_Preview_Space_Commons
}
    ${Location_Preview_Space_CommonsFragmentDoc}`;
export const LocationPreviewCardLocationSpaces__LocationDetailsFragmentDoc = gql`
    fragment LocationPreviewCardLocationSpaces__LocationDetails on Location {
  spaces(spaceType: MeetingRoom, filter: $filter) {
    ...LocationPreviewCardLocationSpaces__SpaceDetails
  }
}
    ${LocationPreviewCardLocationSpaces__SpaceDetailsFragmentDoc}`;
export const LocationPreviewCardLocationSpaces__DayPassLocationDetailsFragmentDoc = gql`
    fragment LocationPreviewCardLocationSpaces__DayPassLocationDetails on Location {
  spaces(spaceType: DayPass, filter: $dayPassFilter) {
    ...LocationPreviewCardLocationSpaces__SpaceDetails
  }
}
    ${LocationPreviewCardLocationSpaces__SpaceDetailsFragmentDoc}`;
export const LocationPreviewCardLocationPhysicalSpaces__PhysicalSpaceDetailsFragmentDoc = gql`
    fragment LocationPreviewCardLocationPhysicalSpaces__PhysicalSpaceDetails on PhysicalSpace {
  id
  name
  floor
  withWindow
  space {
    id
    name
    currency
    locked
    spaceType
    amenities {
      id
      name
      iconURL
      code
    }
    ...Location_Preview_Space_Commons
  }
}
    ${Location_Preview_Space_CommonsFragmentDoc}`;
export const LocationPreviewCardLocationPhysicalSpaces__SpaceDetailsFragmentDoc = gql`
    fragment LocationPreviewCardLocationPhysicalSpaces__SpaceDetails on Space {
  id
  name
  physicalSpaces {
    ...LocationPreviewCardLocationPhysicalSpaces__PhysicalSpaceDetails
  }
}
    ${LocationPreviewCardLocationPhysicalSpaces__PhysicalSpaceDetailsFragmentDoc}`;
export const LocationPreviewCardLocationPhysicalSpaces__LocationDetailsFragmentDoc = gql`
    fragment LocationPreviewCardLocationPhysicalSpaces__LocationDetails on Location {
  spaces(spaceType: DayOffice, filter: $filter) {
    locked
    ...LocationPreviewCardLocationPhysicalSpaces__SpaceDetails
  }
}
    ${LocationPreviewCardLocationPhysicalSpaces__SpaceDetailsFragmentDoc}`;
export const LocationPreview__LocationSpacesFragmentDoc = gql`
    fragment LocationPreview__LocationSpaces on Location {
  id
  name
  timezone
  address {
    fullAddress
    streetAddress
    city
    latitude
    longitude
  }
  images {
    small {
      url
      width
      height
    }
  }
}
    `;
export const RecommendedSpaceListLocationDetail_FragmentFragmentDoc = gql`
    fragment RecommendedSpaceListLocationDetail_Fragment on Location {
  id
  name
  timezone
  centerMapDistance: distance(coordinates: $centerMapCoordinates)
  currentUserDistance: distance(coordinates: $currentUserCoordinates)
  amenities {
    id
    name
    iconURL
    code
  }
  bookings(startDate: $bookingsDate, endDate: $bookingsDate) {
    id
    startTime
    endTime
    user {
      id
      userId
      picture
      fullName
      title
      email
    }
  }
  images {
    small {
      url
      width
      height
    }
  }
  address {
    city
    streetAddress
    latitude
    longitude
  }
}
    `;
export const RecommendedSpaceList_FragmentFragmentDoc = gql`
    fragment RecommendedSpaceList_Fragment on Space {
  id
  name
  currency
  locked
  savedByCurrentUser
  maxCapacity
  amenities {
    id
    name
    iconURL
    code
  }
  location {
    ...RecommendedSpaceListLocationDetail_Fragment
  }
  physicalSpacesCount
  physicalSpaces(first: 1) {
    id
    name
    floor
    withWindow
  }
  images {
    small {
      url
      width
      height
    }
  }
  pricings {
    type
    price
  }
  priceRanges {
    daily {
      min
      max
    }
    hourly {
      min
      max
    }
  }
}
    ${RecommendedSpaceListLocationDetail_FragmentFragmentDoc}`;
export const RecommendedLocationList_FragmentFragmentDoc = gql`
    fragment RecommendedLocationList_Fragment on Location {
  id
  name
  timezone
  savedByCurrentUser
  amenities {
    id
    name
    iconURL
    code
  }
  images {
    small {
      url
      width
      height
    }
  }
  address {
    city
    streetAddress
    latitude
    longitude
  }
}
    `;
export const HomePage__LocationDetailsFragmentDoc = gql`
    fragment HomePage__LocationDetails on Location {
  id
  name
  timezone
  centerMapDistance: distance(coordinates: $centerMapCoordinates)
  currentUserDistance: distance(coordinates: $currentUserCoordinates)
  bookings(startDate: $bookingsDate, endDate: $bookingsDate) {
    id
    startTime
    endTime
    user {
      id
      userId
      picture
      fullName
      title
      email
    }
  }
  amenities {
    id
    name
    iconURL
    code
  }
  images {
    small {
      url
      width
      height
    }
  }
  address {
    city
    streetAddress
    latitude
    longitude
  }
}
    `;
export const HomePage__SpaceDetailsFragmentDoc = gql`
    fragment HomePage__SpaceDetails on Space {
  id
  name
  currency
  maxCapacity
  locked
  preferred
  savedByCurrentUser
  amenities {
    id
    iconURL
    name
    code
  }
  location {
    ...HomePage__LocationDetails
  }
  physicalSpacesCount
  physicalSpaces(first: 1) {
    id
    name
    floor
    withWindow
  }
  images {
    small {
      url
      width
      height
    }
  }
  pricings {
    type
    price
  }
  priceRanges {
    daily {
      min
      max
    }
    hourly {
      min
      max
    }
  }
}
    ${HomePage__LocationDetailsFragmentDoc}`;
export const HomePageLocations__LocationDetailsFragmentDoc = gql`
    fragment HomePageLocations__LocationDetails on Location {
  id
  name
  timezone
  savedByCurrentUser
  preferred
  centerMapDistance: distance(coordinates: $centerMapCoordinates)
  amenities {
    id
    name
    iconURL
    code
  }
  images {
    small {
      url
      width
      height
    }
  }
  address {
    city
    streetAddress
    latitude
    longitude
  }
}
    `;
export const SpaceLocationDetailFragmentDoc = gql`
    fragment SpaceLocationDetail on Location {
  id
  name
  preferred
  currentUserDistance: distance(coordinates: $currentUserCoordinates)
  images {
    small {
      url
    }
    medium {
      url
    }
  }
  address {
    city
    streetAddress
    latitude
    longitude
  }
}
    `;
export const BookingSpaceDetailFragmentDoc = gql`
    fragment BookingSpaceDetail on Space {
  id
  name
  spaceType
  maxCapacity
  locked
  preferred
  amenities(mapNavigationFeatureFlag: true) {
    id
    iconURL
    name
    code
  }
  location {
    ...SpaceLocationDetail
  }
  physicalSpaces(first: 1) {
    id
  }
  images {
    small {
      url
    }
  }
  currency
  pricings {
    type
    price
  }
  priceRanges {
    daily {
      min
      max
    }
    hourly {
      min
      max
    }
  }
}
    ${SpaceLocationDetailFragmentDoc}`;
export const OrgBookingFragmentDoc = gql`
    fragment OrgBooking on Booking {
  id
  user {
    id
    userId
    picture
    fullName
  }
  space {
    ...BookingSpaceDetail
  }
}
    ${BookingSpaceDetailFragmentDoc}`;
export const OrderItemDailyBookingDetailFragmentDoc = gql`
    fragment OrderItemDailyBookingDetail on DailyBooking {
  startDate
  endDate
  space {
    ...BookingSpaceDetail
  }
}
    ${BookingSpaceDetailFragmentDoc}`;
export const OrderItemHourlyBookingDetailFragmentDoc = gql`
    fragment OrderItemHourlyBookingDetail on HourlyBooking {
  date
  startTime
  endTime
  space {
    ...BookingSpaceDetail
  }
}
    ${BookingSpaceDetailFragmentDoc}`;
export const CurrentUserOrderFragmentDoc = gql`
    fragment CurrentUserOrder on Order {
  id
  status
  confirmationID
  invites {
    recipients {
      name
      email
    }
  }
  orderItems {
    details {
      __typename
      ...OrderItemDailyBookingDetail
      ...OrderItemHourlyBookingDetail
    }
  }
}
    ${OrderItemDailyBookingDetailFragmentDoc}
${OrderItemHourlyBookingDetailFragmentDoc}`;
export const LocationDetails__SpacePriceDetailsFragmentDoc = gql`
    fragment LocationDetails__SpacePriceDetails on Space {
  currency
  pricings {
    type
    price
  }
  priceRanges {
    daily {
      min
      max
    }
    hourly {
      min
      max
    }
  }
}
    `;
export const LocationDetails__SpaceDetailsFragmentDoc = gql`
    fragment LocationDetails__SpaceDetails on Space {
  id
  name
  locked
  maxCapacity
  images {
    small {
      url
    }
  }
  amenities {
    id
    name
  }
  ...LocationDetails__SpacePriceDetails
}
    ${LocationDetails__SpacePriceDetailsFragmentDoc}`;
export const LocationDetails__LocationFragmentDoc = gql`
    fragment LocationDetails__Location on Location {
  id
  name
  directions
  description
  savedByCurrentUser
  preferred
  distance
  images {
    small {
      url
      width
      height
    }
    medium {
      url
      width
      height
    }
    large {
      url
      width
      height
    }
  }
  amenities {
    id
    name
    iconURL
    code
  }
  address {
    fullAddress
    latitude
    longitude
    city
    streetAddress
  }
  bookingHours {
    dayOfWeek
    closedAt
    openAt
  }
}
    `;
export const LocationDetails__SpaceTypePolicyFragmentDoc = gql`
    fragment LocationDetails__SpaceTypePolicy on SpaceTypes {
  meetingRoom
  dayPass
  privateOffice
}
    `;
export const ManageUsers__UserDetailsFragmentDoc = gql`
    fragment ManageUsers__UserDetails on OrganizationUser {
  userId
  id
  role
  picture
  title
  email
  fullName
}
    `;
export const OfficePage__OfficeSpaceBookingDetailsFragmentDoc = gql`
    fragment OfficePage__OfficeSpaceBookingDetails on OfficeSpaceBooking {
  id
  day
  bookableID
  bookableType
  user {
    id
    name
    title
    avatar
  }
}
    `;
export const OfficePage__OfficeSpaceCheckinDetailsFragmentDoc = gql`
    fragment OfficePage__OfficeSpaceCheckinDetails on OfficeSpaceCheckin {
  id
  moment
  checkinableID
  checkinableType
  user {
    id
    name
    title
    avatar
  }
}
    `;
export const OfficePage__OfficeSpaceBookingsFragmentDoc = gql`
    fragment OfficePage__OfficeSpaceBookings on OfficeSpace {
  id
  capacity
  bookings(startDate: $startDate, endDate: $endDate) {
    ...OfficePage__OfficeSpaceBookingDetails
  }
  checkins {
    ...OfficePage__OfficeSpaceCheckinDetails
  }
}
    ${OfficePage__OfficeSpaceBookingDetailsFragmentDoc}
${OfficePage__OfficeSpaceCheckinDetailsFragmentDoc}`;
export const OfficePage__OfficeSpaceDetailsFragmentDoc = gql`
    fragment OfficePage__OfficeSpaceDetails on OfficeSpace {
  id
  capacity
  office {
    address {
      latitude
      longitude
    }
    timeZone
  }
  content {
    id
    title
    description
    images {
      large {
        url
        width
        height
      }
      small {
        url
        width
        height
      }
      medium {
        url
        width
        height
      }
    }
  }
}
    `;
export const CancellationFeeTier__DetailsFragmentDoc = gql`
    fragment CancellationFeeTier__Details on CancellationFeeTier {
  refundPercentage
  cancellationAllowedBefore
}
    `;
export const OrderDetails__DailyBookingDetailsFragmentDoc = gql`
    fragment OrderDetails__DailyBookingDetails on DailyBooking {
  id
  spaceID
  orderID
  layoutID
  physicalSpaceID
  room
  floor
  cancellationAllowed
  cancellationAllowedBefore
  cancellationFeeTiers {
    ...CancellationFeeTier__Details
  }
  meetingName
  arrivalTime
  startDate
  endDate
  days
  time
  meetingContactInfo {
    fullName
    email
    companyName
    phoneNumber
  }
  space {
    id
    name
    spaceType
    maxCapacity
    layouts {
      id
      name
      description
      bestFor
      capacity
      imageURL
    }
    inventoryCapacity
    images {
      thumb {
        url
        width
        height
      }
      small {
        url
        width
        height
      }
      medium {
        url
        width
        height
      }
      large {
        url
        width
        height
      }
    }
    pricings {
      type
      price
    }
    location {
      id
      name
      timezone
    }
  }
}
    ${CancellationFeeTier__DetailsFragmentDoc}`;
export const OrderDetails__HourlyBookingDetailsFragmentDoc = gql`
    fragment OrderDetails__HourlyBookingDetails on HourlyBooking {
  id
  spaceID
  orderID
  layoutID
  physicalSpaceID
  room
  floor
  cancellationAllowed
  cancellationAllowedBefore
  cancellationFeeTiers {
    ...CancellationFeeTier__Details
  }
  meetingName
  arrivalTime
  date
  startTime
  endTime
  meetingContactInfo {
    fullName
    email
    companyName
    phoneNumber
  }
  space {
    id
    name
    spaceType
    maxCapacity
    layouts {
      id
      name
      description
      bestFor
      capacity
      imageURL
    }
    inventoryCapacity
    images {
      thumb {
        url
        width
        height
      }
      small {
        url
        width
        height
      }
      medium {
        url
        width
        height
      }
      large {
        url
        width
        height
      }
    }
    pricings {
      type
      price
    }
    location {
      id
      name
      timezone
    }
  }
}
    ${CancellationFeeTier__DetailsFragmentDoc}`;
export const OffsiteOrderPage__OrderItemDetailsFragmentDoc = gql`
    fragment OffsiteOrderPage__OrderItemDetails on OrderItem {
  id
  totalPrice
  subTotal
  unitPrice
  quantity
  details {
    __typename
    ...OrderDetails__DailyBookingDetails
    ...OrderDetails__HourlyBookingDetails
  }
}
    ${OrderDetails__DailyBookingDetailsFragmentDoc}
${OrderDetails__HourlyBookingDetailsFragmentDoc}`;
export const OffsiteOrderPage__OrderInvitesFragmentDoc = gql`
    fragment OffsiteOrderPage__OrderInvites on OrderInvites {
  id
  message
  recipients {
    name
    email
    phoneNumber
  }
}
    `;
export const OffisetOrderOtherSpaces_Space_CommonsFragmentDoc = gql`
    fragment OffisetOrderOtherSpaces_Space_Commons on Space {
  pricings {
    type
    price
  }
  priceRanges {
    daily {
      min
      max
    }
    hourly {
      min
      max
    }
  }
  layouts {
    capacity
  }
  maxCapacity
  images {
    small {
      url
      width
      height
    }
  }
  location {
    amenities {
      id
      name
      iconURL
      code
    }
  }
}
    `;
export const OffsiteOrderLocationSpacesPhysicalSpaces__PhysicalSpaceDetailsFragmentDoc = gql`
    fragment OffsiteOrderLocationSpacesPhysicalSpaces__PhysicalSpaceDetails on PhysicalSpace {
  id
  name
  floor
  withWindow
  space {
    id
    name
    currency
    locked
    spaceType
    amenities {
      id
      name
      iconURL
      code
    }
    ...OffisetOrderOtherSpaces_Space_Commons
  }
}
    ${OffisetOrderOtherSpaces_Space_CommonsFragmentDoc}`;
export const OffsiteOrderLocationSpaces__SpaceDetailsFragmentDoc = gql`
    fragment OffsiteOrderLocationSpaces__SpaceDetails on Space {
  id
  currency
  name
  locked
  spaceType
  physicalSpaces {
    ...OffsiteOrderLocationSpacesPhysicalSpaces__PhysicalSpaceDetails
  }
  amenities {
    id
    name
    iconURL
    code
  }
  ...OffisetOrderOtherSpaces_Space_Commons
}
    ${OffsiteOrderLocationSpacesPhysicalSpaces__PhysicalSpaceDetailsFragmentDoc}
${OffisetOrderOtherSpaces_Space_CommonsFragmentDoc}`;
export const OffsiteOrderLocationSpaces__MeetingRoomsFragmentDoc = gql`
    fragment OffsiteOrderLocationSpaces__MeetingRooms on Location {
  spaces(spaceType: MeetingRoom) {
    ...OffsiteOrderLocationSpaces__SpaceDetails
  }
}
    ${OffsiteOrderLocationSpaces__SpaceDetailsFragmentDoc}`;
export const OffsiteOrderLocationSpaces__DayPassesFragmentDoc = gql`
    fragment OffsiteOrderLocationSpaces__DayPasses on Location {
  spaces(spaceType: DayPass) {
    ...OffsiteOrderLocationSpaces__SpaceDetails
  }
}
    ${OffsiteOrderLocationSpaces__SpaceDetailsFragmentDoc}`;
export const OffsiteOrderLocationSpaces__PrivateOfficesFragmentDoc = gql`
    fragment OffsiteOrderLocationSpaces__PrivateOffices on Location {
  spaces(spaceType: DayOffice) {
    locked
    ...OffsiteOrderLocationSpaces__SpaceDetails
  }
}
    ${OffsiteOrderLocationSpaces__SpaceDetailsFragmentDoc}`;
export const OffsitePage__PhysicalSpaceDetailsV2FragmentDoc = gql`
    fragment OffsitePage__PhysicalSpaceDetailsV2 on PhysicalSpace {
  id
  name
  floor
  withWindow
}
    `;
export const OffsiteSpacePage__SpaceDetailsV2FragmentDoc = gql`
    fragment OffsiteSpacePage__SpaceDetailsV2 on Space {
  id
  name
  partnerID
  spaceType
  description
  defaultLayoutID
  currency
  locked
  preferred
  savedByCurrentUser
  bookingConfig {
    enabled
    multiDayBookingAllowed
  }
  physicalSpaces {
    ...OffsitePage__PhysicalSpaceDetailsV2
  }
  categories {
    code
    name
    description
  }
  location {
    id
    name
    amenities {
      id
      name
      iconURL
      code
    }
    logo {
      url
    }
    images {
      thumb {
        url
        width
        height
      }
      small {
        url
        width
        height
      }
      medium {
        url
        width
        height
      }
      large {
        url
        width
        height
      }
    }
    timezone
    address {
      fullAddress
      streetAddress
      postalCode
      country
      city
      state
      latitude
      longitude
    }
    pricingInclusion
    directions
  }
  images {
    thumb {
      url
      width
      height
    }
    small {
      url
      width
      height
    }
    medium {
      url
      width
      height
    }
    large {
      url
      width
      height
    }
  }
  amenities {
    id
    name
    iconURL
    code
  }
  layouts {
    id
    name
    description
    bestFor
    capacity
    imageURL
  }
  inventoryCapacity
  area
  maxCapacity
  pricings {
    type
    price
  }
  priceRanges {
    hourly {
      min
      max
    }
    daily {
      min
      max
    }
  }
  bookingHours {
    dayOfWeek
    closedAt
    openAt
  }
  bookingPolicy {
    minDuration
  }
  locationID
  locationTimeZone
  spacePerks {
    code
    name
    description
    iconURL
  }
}
    ${OffsitePage__PhysicalSpaceDetailsV2FragmentDoc}`;
export const OffsiteSpaceDetailsWhosHere__BookingDetailsV2FragmentDoc = gql`
    fragment OffsiteSpaceDetailsWhosHere__BookingDetailsV2 on Booking {
  id
  startDate
  endDate
  user {
    id
    fullName
    title
    picture
  }
}
    `;
export const ReportingPageOrderSummaryFragmentDoc = gql`
    fragment ReportingPageOrderSummary on OrderSummary {
  orderID
  hostFullName
  locationName
  spaceType
  bookingDate
  orderCreatedAt
}
    `;
export const ReportingPageReportingDataFragmentDoc = gql`
    fragment ReportingPageReportingData on Reporting {
  spend {
    totalSpend
    dayPasses {
      value
      percentage
    }
    dayOffices {
      value
      percentage
    }
    meetingRooms {
      value
      percentage
    }
  }
  bookings {
    totalBookings
    dayPasses {
      value
      percentage
    }
    dayOffices {
      value
      percentage
    }
    meetingRooms {
      value
      percentage
    }
  }
  frequency {
    totalEmployees
    zeroOrSingleBookingPerWeek {
      value
      percentage
    }
    twoOrThreeBookingsPerWeek {
      value
      percentage
    }
    fourOrMoreBookingsPerWeek {
      value
      percentage
    }
  }
  engagement {
    soloBookings {
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
    }
    teamBookings {
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
    }
  }
  lastUpdatedDate
}
    `;
export const ReportingPageBudgetDataFragmentDoc = gql`
    fragment ReportingPageBudgetData on OrganizationBudget {
  state
  totalSpend
  remaining
  budget
}
    `;
export const ReportingPageReportingTotalFragmentDoc = gql`
    fragment ReportingPageReportingTotal on Reporting {
  spend {
    totalSpend
  }
}
    `;
export const SavedSpaces__SpaceDetailsFragmentDoc = gql`
    fragment SavedSpaces__SpaceDetails on Space {
  id
  spaceType
  savedByCurrentUser
  name
  streetAddress
  city
  preferred
  locationName
  numberOfVisitsByCurrentUser
  images {
    small {
      url
      width
      height
    }
  }
}
    `;
export const SavedLocations__LocationDetailsFragmentDoc = gql`
    fragment SavedLocations__LocationDetails on Location {
  id
  savedByCurrentUser
  name
  preferred
  numberOfVisitsByCurrentUser
  address {
    streetAddress
    city
    latitude
    longitude
  }
  images {
    small {
      url
      width
      height
    }
    medium {
      url
      width
      height
    }
  }
}
    `;
export const CityDetailsFragmentDoc = gql`
    fragment CityDetails on City {
  name
  state
  country
  latitude
  longitude
  displayName
}
    `;
export const TeamsUserDetailsFragmentDoc = gql`
    fragment TeamsUserDetails on OrganizationUser {
  id
  userId
  picture
  fullName
  title
  email
  city {
    ...CityDetails
  }
}
    ${CityDetailsFragmentDoc}`;
export const TeamsLocationDetailsFragmentDoc = gql`
    fragment TeamsLocationDetails on Location {
  id
  name
  timezone
  currentUserDistance: distance(coordinates: $currentUserCoordinates)
  amenities {
    id
    name
    iconURL
    code
  }
  images {
    small {
      url
      width
      height
    }
  }
  address {
    city
    state
    streetAddress
    latitude
    longitude
  }
  bookings(startDate: $startDate, endDate: $endDate) {
    id
    user {
      ...TeamsUserDetails
    }
  }
}
    ${TeamsUserDetailsFragmentDoc}`;
export const TeamsSpaceDetailsFragmentDoc = gql`
    fragment TeamsSpaceDetails on Space {
  id
  name
  spaceType
  locked
  currency
  maxCapacity
  amenities {
    id
    iconURL
    name
    code
  }
  country
  location {
    ...TeamsLocationDetails
  }
  physicalSpacesCount
  physicalSpaces(first: 1) {
    id
    name
    floor
    withWindow
  }
  images {
    small {
      url
      width
      height
    }
  }
  pricings {
    type
    price
  }
  priceRanges {
    daily {
      min
      max
    }
    hourly {
      min
      max
    }
  }
}
    ${TeamsLocationDetailsFragmentDoc}`;
export const TeamsBookingDetailsFragmentDoc = gql`
    fragment TeamsBookingDetails on Booking {
  id
  user {
    ...TeamsUserDetails
  }
  space {
    ...TeamsSpaceDetails
  }
  startTime
  endTime
}
    ${TeamsUserDetailsFragmentDoc}
${TeamsSpaceDetailsFragmentDoc}`;
export const OrgUserDetailsFragmentDoc = gql`
    fragment OrgUserDetails on OrganizationUser {
  ...TeamsUserDetails
  bookings(startDate: $startDate, endDate: $endDate) {
    ...TeamsBookingDetails
  }
}
    ${TeamsUserDetailsFragmentDoc}
${TeamsBookingDetailsFragmentDoc}`;
export const TodayPage__RequestDetailsFragmentDoc = gql`
    fragment TodayPage__RequestDetails on BookingRequest {
  id
  startDate
  reason
  status
  requester {
    picture
    fullName
  }
}
    `;
export const PolicyFragmentDoc = gql`
    fragment Policy on BudgetPolicy {
  spaceTypes {
    meetingRoom
    dayPass
    privateOffice
  }
  locationItems {
    id
    distance
    distanceUnit
    address {
      id
      street
    }
  }
}
    `;
export const UserFragmentDoc = gql`
    fragment User on OrganizationUser {
  id
  fullName
  email
  picture
}
    `;
export const ReservationPage__HourlyBookingDetailsFragmentDoc = gql`
    fragment ReservationPage__HourlyBookingDetails on HourlyBooking {
  space {
    id
    name
    maxCapacity
    images {
      thumb {
        url
        width
        height
      }
      small {
        url
        width
        height
      }
      medium {
        url
        width
        height
      }
      large {
        url
        width
        height
      }
    }
    pricings {
      type
      price
    }
    location {
      name
    }
  }
  id
  spaceID
  orderID
  layoutID
  physicalSpaceID
  room
  floor
  cancellationAllowed
  cancellationAllowedBefore
  meetingName
  arrivalTime
  date
  startTime
  endTime
  meetingContactInfo {
    fullName
    email
    companyName
    phoneNumber
  }
}
    `;
export const ReservationPage__DailyBookingDetailsFragmentDoc = gql`
    fragment ReservationPage__DailyBookingDetails on DailyBooking {
  space {
    id
    name
    maxCapacity
    images {
      thumb {
        url
        width
        height
      }
      small {
        url
        width
        height
      }
      medium {
        url
        width
        height
      }
      large {
        url
        width
        height
      }
    }
    pricings {
      type
      price
    }
    location {
      name
    }
  }
  id
  spaceID
  orderID
  layoutID
  physicalSpaceID
  room
  floor
  cancellationAllowed
  cancellationAllowedBefore
  meetingName
  arrivalTime
  startDate
  endDate
  days
  time
  meetingContactInfo {
    fullName
    email
    companyName
    phoneNumber
  }
}
    `;
export const ReservationPage__OrderItemDetailsFragmentDoc = gql`
    fragment ReservationPage__OrderItemDetails on OrderItem {
  id
  totalPrice
  unitPrice
  details {
    __typename
    ...ReservationPage__HourlyBookingDetails
    ...ReservationPage__DailyBookingDetails
  }
}
    ${ReservationPage__HourlyBookingDetailsFragmentDoc}
${ReservationPage__DailyBookingDetailsFragmentDoc}`;
export const ReservationPage__OrderDetailsFragmentDoc = gql`
    fragment ReservationPage__OrderDetails on Order {
  id
  status
  orderItems {
    ...ReservationPage__OrderItemDetails
  }
}
    ${ReservationPage__OrderItemDetailsFragmentDoc}`;
export const AppHeaderV3DesktopDocument = gql`
    query AppHeaderV3Desktop {
  currentUser {
    id
    role
    picture
    fullName
    groupBudgetRole
    groupBudget {
      id
      name
    }
    organization {
      id
      paymentMode
      plan
    }
  }
}
    `;
export const UserSpacePolicyDocument = gql`
    query userSpacePolicy {
  currentUser {
    organization {
      budget {
        policy {
          spaceTypes {
            meetingRoom
            dayPass
            privateOffice
          }
        }
      }
    }
    groupBudget {
      policy {
        spaceTypes {
          meetingRoom
          dayPass
          privateOffice
        }
      }
    }
  }
}
    `;
export const InviteToTeamInAppDocument = gql`
    mutation InviteToTeamInApp($input: InviteToTeamInput!) {
  inviteToTeam(input: $input)
}
    `;
export const InAppInviteCurrentUserDocument = gql`
    query InAppInviteCurrentUser {
  currentUser {
    role
    organization {
      id
      name
    }
  }
}
    `;
export const SidebarDocument = gql`
    query Sidebar {
  currentUser {
    id
    role
    organization {
      id
      name
    }
  }
}
    `;
export const CreateOrganizationDocument = gql`
    mutation createOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    createdAt
    createdWith
  }
}
    `;
export const UserDomainDocument = gql`
    query UserDomain {
  currentUser {
    email
  }
}
    `;
export const CurrentUserInfoDocument = gql`
    query CurrentUserInfo {
  currentUser {
    id
    hasBookedBefore
    hasSignedUpWithSocialProvider
    fullName
    email
    phoneNumber
    organization {
      id
      name
      plan
    }
  }
}
    `;
export const BetterHourRatesDocument = gql`
    query BetterHourRates($spaceId: ID!, $date: String!, $startTime: String, $endTime: String, $unitPrice: Float) {
  space(id: $spaceId) {
    betterHourRates(
      input: {date: $date, startTime: $startTime, endTime: $endTime, unitPrice: $unitPrice}
    ) {
      currentUnitPrice
      options {
        minBookingUnit
        unitPrice
        startTime
        endTime
      }
    }
  }
}
    `;
export const UpdateOrderMemoDocument = gql`
    mutation updateOrderMemo($orderID: ID!, $memo: String) {
  updateOrderMemo(orderID: $orderID, memo: $memo)
}
    `;
export const SpaceAvailableDaysDocument = gql`
    query SpaceAvailableDays($id: ID!, $input: SpaceAvailableDaysInput!) {
  space(id: $id) {
    id
    availableDays(input: $input) {
      date
      openAt
      closedAt
      availableFullDay
    }
  }
}
    `;
export const SpaceAvailableTimeSlotsDocument = gql`
    query SpaceAvailableTimeSlots($id: ID!, $input: SpaceAvailableTimeSlotsInput!) {
  space(id: $id) {
    id
    availableTimeSlots(input: $input) {
      startTime
      endTimes
    }
  }
}
    `;
export const BookingUtilsOrderDetailsDocument = gql`
    query BookingUtilsOrderDetails($id: ID!) {
  order(id: $id) {
    id
    totalPrice
    currency
    status
    memo
    guest {
      fullName
      companyName
      email
      phoneNumber
    }
    orderItems {
      id
      details {
        __typename
        ... on DailyBooking {
          startDate
          endDate
          time
          space {
            id
            locationName
            name
            city
            country
          }
        }
        ... on HourlyBooking {
          date
          startTime
          endTime
          space {
            id
            locationName
            name
            city
            country
          }
        }
      }
    }
  }
}
    `;
export const CheckoutDocument = gql`
    mutation Checkout($input: CheckoutInput!) {
  checkout(input: $input) {
    id
    stripeClientSecret
    totalPrice
  }
}
    `;
export const BookingUpdateUserDocument = gql`
    mutation BookingUpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    hasBookedBefore
    fullName
    email
    phoneNumber
  }
}
    `;
export const SpaceCheckoutCurrentUserInfoDocument = gql`
    query SpaceCheckoutCurrentUserInfo {
  currentUser {
    id
    hasBookedBefore
    hasSignedUpWithSocialProvider
    fullName
    email
    phoneNumber
    organization {
      id
      name
    }
  }
}
    `;
export const SpaceCheckoutSpaceInfoDocument = gql`
    query SpaceCheckoutSpaceInfo($id: ID!) {
  space(id: $id) {
    id
    partnerID
    maxCapacity
  }
}
    `;
export const BottomBarAdminNavigationDocument = gql`
    query BottomBarAdminNavigation {
  currentUser {
    id
    organization {
      id
      plan
    }
  }
}
    `;
export const UserAvatarDocument = gql`
    query UserAvatar {
  currentUser {
    id
    picture
    fullName
  }
}
    `;
export const DetachPaymentMethodDocument = gql`
    mutation DetachPaymentMethod($input: DetachPaymentMethodInput!) {
  detachPaymentMethod(input: $input) {
    status
  }
}
    `;
export const SetupPaymentMethodUpdateDocument = gql`
    mutation SetupPaymentMethodUpdate {
  setupPaymentMethodUpdate {
    customerID
    stripeClientSecret
  }
}
    `;
export const BookingPaymentMethodDocument = gql`
    query BookingPaymentMethod {
  paymentMethod {
    ... on CardPaymentMethod {
      id
      last4
      network
      networkLogoUrl
    }
  }
}
    `;
export const CheckOutPaymentDetailsDocument = gql`
    query CheckOutPaymentDetails {
  currentUser {
    id
    fullName
  }
}
    `;
export const OffsiteLocationWhosHereDocument = gql`
    query OffsiteLocationWhosHere($offsiteLocationID: ID!, $startDate: String!, $endDate: String!) {
  offsiteLocation(id: $offsiteLocationID) {
    id
    bookings(startDate: $startDate, endDate: $endDate) {
      ...OffsiteLocationWhosHere__BookingDetails
    }
  }
}
    ${OffsiteLocationWhosHere__BookingDetailsFragmentDoc}`;
export const OffsiteDetailsWhosHereDocument = gql`
    query OffsiteDetailsWhosHere {
  currentUser {
    id
  }
}
    `;
export const BookingRequestsAdminStatusesDocument = gql`
    query BookingRequestsAdminStatuses {
  currentUser {
    id
    organization {
      id
      bookingRequests {
        id
        status
      }
    }
  }
}
    `;
export const BookingRequestsManagerStatusesDocument = gql`
    query BookingRequestsManagerStatuses {
  currentUser {
    id
    groupBudget {
      id
      bookingRequests {
        id
        status
      }
    }
  }
}
    `;
export const PromoCodeIsValidDocument = gql`
    query PromoCodeIsValid($code: String!, $offsiteSpaceID: ID!, $startDate: String!, $endDate: String!) {
  promoCodeIsValid(
    code: $code
    offsiteSpaceID: $offsiteSpaceID
    startDate: $startDate
    endDate: $endDate
  )
}
    `;
export const QuoteDetailsDocument = gql`
    query QuoteDetails($input: QuoteInput!) {
  quote(input: $input) {
    quoteId
    totalPrice
    subTotal
    processingFee
    outOfPolicyMessage
    promotionLine {
      amount
      description
      code
      discount
    }
    taxLine {
      amount
      description
      percentage
    }
    orderItems {
      ...QuoteDetail__OrderItem
    }
    cancellationFeeTiers {
      ...CancellationFeeTier__Details
    }
    quoteItems {
      quoteId
      unitPrice
      totalPrice
      originalTotalPrice
      quoteItemPrices {
        quoteItemId
        unitPrice
        unitCount
        unitType
        originalUnitPrice
        startDate
        endDate
        dynamicPriceRate {
          id
        }
      }
      dynamicPriceRate {
        id
      }
    }
  }
}
    ${QuoteDetail__OrderItemFragmentDoc}
${CancellationFeeTier__DetailsFragmentDoc}`;
export const SpaceDetailsDocument = gql`
    query SpaceDetails($id: ID!) {
  space(id: $id) {
    id
    ...SpaceDetails__AllDetails
  }
}
    ${SpaceDetails__AllDetailsFragmentDoc}`;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    ...CurrentUser__MainDetails
    ...CurrentUser__Promotions
    ...CurrentUser__Organization
  }
}
    ${CurrentUser__MainDetailsFragmentDoc}
${CurrentUser__PromotionsFragmentDoc}
${CurrentUser__OrganizationFragmentDoc}`;
export const PersonDocument = gql`
    query Person {
  person {
    id
    userId
    organizationId
  }
}
    `;
export const SideBarDocument = gql`
    query SideBar {
  currentUser {
    id
    role
    fullName
    email
    phoneNumber
    organization {
      id
    }
    picture
  }
}
    `;
export const SendInvitesDocument = gql`
    mutation SendInvites($orderID: ID!, $input: InvitesInput!) {
  sendInvites(orderID: $orderID, input: $input) {
    id
    message
    recipients {
      name
      email
      phoneNumber
    }
  }
}
    `;
export const HookUserRoleDocument = gql`
    query HookUserRole {
  currentUser {
    role
    groupBudgetRole
  }
}
    `;
export const OrganizationByInviteQueryDocument = gql`
    query OrganizationByInviteQuery($inviteId: String!) {
  organizationByInvite(inviteId: $inviteId) {
    id
    inviteeEmail
    status
    organization {
      name
      domain
      requireSSO
      ssoProvider
      logoUrl
      slug
      users {
        userId
        id
        role
        picture
        fullName
        email
      }
    }
  }
}
    `;
export const AcceptInviteCodeVerifiedDocument = gql`
    query AcceptInviteCodeVerified {
  currentUser {
    id
  }
}
    `;
export const LinkEmailAccountToPasswordAccountIfExistsDocument = gql`
    mutation LinkEmailAccountToPasswordAccountIfExists {
  linkEmailAccountToPasswordAccountIfExists
}
    `;
export const CurrentUserStepCodeDocument = gql`
    query CurrentUserStepCode {
  currentUser {
    id
    organization {
      id
    }
  }
}
    `;
export const AcceptInviteDocument = gql`
    mutation AcceptInvite($inviteID: String!) {
  acceptInvite(inviteID: $inviteID)
}
    `;
export const UserInfoDocument = gql`
    query UserInfo {
  currentUser {
    fullName
    email
    phoneNumber
    city {
      displayName
    }
  }
}
    `;
export const BookingDetailsDocument = gql`
    query BookingDetails($id: ID!) {
  currentUser {
    organization {
      monthlyBilling
    }
  }
  order(id: $id) {
    id
    totalPrice
    subTotal
    processingFee
    confirmationID
    memo
    status
    cancellable
    currency
    taxLine {
      amount
      description
      percentage
    }
    promotionLine {
      amount
      description
      discount
      code
    }
    invitees {
      name
      email
    }
    paymentDetail {
      id
      paymentMethodDetails {
        last4
        network
        networkLogoUrl
      }
      billingDetails {
        name
        email
        phone
        address {
          line1
          line2
          city
          state
          postalCode
          country
        }
      }
      receiptUrl
    }
    orderItems {
      ...BookingDetails__OrderItemDetails
    }
  }
}
    ${BookingDetails__OrderItemDetailsFragmentDoc}`;
export const CancelBookingDocument = gql`
    mutation cancelBooking($orderID: ID!) {
  cancelOrder(orderID: $orderID)
}
    `;
export const ApproveBookingRequestDocument = gql`
    mutation ApproveBookingRequest($input: UpdateBookingRequestStatusInput!) {
  approveBookingRequest(input: $input) {
    id
  }
}
    `;
export const DeclineBookingRequestDocument = gql`
    mutation DeclineBookingRequest($input: UpdateBookingRequestStatusInput!) {
  declineBookingRequest(input: $input) {
    id
  }
}
    `;
export const BookingRequestsDocument = gql`
    query BookingRequests($requesterStartDate: String, $requesterEndDate: String) {
  currentUser {
    ...BookingRequests__CurrentUser
  }
}
    ${BookingRequests__CurrentUserFragmentDoc}`;
export const BudgetBookingRequestsDocument = gql`
    query BudgetBookingRequests($requesterStartDate: String, $requesterEndDate: String) {
  currentUser {
    ...BudgetBookingRequests__CurrentUser
  }
}
    ${BudgetBookingRequests__CurrentUserFragmentDoc}`;
export const BookingsDocument = gql`
    query Bookings($limit: Int, $sort: OrderSort, $startDate: String, $endDate: String) {
  currentUser {
    orders(limit: $limit, sort: $sort, startDate: $startDate, endDate: $endDate) {
      ...Bookings__OrderDetails
    }
  }
}
    ${Bookings__OrderDetailsFragmentDoc}`;
export const InviteesRemainingDocument = gql`
    query InviteesRemaining($orderId: ID!) {
  order(id: $orderId) {
    invitees {
      name
    }
    orderItems {
      details {
        ...InviteesRemaining__DailyBookingDetails
        ...InviteesRemaining__HourlyBookingDetails
      }
    }
  }
}
    ${InviteesRemaining__DailyBookingDetailsFragmentDoc}
${InviteesRemaining__HourlyBookingDetailsFragmentDoc}`;
export const GetOrgNameDocument = gql`
    query getOrgName {
  currentUser {
    organization {
      name
    }
  }
}
    `;
export const OrgBudgetDocument = gql`
    query OrgBudget {
  currentUser {
    organization {
      id
      name
      groupBudgets {
        id
        name
      }
    }
  }
}
    `;
export const UpdateOrderBudgetDocument = gql`
    mutation updateOrderBudget($orderId: ID!, $budgetId: ID!) {
  updateOrderBudget(orderId: $orderId, budgetId: $budgetId)
}
    `;
export const PeoplePickerDocument = gql`
    query PeoplePicker {
  currentUser {
    id
    groupBudgetRole
    organization {
      id
      users {
        id
        userId
        role
        fullName
        email
        picture
        groupBudgetRole
        groupBudget {
          id
          name
          members {
            role
            user {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export const BudgetDocument = gql`
    query Budget {
  currentUser {
    id
    role
    organization {
      id
      name
      budget {
        id
        state
        remaining
        spend
        limit
        individualLimit
      }
      groupBudgets {
        id
        status
        name
        description
        color
        spend
        remaining
        limit
      }
    }
  }
}
    `;
export const PreMovingGroupBudgetPeopleMessageQueryDocument = gql`
    query PreMovingGroupBudgetPeopleMessageQuery($input: PreMovingGroupBudgetPeopleInput!) {
  preMovingGroupBudgetPeopleMessage(input: $input) {
    messages
    personName
    previousBudgetName
    newManagerName
  }
}
    `;
export const UpdateGroupBudgetAddMemberDocument = gql`
    mutation UpdateGroupBudgetAddMember($input: UpdateGroupBudgetInput!) {
  updateGroupBudget(input: $input) {
    id
    members {
      role
      user {
        id
      }
    }
  }
}
    `;
export const ReactivateGroupBudgetDocument = gql`
    mutation ReactivateGroupBudget($input: ReactivateGroupBudgetInput!) {
  reactivateGroupBudget(input: $input) {
    id
    name
    description
    limit
    individualLimit
    status
    policy {
      id
      name
    }
  }
}
    `;
export const CreateGroupBudgetDocument = gql`
    mutation CreateGroupBudget($input: CreateGroupBudgetInput!) {
  createGroupBudget(input: $input) {
    id
    name
    description
    limit
    individualLimit
    status
    policy {
      id
      name
    }
  }
}
    `;
export const CreateGroupBudgetOrganizationBudgetDocument = gql`
    query CreateGroupBudgetOrganizationBudget {
  currentUser {
    id
    role
    organization {
      id
      budget {
        limit
      }
      groupBudgets {
        id
        name
      }
      policies {
        id
        name
        isAppliedToNewBudget
      }
    }
  }
}
    `;
export const UserRoleAndOrgInfoDocument = gql`
    query UserRoleAndOrgInfo($id: ID!) {
  currentUser {
    id
    role
    organization {
      id
      budget {
        id
        limit
      }
      groupBudgets {
        id
        name
      }
    }
  }
  groupBudget(id: $id) {
    id
    status
    name
    description
    color
    spend
    remaining
    limit
    individualLimit
    members {
      role
      user {
        id
        userId
        role
        fullName
        email
        picture
        title
        groupBudgetRole
      }
    }
  }
}
    `;
export const GroupBudgetDetailPeopleDocument = gql`
    query GroupBudgetDetailPeople($groupBudgetId: ID!) {
  groupBudget(id: $groupBudgetId) {
    id
    status
    members {
      role
      user {
        id
        fullName
        email
        picture
        groupBudgetRole
      }
    }
  }
}
    `;
export const GroupBudgetDetailDocument = gql`
    query GroupBudgetDetail($id: ID!, $startDate: String!, $endDate: String!) {
  groupBudget(id: $id) {
    id
    status
    color
    spend
    remaining
    limit
    reporting(startDate: $startDate, endDate: $endDate) {
      ...BudgetDetail__Reporting
    }
  }
}
    ${BudgetDetail__ReportingFragmentDoc}`;
export const GroupBudgetDetailTransactionsDocument = gql`
    query GroupBudgetDetailTransactions($id: ID!, $startDate: String!, $endDate: String!) {
  groupBudget(id: $id) {
    id
    name
    ordersSummary(startDate: $startDate, endDate: $endDate) {
      lastUpdatedDate
      orders {
        order {
          memo
        }
        orderID
        hostFullName
        hostTitle
        locationName
        locationAddress
        spaceName
        spaceType
        bookingDate
        bookingStartTime
        bookingEndTime
        orderCreatedAt
        totalPrice
        currency
        bookingRequest {
          id
        }
      }
    }
  }
}
    `;
export const UpdateGroupBudgetDocument = gql`
    mutation UpdateGroupBudget($input: UpdateGroupBudgetInput!) {
  updateGroupBudget(input: $input) {
    id
    name
    description
    limit
    individualLimit
    status
    policy {
      id
      name
    }
  }
}
    `;
export const UpdateGroupBudgetOrganizationBudgetDocument = gql`
    query UpdateGroupBudgetOrganizationBudget($id: ID!) {
  currentUser {
    id
    role
    organization {
      id
      budget {
        id
        limit
      }
      groupBudgets {
        id
        name
      }
    }
  }
  groupBudget(id: $id) {
    id
    status
    name
    description
    color
    spend
    remaining
    limit
    individualLimit
    members {
      role
      user {
        id
        userId
        role
        fullName
        email
        picture
        title
        groupBudgetRole
      }
    }
    policy {
      id
    }
  }
}
    `;
export const DeactivateGroupBudgetDocument = gql`
    mutation DeactivateGroupBudget($id: ID!) {
  deactivateGroupBudget(id: $id) {
    id
    status
    name
    description
    spend
    remaining
    limit
    members {
      role
      user {
        id
        userId
        role
        fullName
        email
        picture
        title
        groupBudgetRole
      }
    }
  }
}
    `;
export const CreateOrganizationBudgetDocument = gql`
    mutation createOrganizationBudget($input: CreateOrganizationBudgetInput!) {
  createOrganizationBudget(input: $input) {
    id
    remaining
    spend
    limit
    individualLimit
    policy {
      id
      name
    }
  }
}
    `;
export const OrganizationBudgetDetailDocument = gql`
    query OrganizationBudgetDetail($startDate: String!, $endDate: String!) {
  currentUser {
    id
    organization {
      id
      name
      createdAt
      reporting(startDate: $startDate, endDate: $endDate) {
        ...BudgetDetail__Reporting
      }
      budget {
        id
        state
        remaining
        spend
        limit
        individualLimit
      }
      groupBudgets {
        id
        status
        name
        description
        color
        spend
        remaining
        limit
      }
    }
  }
}
    ${BudgetDetail__ReportingFragmentDoc}`;
export const OrganizationBudgetDetailTransactionsDocument = gql`
    query OrganizationBudgetDetailTransactions($startDate: String!, $endDate: String!) {
  currentUser {
    organization {
      id
      name
      ordersSummary(startDate: $startDate, endDate: $endDate) {
        lastUpdatedDate
        orders {
          order {
            memo
          }
          hostFullName
          hostTitle
          locationName
          locationAddress
          spaceName
          spaceType
          bookingDate
          bookingStartTime
          bookingEndTime
          orderCreatedAt
          orderID
          totalPrice
          currency
          groupBudget {
            id
            name
          }
          bookingRequest {
            id
          }
        }
      }
    }
  }
}
    `;
export const UpdateOrganizationBudgetDocument = gql`
    mutation UpdateOrganizationBudget($input: UpdateOrganizationBudgetInput!) {
  updateOrganizationBudget(input: $input) {
    id
    remaining
    spend
    limit
    individualLimit
    policy {
      id
      name
    }
  }
}
    `;
export const EditOrganizationBudgetDocument = gql`
    query EditOrganizationBudget {
  currentUser {
    id
    organization {
      id
      budget {
        limit
        individualLimit
        policy {
          id
        }
      }
    }
  }
}
    `;
export const PoliciesDocument = gql`
    query Policies {
  currentUser {
    organization {
      policies {
        id
        name
        lastUpdated
      }
    }
  }
}
    `;
export const RemoveAddressDocument = gql`
    mutation RemoveAddress($addressId: ID!) {
  removeBudgetPolicyAddress(addressId: $addressId)
}
    `;
export const CreatePolicyDocument = gql`
    mutation CreatePolicy($input: CreateBudgetPolicyInput!) {
  createBudgetPolicy(input: $input) {
    id
    name
  }
}
    `;
export const BudgetPolicyDocument = gql`
    query BudgetPolicy($id: ID!) {
  budgetPolicy(id: $id) {
    name
    isAppliedToNewBudget
    applyToBudgets {
      id
    }
    spaceTypes {
      meetingRoom
      privateOffice
      dayPass
    }
    locationItems {
      id
      distance
      distanceUnit
      address {
        id
        street
        latitude
        longitude
      }
    }
  }
}
    `;
export const UpdateBudgetPolicyDocument = gql`
    mutation UpdateBudgetPolicy($input: UpdateBudgetPolicyInput!) {
  updateBudgetPolicy(input: $input) {
    id
  }
}
    `;
export const GroupBudgetsDocument = gql`
    query GroupBudgets {
  currentUser {
    organization {
      groupBudgets {
        id
        name
        policy {
          name
        }
      }
    }
  }
}
    `;
export const BudgetPoliciesDocument = gql`
    query BudgetPolicies {
  currentUser {
    organization {
      policies {
        id
        name
      }
    }
  }
}
    `;
export const BudgetPolicyAddressesDocument = gql`
    query BudgetPolicyAddresses {
  budgetPolicyAddresses {
    id
    street
    latitude
    longitude
  }
}
    `;
export const OrgBySlugDocument = gql`
    query orgBySlug($slug: String!) {
  organizationBySlug(slug: $slug) {
    id
    name
    requireSSO
    ssoProvider
    logoUrl
    slug
    connectionName
  }
}
    `;
export const SendSupportTicketDocument = gql`
    mutation SendSupportTicket($topic: String!, $subject: String!, $content: String!) {
  sendSupportTicket(topic: $topic, subject: $subject, content: $content)
}
    `;
export const LocationPreviewSpacesDocument = gql`
    query LocationPreviewSpaces($offsiteLocationID: ID!, $filter: DiscoverFilter, $dayPassFilter: DiscoverFilter) {
  locations: offsiteLocation(id: $offsiteLocationID) {
    id
    name
    ...LocationPreview__LocationSpaces
  }
  meetingRooms: offsiteLocation(id: $offsiteLocationID) {
    id
    name
    ...LocationPreviewCardLocationSpaces__LocationDetails
  }
  dayPasses: offsiteLocation(id: $offsiteLocationID) {
    id
    name
    ...LocationPreviewCardLocationSpaces__DayPassLocationDetails
  }
  dayOffices: offsiteLocation(id: $offsiteLocationID) {
    id
    name
    ...LocationPreviewCardLocationPhysicalSpaces__LocationDetails
  }
}
    ${LocationPreview__LocationSpacesFragmentDoc}
${LocationPreviewCardLocationSpaces__LocationDetailsFragmentDoc}
${LocationPreviewCardLocationSpaces__DayPassLocationDetailsFragmentDoc}
${LocationPreviewCardLocationPhysicalSpaces__LocationDetailsFragmentDoc}`;
export const SpaceCardCurrentUserCountryDocument = gql`
    query SpaceCardCurrentUserCountry {
  currentUser {
    id
    ipPlace {
      country
    }
  }
}
    `;
export const SpaceTypeFilterAmenitiesDocument = gql`
    query SpaceTypeFilterAmenities {
  MeetingRoomAmenities: amenities(spaceType: MeetingRoom) {
    id
    iconURL
    name
    code
  }
  DayPassAmenities: amenities(spaceType: DayPass) {
    id
    iconURL
    name
    code
  }
  DayOfficeAmenities: amenities(spaceType: DayOffice) {
    id
    iconURL
    name
    code
  }
  LocationAmenities: amenities {
    id
    iconURL
    name
    code
  }
}
    `;
export const EmptyStateTileBDocument = gql`
    query EmptyStateTileB {
  currentUser {
    id
    fullName
    email
  }
}
    `;
export const RecommendedSpaceListDocument = gql`
    query RecommendedSpaceList($spaceType: SpaceType!, $filter: SpacesFilter, $centerMapCoordinates: SpaceSearchCoordinates, $currentUserCoordinates: SpaceSearchCoordinates, $limit: Int, $offset: Int, $sort: SpacesSort, $bookingsDate: String!) {
  spaces(
    spaceType: $spaceType
    filter: $filter
    centerMapCoordinates: $centerMapCoordinates
    currentUserCoordinates: $currentUserCoordinates
    limit: $limit
    offset: $offset
    sort: $sort
  ) {
    data {
      ...RecommendedSpaceList_Fragment
    }
  }
}
    ${RecommendedSpaceList_FragmentFragmentDoc}`;
export const RecommendedLocationListDocument = gql`
    query RecommendedLocationList($filter: LocationsFilter, $centerMapCoordinates: SpaceSearchCoordinates) {
  locations(filter: $filter, centerMapCoordinates: $centerMapCoordinates) {
    ...RecommendedLocationList_Fragment
  }
}
    ${RecommendedLocationList_FragmentFragmentDoc}`;
export const EmptyStatesOtherSpacesDocument = gql`
    query EmptyStatesOtherSpaces($filter: SpacesFilter, $centerMapCoordinates: SpaceSearchCoordinates, $currentUserCoordinates: SpaceSearchCoordinates, $limit: Int, $offset: Int, $sort: SpacesSort) {
  MeetingRoom: spaces(
    spaceType: MeetingRoom
    filter: $filter
    currentUserCoordinates: $currentUserCoordinates
    centerMapCoordinates: $centerMapCoordinates
    limit: $limit
    offset: $offset
    sort: $sort
  ) {
    data {
      id
    }
  }
  DayPass: spaces(
    spaceType: DayPass
    filter: $filter
    currentUserCoordinates: $currentUserCoordinates
    centerMapCoordinates: $centerMapCoordinates
    limit: $limit
    offset: $offset
    sort: $sort
  ) {
    data {
      id
    }
  }
  DayOffice: spaces(
    spaceType: DayOffice
    filter: $filter
    currentUserCoordinates: $currentUserCoordinates
    centerMapCoordinates: $centerMapCoordinates
    limit: $limit
    offset: $offset
    sort: $sort
  ) {
    data {
      id
      physicalSpacesCount
    }
  }
}
    `;
export const HomePageDocument = gql`
    query HomePage($spaceType: SpaceType!, $filter: SpacesFilter, $centerMapCoordinates: SpaceSearchCoordinates, $currentUserCoordinates: SpaceSearchCoordinates, $limit: Int, $offset: Int, $radius: Int, $sort: SpacesSort, $bookingsDate: String!) {
  spaces(
    spaceType: $spaceType
    filter: $filter
    centerMapCoordinates: $centerMapCoordinates
    currentUserCoordinates: $currentUserCoordinates
    limit: $limit
    offset: $offset
    radius: $radius
    sort: $sort
  ) {
    totalCount
    data {
      ...HomePage__SpaceDetails
    }
  }
}
    ${HomePage__SpaceDetailsFragmentDoc}`;
export const HomePageLocationsDocument = gql`
    query HomePageLocations($filter: LocationsFilter, $centerMapCoordinates: SpaceSearchCoordinates) {
  locations(filter: $filter, centerMapCoordinates: $centerMapCoordinates) {
    ...HomePageLocations__LocationDetails
  }
}
    ${HomePageLocations__LocationDetailsFragmentDoc}`;
export const CurrentUserIpPlaceCoordinatesHookDocument = gql`
    query CurrentUserIpPlaceCoordinatesHook {
  ipPlace {
    latitude
    longitude
    placeName
  }
}
    `;
export const GetLocationAmenitiesDocument = gql`
    query GetLocationAmenities {
  amenities {
    id
    iconURL
    name
    code
  }
}
    `;
export const GetUserInfoDocument = gql`
    query GetUserInfo {
  currentUser {
    id
    hasBookedBefore
  }
}
    `;
export const GetLocationNearByDocument = gql`
    query GetLocationNearBy($filter: LocationsFilter, $centerMapCoordinates: SpaceSearchCoordinates, $currentUserCoordinates: SpaceSearchCoordinates, $limit: Int, $radius: Int, $sort: LocationsSort) {
  locations(
    filter: $filter
    centerMapCoordinates: $centerMapCoordinates
    currentUserCoordinates: $currentUserCoordinates
    limit: $limit
    radius: $radius
    sort: $sort
  ) {
    ...SpaceLocationDetail
  }
}
    ${SpaceLocationDetailFragmentDoc}`;
export const GetOrgBookingDocument = gql`
    query GetOrgBooking($startDate: String!, $endDate: String!, $currentUserCoordinates: SpaceSearchCoordinates) {
  currentUser {
    id
    organization {
      bookings(startDate: $startDate, endDate: $endDate) {
        ...OrgBooking
      }
    }
  }
}
    ${OrgBookingFragmentDoc}`;
export const GetPopularLocationDocument = gql`
    query GetPopularLocation($centerMapCoordinates: SpaceSearchCoordinates, $currentUserCoordinates: SpaceSearchCoordinates, $limit: Int, $radius: Int) {
  popularLocations(
    centerMapCoordinates: $centerMapCoordinates
    currentUserCoordinates: $currentUserCoordinates
    limit: $limit
    radius: $radius
  ) {
    ...SpaceLocationDetail
  }
}
    ${SpaceLocationDetailFragmentDoc}`;
export const GetSpaceNearByDocument = gql`
    query GetSpaceNearBy($spaceType: SpaceType!, $hasSpaceType: Boolean!, $filter: SpacesFilter, $centerMapCoordinates: SpaceSearchCoordinates, $currentUserCoordinates: SpaceSearchCoordinates, $limit: Int, $offset: Int, $radius: Int, $sort: SpacesSort) {
  spaces: spaces(
    spaceType: $spaceType
    filter: $filter
    centerMapCoordinates: $centerMapCoordinates
    currentUserCoordinates: $currentUserCoordinates
    limit: $limit
    offset: $offset
    radius: $radius
    sort: $sort
  ) @include(if: $hasSpaceType) {
    data {
      ...BookingSpaceDetail
    }
  }
  dayPasses: spaces(
    spaceType: DayPass
    filter: $filter
    centerMapCoordinates: $centerMapCoordinates
    currentUserCoordinates: $currentUserCoordinates
    limit: $limit
    offset: $offset
    radius: $radius
  ) @skip(if: $hasSpaceType) {
    data {
      ...BookingSpaceDetail
    }
  }
  meetingRooms: spaces(
    spaceType: MeetingRoom
    filter: $filter
    centerMapCoordinates: $centerMapCoordinates
    currentUserCoordinates: $currentUserCoordinates
    limit: $limit
    offset: $offset
    radius: $radius
  ) @skip(if: $hasSpaceType) {
    data {
      ...BookingSpaceDetail
    }
  }
  dayOffices: spaces(
    spaceType: DayOffice
    filter: $filter
    centerMapCoordinates: $centerMapCoordinates
    currentUserCoordinates: $currentUserCoordinates
    limit: $limit
    offset: $offset
    radius: $radius
  ) @skip(if: $hasSpaceType) {
    data {
      ...BookingSpaceDetail
    }
  }
}
    ${BookingSpaceDetailFragmentDoc}`;
export const GetUserOrderDocument = gql`
    query GetUserOrder($currentUserCoordinates: SpaceSearchCoordinates, $limit: Int, $sort: OrderSort, $startDate: String, $endDate: String) {
  currentUser {
    id
    orders(limit: $limit, sort: $sort, startDate: $startDate, endDate: $endDate) {
      ...CurrentUserOrder
    }
  }
}
    ${CurrentUserOrderFragmentDoc}`;
export const GetUserTypeDocument = gql`
    query GetUserType {
  currentUser {
    id
    hasBookedBefore
  }
}
    `;
export const LocationDetailsDocument = gql`
    query LocationDetails($locationId: ID!) {
  currentUser {
    organization {
      budget {
        id
        policy {
          id
          spaceTypes {
            ...LocationDetails__SpaceTypePolicy
          }
        }
      }
    }
    groupBudget {
      id
      policy {
        id
        spaceTypes {
          ...LocationDetails__SpaceTypePolicy
        }
      }
    }
  }
  location: offsiteLocation(id: $locationId) {
    ...LocationDetails__Location
  }
  meetingRooms: offsiteLocation(id: $locationId) {
    id
    spaces(spaceType: MeetingRoom) {
      ...LocationDetails__SpaceDetails
    }
  }
  dayPasses: offsiteLocation(id: $locationId) {
    id
    spaces(spaceType: DayPass) {
      ...LocationDetails__SpaceDetails
    }
  }
  dayOffices: offsiteLocation(id: $locationId) {
    id
    spaces(spaceType: DayOffice) {
      ...LocationDetails__SpaceDetails
    }
  }
}
    ${LocationDetails__SpaceTypePolicyFragmentDoc}
${LocationDetails__LocationFragmentDoc}
${LocationDetails__SpaceDetailsFragmentDoc}`;
export const ManageUsersListDocument = gql`
    query ManageUsersList {
  currentUser {
    id
    role
    organization {
      id
      name
      invitations(status: "pending") {
        id
        inviteeEmail
      }
      users {
        ...ManageUsers__UserDetails
      }
    }
  }
}
    ${ManageUsers__UserDetailsFragmentDoc}`;
export const RevokeInviteDocument = gql`
    mutation RevokeInvite($inviteID: String!) {
  revokeInvite(inviteID: $inviteID)
}
    `;
export const ChangeUserRoleDocument = gql`
    mutation ChangeUserRole($personId: String!, $newRole: String!) {
  changeUserRole(personId: $personId, newRole: $newRole)
}
    `;
export const DeletePersonDocument = gql`
    mutation DeletePerson($personId: String!) {
  deletePerson(personId: $personId)
}
    `;
export const OfficePageBookingsDocument = gql`
    query OfficePageBookings($officeSpaceID: ID!, $startDate: String!, $endDate: String!) {
  officeSpace(id: $officeSpaceID) {
    ...OfficePage__OfficeSpaceBookings
  }
}
    ${OfficePage__OfficeSpaceBookingsFragmentDoc}`;
export const OfficePageDetailsCurrentUserDocument = gql`
    query OfficePageDetailsCurrentUser {
  currentUser {
    id
  }
}
    `;
export const OfficePageDetailsDocument = gql`
    query OfficePageDetails($officeSpaceID: ID!) {
  officeSpace(id: $officeSpaceID) {
    ...OfficePage__OfficeSpaceDetails
  }
}
    ${OfficePage__OfficeSpaceDetailsFragmentDoc}`;
export const BookOfficeSpaceOnDayDocument = gql`
    mutation BookOfficeSpaceOnDay($spaceID: String!, $day: String!) {
  bookOfficeSpaceOnDay(spaceID: $spaceID, day: $day) {
    day
    bookableID
    bookableType
  }
}
    `;
export const UnbookOfficeSpaceDocument = gql`
    mutation UnbookOfficeSpace($spaceID: ID!, $bookingID: ID!) {
  unbookOfficeSpace(spaceID: $spaceID, bookingID: $bookingID)
}
    `;
export const CheckinOfficeSpaceTodayDocument = gql`
    mutation CheckinOfficeSpaceToday($spaceID: String!) {
  checkinOfficeSpaceToday(spaceID: $spaceID) {
    id
    moment
    checkinableID
    checkinableType
  }
}
    `;
export const RequestToBookBannerDocument = gql`
    query RequestToBookBanner {
  currentUser {
    id
    role
  }
}
    `;
export const RequestBudgetIncreaseDocument = gql`
    mutation RequestBudgetIncrease($input: RequestBudgetIncreaseInput!) {
  requestBudgetIncrease(input: $input)
}
    `;
export const RequestToBookDocument = gql`
    query requestToBook($role: String!, $status: UserStatus) {
  currentUser {
    organization {
      users(role: $role, status: $status) {
        userId
        role
        fullName
        phoneNumber
        email
      }
    }
  }
}
    `;
export const OffsiteOrderPage__OrderDetailsDocument = gql`
    query OffsiteOrderPage__OrderDetails($id: ID!) {
  order(id: $id) {
    id
    totalPrice
    subTotal
    processingFee
    confirmationID
    memo
    additionalNotes
    stripeClientSecret
    status
    cancellable
    uncancellable_reason
    currency
    invites {
      ...OffsiteOrderPage__OrderInvites
    }
    invitees {
      name
      email
    }
    taxLine {
      amount
      description
      percentage
    }
    promotionLine {
      amount
      description
      discount
      code
    }
    guest {
      fullName
      companyName
      email
      phoneNumber
    }
    paymentDetail {
      id
      paymentMethodDetails {
        last4
        network
        networkLogoUrl
      }
      billingDetails {
        name
        email
        phone
        address {
          line1
          line2
          city
          state
          postalCode
          country
        }
      }
      receiptUrl
    }
    orderItems {
      ...OffsiteOrderPage__OrderItemDetails
    }
  }
}
    ${OffsiteOrderPage__OrderInvitesFragmentDoc}
${OffsiteOrderPage__OrderItemDetailsFragmentDoc}`;
export const OffsiteOrderOtherSpacesDocument = gql`
    query OffsiteOrderOtherSpaces($offsiteLocationID: ID!) {
  meetingRooms: offsiteLocation(id: $offsiteLocationID) {
    id
    name
    ...OffsiteOrderLocationSpaces__MeetingRooms
  }
  dayPasses: offsiteLocation(id: $offsiteLocationID) {
    id
    name
    ...OffsiteOrderLocationSpaces__DayPasses
  }
  privateOffices: offsiteLocation(id: $offsiteLocationID) {
    id
    name
    ...OffsiteOrderLocationSpaces__PrivateOffices
  }
}
    ${OffsiteOrderLocationSpaces__MeetingRoomsFragmentDoc}
${OffsiteOrderLocationSpaces__DayPassesFragmentDoc}
${OffsiteOrderLocationSpaces__PrivateOfficesFragmentDoc}`;
export const OrderPageDocument = gql`
    query OrderPage {
  currentUser {
    id
    organization {
      monthlyBilling
    }
  }
}
    `;
export const SpaceCheckoutCurrentUserPaymentMethodDocument = gql`
    query SpaceCheckoutCurrentUserPaymentMethod {
  currentUser {
    id
    organization {
      id
      monthlyBilling
    }
    paymentMethod {
      ... on CardPaymentMethod {
        id
        last4
        network
        networkLogoUrl
      }
    }
  }
}
    `;
export const SpaceDetailsCurrentUserPaymentMethodDocument = gql`
    query SpaceDetailsCurrentUserPaymentMethod {
  currentUser {
    id
    paymentMethod {
      ... on CardPaymentMethod {
        id
        last4
        network
        networkLogoUrl
      }
    }
  }
}
    `;
export const CreateBookingRequestDocument = gql`
    mutation CreateBookingRequest($input: CreateBookingRequestInput!) {
  createBookingRequest(input: $input) {
    id
  }
}
    `;
export const CancelBookingRequestDocument = gql`
    mutation CancelBookingRequest($input: CancelBookingRequestInput!) {
  cancelBookingRequest(input: $input) {
    id
  }
}
    `;
export const UserBookingRequestsDocument = gql`
    query UserBookingRequests($spaceId: ID!) {
  space(id: $spaceId) {
    id
    bookingRequests {
      id
      startDate
      endDate
      startTime
      endTime
      reason
      status
    }
  }
}
    `;
export const BestDayRatesDocument = gql`
    query BestDayRates($spaceId: ID!, $bookingType: BookingType!, $startDate: String!, $endDate: String!) {
  space(id: $spaceId) {
    bestDayRates(
      input: {bookingType: $bookingType, startDate: $startDate, endDate: $endDate}
    ) {
      date
      price
    }
  }
}
    `;
export const SetFavoriteSpaceDocument = gql`
    mutation setFavoriteSpace($input: CreateFavoriteSpaceInput!) {
  setFavoriteSpace(input: $input)
}
    `;
export const SetFavoriteLocationDocument = gql`
    mutation setFavoriteLocation($input: CreateFavoriteLocationInput!) {
  setFavoriteLocation(input: $input)
}
    `;
export const RemoveFavoriteDocument = gql`
    mutation removeFavorite($input: RemoveFavoriteResourceInput!) {
  removeFavoriteResource(input: $input)
}
    `;
export const OffsiteSpacePageV2Document = gql`
    query OffsiteSpacePageV2($id: ID!) {
  space(id: $id) {
    id
    ...OffsiteSpacePage__SpaceDetailsV2
  }
}
    ${OffsiteSpacePage__SpaceDetailsV2FragmentDoc}`;
export const OffsiteSpaceDetailsWhosHereV2Document = gql`
    query OffsiteSpaceDetailsWhosHereV2($offsiteLocationID: ID!, $startDate: String!, $endDate: String!) {
  offsiteLocation(id: $offsiteLocationID) {
    id
    bookings(startDate: $startDate, endDate: $endDate) {
      ...OffsiteSpaceDetailsWhosHere__BookingDetailsV2
    }
  }
}
    ${OffsiteSpaceDetailsWhosHere__BookingDetailsV2FragmentDoc}`;
export const SpaceDetailsCurrentUserMonthlyBillingV2Document = gql`
    query SpaceDetailsCurrentUserMonthlyBillingV2 {
  currentUser {
    id
    organization {
      monthlyBilling
    }
  }
}
    `;
export const CurrentUserOrganizationNameDocument = gql`
    query CurrentUserOrganizationName($status: UserStatus) {
  currentUser {
    id
    role
    email
    authMethod
    organization {
      id
      name
      domain
      requireSSO
      ssoProvider
      logoUrl
      slug
      monthlyBilling
      plan
      createdAt
      users(status: $status) {
        userId
      }
    }
  }
}
    `;
export const UpdateOrganizationNameDocument = gql`
    mutation updateOrganizationName($input: UpdateOrganizationNameInput!) {
  updateOrganizationName(input: $input) {
    id
    name
  }
}
    `;
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    id
    name
    domain
  }
}
    `;
export const RecentActivityOrdersSummaryDocument = gql`
    query RecentActivityOrdersSummary {
  currentUser {
    organization {
      ordersSummary {
        orders {
          ...ReportingPageOrderSummary
        }
        lastUpdatedDate
      }
    }
  }
}
    ${ReportingPageOrderSummaryFragmentDoc}`;
export const ReportingPageOrganizationReportingDocument = gql`
    query ReportingPageOrganizationReporting($startDate: String!, $endDate: String!) {
  currentUser {
    organization {
      reporting(startDate: $startDate, endDate: $endDate) {
        ...ReportingPageReportingData
      }
    }
  }
}
    ${ReportingPageReportingDataFragmentDoc}`;
export const ReportingPageOrganizationBudgetDocument = gql`
    query ReportingPageOrganizationBudget {
  currentUser {
    organization {
      budget {
        ...ReportingPageBudgetData
      }
    }
  }
}
    ${ReportingPageBudgetDataFragmentDoc}`;
export const ReportingPageOrganizationTotalSpendDocument = gql`
    query ReportingPageOrganizationTotalSpend($startDate: String!, $endDate: String!) {
  currentUser {
    organization {
      reporting(startDate: $startDate, endDate: $endDate) {
        ...ReportingPageReportingTotal
      }
    }
  }
}
    ${ReportingPageReportingTotalFragmentDoc}`;
export const UpdateOrganizationBudgetReportingBudgetCardHookDocument = gql`
    mutation UpdateOrganizationBudgetReportingBudgetCardHook($input: UpdateOrganizationBudgetInput!) {
  updateOrganizationBudget(input: $input) {
    budget
  }
}
    `;
export const ReportingPageCurrentUserDocument = gql`
    query ReportingPageCurrentUser {
  currentUser {
    id
    organization {
      monthlyBilling
      paymentMode
      createdAt
    }
  }
}
    `;
export const SavedSpacesDocument = gql`
    query SavedSpaces {
  currentUser {
    id
    favoriteSpaces {
      ...SavedSpaces__SpaceDetails
    }
  }
}
    ${SavedSpaces__SpaceDetailsFragmentDoc}`;
export const SavedLocationsDocument = gql`
    query SavedLocations {
  currentUser {
    id
    favoriteLocations {
      ...SavedLocations__LocationDetails
    }
  }
}
    ${SavedLocations__LocationDetailsFragmentDoc}`;
export const StepFinalDocument = gql`
    query StepFinal {
  currentUser {
    id
    createdWith
    createdAt
    role
    auth0PrimaryEmail
    fullName
    email
    organization {
      id
      name
      createdAt
      createdWith
    }
  }
}
    `;
export const IsEmailTakenDocument = gql`
    query IsEmailTaken($email: String!) {
  isEmailTaken(email: $email)
}
    `;
export const InviteToTeamDocument = gql`
    mutation InviteToTeam($input: InviteToTeamInput!) {
  inviteToTeam(input: $input)
}
    `;
export const StepInviteOthersDocument = gql`
    query StepInviteOthers {
  currentUser {
    id
    organization {
      id
      name
    }
  }
}
    `;
export const InviteByEmailDocument = gql`
    query InviteByEmail($inviteeEmail: String!, $status: String) {
  inviteByEmail(inviteeEmail: $inviteeEmail, status: $status) {
    id
    status
    organization {
      id
      name
      users {
        id
        picture
        role
        userId
        fullName
      }
    }
  }
}
    `;
export const OrganizationByDomainDocument = gql`
    query OrganizationByDomain($domain: String!) {
  organizationByDomain(domain: $domain) {
    id
    name
    users {
      id
      picture
      userId
      role
      fullName
    }
  }
}
    `;
export const StepTeamDocument = gql`
    query StepTeam {
  currentUser {
    id
    auth0PrimaryEmail
    fullName
    organization {
      id
    }
  }
}
    `;
export const RegisterGoogleAccountToOrganizationIfExistsDocument = gql`
    mutation RegisterGoogleAccountToOrganizationIfExists {
  registerGoogleAccountToOrganizationIfExists
}
    `;
export const TeamUserInfoCurrentUserDocument = gql`
    query TeamUserInfoCurrentUser {
  currentUser {
    id
  }
}
    `;
export const AddCityDocument = gql`
    mutation AddCity($input: AddCityInput!) {
  addCity(input: $input) {
    name
  }
}
    `;
export const OrgUsersDocument = gql`
    query OrgUsers($startDate: String!, $endDate: String!, $currentUserCoordinates: SpaceSearchCoordinates, $status: UserStatus) {
  currentUser {
    city {
      ...CityDetails
    }
    organization {
      users(status: $status) {
        ...OrgUserDetails
      }
    }
  }
}
    ${CityDetailsFragmentDoc}
${OrgUserDetailsFragmentDoc}`;
export const TeamUsersDocument = gql`
    query teamUsers($status: UserStatus) {
  currentUser {
    id
    organization {
      id
      name
      users(status: $status) {
        id
        userId
        role
        picture
        title
        email
        fullName
      }
    }
  }
}
    `;
export const GetOrgDataDocument = gql`
    query GetOrgData($startDate: String!, $endDate: String!, $currentUserCoordinates: SpaceSearchCoordinates, $status: UserStatus) {
  currentUser {
    organization {
      users(status: $status) {
        id
      }
      bookings(startDate: $startDate, endDate: $endDate) {
        ...TeamsBookingDetails
      }
      mostBookedSpaces {
        ...TeamsSpaceDetails
      }
    }
  }
}
    ${TeamsBookingDetailsFragmentDoc}
${TeamsSpaceDetailsFragmentDoc}`;
export const TodayRequestsDocument = gql`
    query TodayRequests {
  currentUser {
    organization {
      bookingRequests {
        ...TodayPage__RequestDetails
      }
    }
    groupBudget {
      bookingRequests {
        ...TodayPage__RequestDetails
      }
    }
  }
}
    ${TodayPage__RequestDetailsFragmentDoc}`;
export const TodayCurrentUserDocument = gql`
    query TodayCurrentUser {
  currentUser {
    id
    fullName
  }
}
    `;
export const MenuCardListDocument = gql`
    query MenuCardList {
  currentUser {
    id
    role
    groupBudgetRole
    organization {
      id
      paymentMode
      plan
    }
  }
}
    `;
export const UserProfileDocument = gql`
    query UserProfile {
  currentUser {
    id
    role
    groupBudgetRole
    groupBudget {
      id
      name
    }
    organization {
      id
      paymentMode
      plan
    }
  }
}
    `;
export const BookingPolicyDocument = gql`
    query BookingPolicy {
  currentUser {
    organization {
      users(role: "admin") {
        ...User
      }
      budget {
        limit
        individualLimit
        policy {
          ...Policy
        }
      }
    }
    groupBudget {
      members {
        role
        user {
          ...User
        }
      }
      limit
      individualLimit
      policy {
        ...Policy
      }
    }
  }
}
    ${UserFragmentDoc}
${PolicyFragmentDoc}`;
export const ProfileUpdateUserDocument = gql`
    mutation ProfileUpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    title
    hasBookedBefore
    fullName
    email
    phoneNumber
  }
}
    `;
export const ProfileCurrentUserDocument = gql`
    query ProfileCurrentUser {
  currentUser {
    id
    title
    hasBookedBefore
    hasSignedUpWithSocialProvider
    fullName
    email
    phoneNumber
    organization {
      id
      name
    }
  }
}
    `;
export const PaymentMethodDocument = gql`
    query PaymentMethod {
  paymentMethod {
    ... on CardPaymentMethod {
      id
      last4
      network
      networkLogoUrl
    }
  }
}
    `;
export const CancelOrderDocument = gql`
    mutation cancelOrder($orderID: ID!) {
  cancelOrder(orderID: $orderID)
}
    `;
export const ReservationDetailsCurrentUserDocument = gql`
    query ReservationDetailsCurrentUser {
  currentUser {
    id
    organization {
      monthlyBilling
    }
  }
}
    `;
export const ReservationsPageDocument = gql`
    query ReservationsPage {
  currentUser {
    orders {
      ...ReservationPage__OrderDetails
    }
  }
}
    ${ReservationPage__OrderDetailsFragmentDoc}`;
export const CurrentUserAnalyticsDocument = gql`
    query CurrentUserAnalytics {
  currentUser {
    id
    createdWith
    createdAt
    role
    auth0PrimaryEmail
    fullName
    email
    organization {
      id
      name
      createdAt
      createdWith
    }
  }
}
    `;
export const LinkGoogleAccountToPasswordAccountIfExistsDocument = gql`
    mutation LinkGoogleAccountToPasswordAccountIfExists {
  linkGoogleAccountToPasswordAccountIfExists
}
    `;
export const RegisterPasswordAccountToOrganizationIfExistsDocument = gql`
    mutation registerPasswordAccountToOrganizationIfExists {
  registerEmailAccountToOrganizationIfExists
}
    `;
export const RegisterOktaAccountToOrganizationIfExistsDocument = gql`
    mutation RegisterOktaAccountToOrganizationIfExists {
  registerOktaAccountToOrganizationIfExists
}
    `;
export const AuthLoaderDocument = gql`
    query AuthLoader {
  currentUser {
    id
    authMethod
    fullName
    email
    auth0PrimaryEmail
    organization {
      id
      name
    }
  }
}
    `;
export const OrgByDomainDocument = gql`
    query orgByDomain($domain: String!) {
  organizationByDomain(domain: $domain) {
    id
    name
    requireSSO
    ssoProvider
    logoUrl
    slug
    connectionName
  }
}
    `;
export const PostAuthDocument = gql`
    mutation postAuth($inviteId: String) {
  postAuth(inviteId: $inviteId) {
    linked
    orgRegistered
    acceptedInvite
  }
}
    `;
export const CurrentUserIdDocument = gql`
    query CurrentUserId {
  currentUser {
    id
    organization {
      id
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    AppHeaderV3Desktop(variables?: AppHeaderV3DesktopQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AppHeaderV3DesktopQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppHeaderV3DesktopQuery>(AppHeaderV3DesktopDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AppHeaderV3Desktop', 'query');
    },
    userSpacePolicy(variables?: UserSpacePolicyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UserSpacePolicyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserSpacePolicyQuery>(UserSpacePolicyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userSpacePolicy', 'query');
    },
    InviteToTeamInApp(variables: InviteToTeamInAppMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InviteToTeamInAppMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InviteToTeamInAppMutation>(InviteToTeamInAppDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'InviteToTeamInApp', 'mutation');
    },
    InAppInviteCurrentUser(variables?: InAppInviteCurrentUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InAppInviteCurrentUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InAppInviteCurrentUserQuery>(InAppInviteCurrentUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'InAppInviteCurrentUser', 'query');
    },
    Sidebar(variables?: SidebarQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SidebarQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SidebarQuery>(SidebarDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Sidebar', 'query');
    },
    createOrganization(variables: CreateOrganizationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrganizationMutation>(CreateOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrganization', 'mutation');
    },
    UserDomain(variables?: UserDomainQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UserDomainQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserDomainQuery>(UserDomainDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserDomain', 'query');
    },
    CurrentUserInfo(variables?: CurrentUserInfoQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CurrentUserInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentUserInfoQuery>(CurrentUserInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CurrentUserInfo', 'query');
    },
    BetterHourRates(variables: BetterHourRatesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BetterHourRatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BetterHourRatesQuery>(BetterHourRatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BetterHourRates', 'query');
    },
    updateOrderMemo(variables: UpdateOrderMemoMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateOrderMemoMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrderMemoMutation>(UpdateOrderMemoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrderMemo', 'mutation');
    },
    SpaceAvailableDays(variables: SpaceAvailableDaysQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SpaceAvailableDaysQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpaceAvailableDaysQuery>(SpaceAvailableDaysDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SpaceAvailableDays', 'query');
    },
    SpaceAvailableTimeSlots(variables: SpaceAvailableTimeSlotsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SpaceAvailableTimeSlotsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpaceAvailableTimeSlotsQuery>(SpaceAvailableTimeSlotsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SpaceAvailableTimeSlots', 'query');
    },
    BookingUtilsOrderDetails(variables: BookingUtilsOrderDetailsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingUtilsOrderDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingUtilsOrderDetailsQuery>(BookingUtilsOrderDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BookingUtilsOrderDetails', 'query');
    },
    Checkout(variables: CheckoutMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CheckoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckoutMutation>(CheckoutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Checkout', 'mutation');
    },
    BookingUpdateUser(variables: BookingUpdateUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingUpdateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingUpdateUserMutation>(BookingUpdateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BookingUpdateUser', 'mutation');
    },
    SpaceCheckoutCurrentUserInfo(variables?: SpaceCheckoutCurrentUserInfoQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SpaceCheckoutCurrentUserInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpaceCheckoutCurrentUserInfoQuery>(SpaceCheckoutCurrentUserInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SpaceCheckoutCurrentUserInfo', 'query');
    },
    SpaceCheckoutSpaceInfo(variables: SpaceCheckoutSpaceInfoQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SpaceCheckoutSpaceInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpaceCheckoutSpaceInfoQuery>(SpaceCheckoutSpaceInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SpaceCheckoutSpaceInfo', 'query');
    },
    BottomBarAdminNavigation(variables?: BottomBarAdminNavigationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BottomBarAdminNavigationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BottomBarAdminNavigationQuery>(BottomBarAdminNavigationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BottomBarAdminNavigation', 'query');
    },
    UserAvatar(variables?: UserAvatarQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UserAvatarQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserAvatarQuery>(UserAvatarDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserAvatar', 'query');
    },
    DetachPaymentMethod(variables: DetachPaymentMethodMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DetachPaymentMethodMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DetachPaymentMethodMutation>(DetachPaymentMethodDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DetachPaymentMethod', 'mutation');
    },
    SetupPaymentMethodUpdate(variables?: SetupPaymentMethodUpdateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SetupPaymentMethodUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetupPaymentMethodUpdateMutation>(SetupPaymentMethodUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetupPaymentMethodUpdate', 'mutation');
    },
    BookingPaymentMethod(variables?: BookingPaymentMethodQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingPaymentMethodQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingPaymentMethodQuery>(BookingPaymentMethodDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BookingPaymentMethod', 'query');
    },
    CheckOutPaymentDetails(variables?: CheckOutPaymentDetailsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CheckOutPaymentDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckOutPaymentDetailsQuery>(CheckOutPaymentDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CheckOutPaymentDetails', 'query');
    },
    OffsiteLocationWhosHere(variables: OffsiteLocationWhosHereQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OffsiteLocationWhosHereQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OffsiteLocationWhosHereQuery>(OffsiteLocationWhosHereDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OffsiteLocationWhosHere', 'query');
    },
    OffsiteDetailsWhosHere(variables?: OffsiteDetailsWhosHereQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OffsiteDetailsWhosHereQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OffsiteDetailsWhosHereQuery>(OffsiteDetailsWhosHereDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OffsiteDetailsWhosHere', 'query');
    },
    BookingRequestsAdminStatuses(variables?: BookingRequestsAdminStatusesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingRequestsAdminStatusesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingRequestsAdminStatusesQuery>(BookingRequestsAdminStatusesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BookingRequestsAdminStatuses', 'query');
    },
    BookingRequestsManagerStatuses(variables?: BookingRequestsManagerStatusesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingRequestsManagerStatusesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingRequestsManagerStatusesQuery>(BookingRequestsManagerStatusesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BookingRequestsManagerStatuses', 'query');
    },
    PromoCodeIsValid(variables: PromoCodeIsValidQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PromoCodeIsValidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PromoCodeIsValidQuery>(PromoCodeIsValidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PromoCodeIsValid', 'query');
    },
    QuoteDetails(variables: QuoteDetailsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<QuoteDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuoteDetailsQuery>(QuoteDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'QuoteDetails', 'query');
    },
    SpaceDetails(variables: SpaceDetailsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SpaceDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpaceDetailsQuery>(SpaceDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SpaceDetails', 'query');
    },
    CurrentUser(variables?: CurrentUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CurrentUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentUserQuery>(CurrentUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CurrentUser', 'query');
    },
    Person(variables?: PersonQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PersonQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PersonQuery>(PersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Person', 'query');
    },
    SideBar(variables?: SideBarQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SideBarQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SideBarQuery>(SideBarDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SideBar', 'query');
    },
    SendInvites(variables: SendInvitesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SendInvitesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendInvitesMutation>(SendInvitesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SendInvites', 'mutation');
    },
    HookUserRole(variables?: HookUserRoleQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<HookUserRoleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<HookUserRoleQuery>(HookUserRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'HookUserRole', 'query');
    },
    OrganizationByInviteQuery(variables: OrganizationByInviteQueryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OrganizationByInviteQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganizationByInviteQueryQuery>(OrganizationByInviteQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OrganizationByInviteQuery', 'query');
    },
    AcceptInviteCodeVerified(variables?: AcceptInviteCodeVerifiedQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AcceptInviteCodeVerifiedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcceptInviteCodeVerifiedQuery>(AcceptInviteCodeVerifiedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AcceptInviteCodeVerified', 'query');
    },
    LinkEmailAccountToPasswordAccountIfExists(variables?: LinkEmailAccountToPasswordAccountIfExistsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LinkEmailAccountToPasswordAccountIfExistsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LinkEmailAccountToPasswordAccountIfExistsMutation>(LinkEmailAccountToPasswordAccountIfExistsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LinkEmailAccountToPasswordAccountIfExists', 'mutation');
    },
    CurrentUserStepCode(variables?: CurrentUserStepCodeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CurrentUserStepCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentUserStepCodeQuery>(CurrentUserStepCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CurrentUserStepCode', 'query');
    },
    AcceptInvite(variables: AcceptInviteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AcceptInviteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcceptInviteMutation>(AcceptInviteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AcceptInvite', 'mutation');
    },
    UserInfo(variables?: UserInfoQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UserInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserInfoQuery>(UserInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserInfo', 'query');
    },
    BookingDetails(variables: BookingDetailsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingDetailsQuery>(BookingDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BookingDetails', 'query');
    },
    cancelBooking(variables: CancelBookingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CancelBookingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelBookingMutation>(CancelBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cancelBooking', 'mutation');
    },
    ApproveBookingRequest(variables: ApproveBookingRequestMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ApproveBookingRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApproveBookingRequestMutation>(ApproveBookingRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ApproveBookingRequest', 'mutation');
    },
    DeclineBookingRequest(variables: DeclineBookingRequestMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeclineBookingRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeclineBookingRequestMutation>(DeclineBookingRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeclineBookingRequest', 'mutation');
    },
    BookingRequests(variables?: BookingRequestsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingRequestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingRequestsQuery>(BookingRequestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BookingRequests', 'query');
    },
    BudgetBookingRequests(variables?: BudgetBookingRequestsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BudgetBookingRequestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BudgetBookingRequestsQuery>(BudgetBookingRequestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BudgetBookingRequests', 'query');
    },
    Bookings(variables?: BookingsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingsQuery>(BookingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Bookings', 'query');
    },
    InviteesRemaining(variables: InviteesRemainingQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InviteesRemainingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InviteesRemainingQuery>(InviteesRemainingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'InviteesRemaining', 'query');
    },
    getOrgName(variables?: GetOrgNameQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOrgNameQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrgNameQuery>(GetOrgNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrgName', 'query');
    },
    OrgBudget(variables?: OrgBudgetQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OrgBudgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrgBudgetQuery>(OrgBudgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OrgBudget', 'query');
    },
    updateOrderBudget(variables: UpdateOrderBudgetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateOrderBudgetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrderBudgetMutation>(UpdateOrderBudgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrderBudget', 'mutation');
    },
    PeoplePicker(variables?: PeoplePickerQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PeoplePickerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PeoplePickerQuery>(PeoplePickerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PeoplePicker', 'query');
    },
    Budget(variables?: BudgetQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BudgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BudgetQuery>(BudgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Budget', 'query');
    },
    PreMovingGroupBudgetPeopleMessageQuery(variables: PreMovingGroupBudgetPeopleMessageQueryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PreMovingGroupBudgetPeopleMessageQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreMovingGroupBudgetPeopleMessageQueryQuery>(PreMovingGroupBudgetPeopleMessageQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PreMovingGroupBudgetPeopleMessageQuery', 'query');
    },
    UpdateGroupBudgetAddMember(variables: UpdateGroupBudgetAddMemberMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateGroupBudgetAddMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateGroupBudgetAddMemberMutation>(UpdateGroupBudgetAddMemberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateGroupBudgetAddMember', 'mutation');
    },
    ReactivateGroupBudget(variables: ReactivateGroupBudgetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ReactivateGroupBudgetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReactivateGroupBudgetMutation>(ReactivateGroupBudgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ReactivateGroupBudget', 'mutation');
    },
    CreateGroupBudget(variables: CreateGroupBudgetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateGroupBudgetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateGroupBudgetMutation>(CreateGroupBudgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateGroupBudget', 'mutation');
    },
    CreateGroupBudgetOrganizationBudget(variables?: CreateGroupBudgetOrganizationBudgetQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateGroupBudgetOrganizationBudgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateGroupBudgetOrganizationBudgetQuery>(CreateGroupBudgetOrganizationBudgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateGroupBudgetOrganizationBudget', 'query');
    },
    UserRoleAndOrgInfo(variables: UserRoleAndOrgInfoQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UserRoleAndOrgInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserRoleAndOrgInfoQuery>(UserRoleAndOrgInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserRoleAndOrgInfo', 'query');
    },
    GroupBudgetDetailPeople(variables: GroupBudgetDetailPeopleQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GroupBudgetDetailPeopleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GroupBudgetDetailPeopleQuery>(GroupBudgetDetailPeopleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GroupBudgetDetailPeople', 'query');
    },
    GroupBudgetDetail(variables: GroupBudgetDetailQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GroupBudgetDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GroupBudgetDetailQuery>(GroupBudgetDetailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GroupBudgetDetail', 'query');
    },
    GroupBudgetDetailTransactions(variables: GroupBudgetDetailTransactionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GroupBudgetDetailTransactionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GroupBudgetDetailTransactionsQuery>(GroupBudgetDetailTransactionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GroupBudgetDetailTransactions', 'query');
    },
    UpdateGroupBudget(variables: UpdateGroupBudgetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateGroupBudgetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateGroupBudgetMutation>(UpdateGroupBudgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateGroupBudget', 'mutation');
    },
    UpdateGroupBudgetOrganizationBudget(variables: UpdateGroupBudgetOrganizationBudgetQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateGroupBudgetOrganizationBudgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateGroupBudgetOrganizationBudgetQuery>(UpdateGroupBudgetOrganizationBudgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateGroupBudgetOrganizationBudget', 'query');
    },
    DeactivateGroupBudget(variables: DeactivateGroupBudgetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeactivateGroupBudgetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeactivateGroupBudgetMutation>(DeactivateGroupBudgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeactivateGroupBudget', 'mutation');
    },
    createOrganizationBudget(variables: CreateOrganizationBudgetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateOrganizationBudgetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrganizationBudgetMutation>(CreateOrganizationBudgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrganizationBudget', 'mutation');
    },
    OrganizationBudgetDetail(variables: OrganizationBudgetDetailQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OrganizationBudgetDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganizationBudgetDetailQuery>(OrganizationBudgetDetailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OrganizationBudgetDetail', 'query');
    },
    OrganizationBudgetDetailTransactions(variables: OrganizationBudgetDetailTransactionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OrganizationBudgetDetailTransactionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganizationBudgetDetailTransactionsQuery>(OrganizationBudgetDetailTransactionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OrganizationBudgetDetailTransactions', 'query');
    },
    UpdateOrganizationBudget(variables: UpdateOrganizationBudgetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateOrganizationBudgetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrganizationBudgetMutation>(UpdateOrganizationBudgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateOrganizationBudget', 'mutation');
    },
    EditOrganizationBudget(variables?: EditOrganizationBudgetQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<EditOrganizationBudgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditOrganizationBudgetQuery>(EditOrganizationBudgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EditOrganizationBudget', 'query');
    },
    Policies(variables?: PoliciesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PoliciesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PoliciesQuery>(PoliciesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Policies', 'query');
    },
    RemoveAddress(variables: RemoveAddressMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveAddressMutation>(RemoveAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveAddress', 'mutation');
    },
    CreatePolicy(variables: CreatePolicyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreatePolicyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePolicyMutation>(CreatePolicyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreatePolicy', 'mutation');
    },
    BudgetPolicy(variables: BudgetPolicyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BudgetPolicyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BudgetPolicyQuery>(BudgetPolicyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BudgetPolicy', 'query');
    },
    UpdateBudgetPolicy(variables: UpdateBudgetPolicyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateBudgetPolicyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateBudgetPolicyMutation>(UpdateBudgetPolicyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateBudgetPolicy', 'mutation');
    },
    GroupBudgets(variables?: GroupBudgetsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GroupBudgetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GroupBudgetsQuery>(GroupBudgetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GroupBudgets', 'query');
    },
    BudgetPolicies(variables?: BudgetPoliciesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BudgetPoliciesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BudgetPoliciesQuery>(BudgetPoliciesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BudgetPolicies', 'query');
    },
    BudgetPolicyAddresses(variables?: BudgetPolicyAddressesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BudgetPolicyAddressesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BudgetPolicyAddressesQuery>(BudgetPolicyAddressesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BudgetPolicyAddresses', 'query');
    },
    orgBySlug(variables: OrgBySlugQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OrgBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrgBySlugQuery>(OrgBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orgBySlug', 'query');
    },
    SendSupportTicket(variables: SendSupportTicketMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SendSupportTicketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendSupportTicketMutation>(SendSupportTicketDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SendSupportTicket', 'mutation');
    },
    LocationPreviewSpaces(variables: LocationPreviewSpacesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LocationPreviewSpacesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LocationPreviewSpacesQuery>(LocationPreviewSpacesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LocationPreviewSpaces', 'query');
    },
    SpaceCardCurrentUserCountry(variables?: SpaceCardCurrentUserCountryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SpaceCardCurrentUserCountryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpaceCardCurrentUserCountryQuery>(SpaceCardCurrentUserCountryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SpaceCardCurrentUserCountry', 'query');
    },
    SpaceTypeFilterAmenities(variables?: SpaceTypeFilterAmenitiesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SpaceTypeFilterAmenitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpaceTypeFilterAmenitiesQuery>(SpaceTypeFilterAmenitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SpaceTypeFilterAmenities', 'query');
    },
    EmptyStateTileB(variables?: EmptyStateTileBQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<EmptyStateTileBQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmptyStateTileBQuery>(EmptyStateTileBDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EmptyStateTileB', 'query');
    },
    RecommendedSpaceList(variables: RecommendedSpaceListQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RecommendedSpaceListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecommendedSpaceListQuery>(RecommendedSpaceListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RecommendedSpaceList', 'query');
    },
    RecommendedLocationList(variables?: RecommendedLocationListQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RecommendedLocationListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecommendedLocationListQuery>(RecommendedLocationListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RecommendedLocationList', 'query');
    },
    EmptyStatesOtherSpaces(variables?: EmptyStatesOtherSpacesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<EmptyStatesOtherSpacesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmptyStatesOtherSpacesQuery>(EmptyStatesOtherSpacesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EmptyStatesOtherSpaces', 'query');
    },
    HomePage(variables: HomePageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<HomePageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<HomePageQuery>(HomePageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'HomePage', 'query');
    },
    HomePageLocations(variables?: HomePageLocationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<HomePageLocationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<HomePageLocationsQuery>(HomePageLocationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'HomePageLocations', 'query');
    },
    CurrentUserIpPlaceCoordinatesHook(variables?: CurrentUserIpPlaceCoordinatesHookQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CurrentUserIpPlaceCoordinatesHookQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentUserIpPlaceCoordinatesHookQuery>(CurrentUserIpPlaceCoordinatesHookDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CurrentUserIpPlaceCoordinatesHook', 'query');
    },
    GetLocationAmenities(variables?: GetLocationAmenitiesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetLocationAmenitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLocationAmenitiesQuery>(GetLocationAmenitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetLocationAmenities', 'query');
    },
    GetUserInfo(variables?: GetUserInfoQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUserInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserInfoQuery>(GetUserInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetUserInfo', 'query');
    },
    GetLocationNearBy(variables?: GetLocationNearByQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetLocationNearByQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLocationNearByQuery>(GetLocationNearByDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetLocationNearBy', 'query');
    },
    GetOrgBooking(variables: GetOrgBookingQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOrgBookingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrgBookingQuery>(GetOrgBookingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetOrgBooking', 'query');
    },
    GetPopularLocation(variables?: GetPopularLocationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPopularLocationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPopularLocationQuery>(GetPopularLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPopularLocation', 'query');
    },
    GetSpaceNearBy(variables: GetSpaceNearByQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSpaceNearByQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSpaceNearByQuery>(GetSpaceNearByDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSpaceNearBy', 'query');
    },
    GetUserOrder(variables?: GetUserOrderQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUserOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserOrderQuery>(GetUserOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetUserOrder', 'query');
    },
    GetUserType(variables?: GetUserTypeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUserTypeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserTypeQuery>(GetUserTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetUserType', 'query');
    },
    LocationDetails(variables: LocationDetailsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LocationDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LocationDetailsQuery>(LocationDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LocationDetails', 'query');
    },
    ManageUsersList(variables?: ManageUsersListQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ManageUsersListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ManageUsersListQuery>(ManageUsersListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ManageUsersList', 'query');
    },
    RevokeInvite(variables: RevokeInviteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RevokeInviteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RevokeInviteMutation>(RevokeInviteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RevokeInvite', 'mutation');
    },
    ChangeUserRole(variables: ChangeUserRoleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ChangeUserRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeUserRoleMutation>(ChangeUserRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ChangeUserRole', 'mutation');
    },
    DeletePerson(variables: DeletePersonMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeletePersonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePersonMutation>(DeletePersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeletePerson', 'mutation');
    },
    OfficePageBookings(variables: OfficePageBookingsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OfficePageBookingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficePageBookingsQuery>(OfficePageBookingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OfficePageBookings', 'query');
    },
    OfficePageDetailsCurrentUser(variables?: OfficePageDetailsCurrentUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OfficePageDetailsCurrentUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficePageDetailsCurrentUserQuery>(OfficePageDetailsCurrentUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OfficePageDetailsCurrentUser', 'query');
    },
    OfficePageDetails(variables: OfficePageDetailsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OfficePageDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficePageDetailsQuery>(OfficePageDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OfficePageDetails', 'query');
    },
    BookOfficeSpaceOnDay(variables: BookOfficeSpaceOnDayMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookOfficeSpaceOnDayMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookOfficeSpaceOnDayMutation>(BookOfficeSpaceOnDayDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BookOfficeSpaceOnDay', 'mutation');
    },
    UnbookOfficeSpace(variables: UnbookOfficeSpaceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UnbookOfficeSpaceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnbookOfficeSpaceMutation>(UnbookOfficeSpaceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UnbookOfficeSpace', 'mutation');
    },
    CheckinOfficeSpaceToday(variables: CheckinOfficeSpaceTodayMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CheckinOfficeSpaceTodayMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckinOfficeSpaceTodayMutation>(CheckinOfficeSpaceTodayDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CheckinOfficeSpaceToday', 'mutation');
    },
    RequestToBookBanner(variables?: RequestToBookBannerQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RequestToBookBannerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestToBookBannerQuery>(RequestToBookBannerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RequestToBookBanner', 'query');
    },
    RequestBudgetIncrease(variables: RequestBudgetIncreaseMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RequestBudgetIncreaseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestBudgetIncreaseMutation>(RequestBudgetIncreaseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RequestBudgetIncrease', 'mutation');
    },
    requestToBook(variables: RequestToBookQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RequestToBookQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestToBookQuery>(RequestToBookDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'requestToBook', 'query');
    },
    OffsiteOrderPage__OrderDetails(variables: OffsiteOrderPage__OrderDetailsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OffsiteOrderPage__OrderDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OffsiteOrderPage__OrderDetailsQuery>(OffsiteOrderPage__OrderDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OffsiteOrderPage__OrderDetails', 'query');
    },
    OffsiteOrderOtherSpaces(variables: OffsiteOrderOtherSpacesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OffsiteOrderOtherSpacesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OffsiteOrderOtherSpacesQuery>(OffsiteOrderOtherSpacesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OffsiteOrderOtherSpaces', 'query');
    },
    OrderPage(variables?: OrderPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OrderPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderPageQuery>(OrderPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OrderPage', 'query');
    },
    SpaceCheckoutCurrentUserPaymentMethod(variables?: SpaceCheckoutCurrentUserPaymentMethodQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SpaceCheckoutCurrentUserPaymentMethodQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpaceCheckoutCurrentUserPaymentMethodQuery>(SpaceCheckoutCurrentUserPaymentMethodDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SpaceCheckoutCurrentUserPaymentMethod', 'query');
    },
    SpaceDetailsCurrentUserPaymentMethod(variables?: SpaceDetailsCurrentUserPaymentMethodQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SpaceDetailsCurrentUserPaymentMethodQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpaceDetailsCurrentUserPaymentMethodQuery>(SpaceDetailsCurrentUserPaymentMethodDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SpaceDetailsCurrentUserPaymentMethod', 'query');
    },
    CreateBookingRequest(variables: CreateBookingRequestMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateBookingRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateBookingRequestMutation>(CreateBookingRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateBookingRequest', 'mutation');
    },
    CancelBookingRequest(variables: CancelBookingRequestMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CancelBookingRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelBookingRequestMutation>(CancelBookingRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CancelBookingRequest', 'mutation');
    },
    UserBookingRequests(variables: UserBookingRequestsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UserBookingRequestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserBookingRequestsQuery>(UserBookingRequestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserBookingRequests', 'query');
    },
    BestDayRates(variables: BestDayRatesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BestDayRatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BestDayRatesQuery>(BestDayRatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BestDayRates', 'query');
    },
    setFavoriteSpace(variables: SetFavoriteSpaceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SetFavoriteSpaceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetFavoriteSpaceMutation>(SetFavoriteSpaceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setFavoriteSpace', 'mutation');
    },
    setFavoriteLocation(variables: SetFavoriteLocationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SetFavoriteLocationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetFavoriteLocationMutation>(SetFavoriteLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setFavoriteLocation', 'mutation');
    },
    removeFavorite(variables: RemoveFavoriteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveFavoriteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveFavoriteMutation>(RemoveFavoriteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeFavorite', 'mutation');
    },
    OffsiteSpacePageV2(variables: OffsiteSpacePageV2QueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OffsiteSpacePageV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<OffsiteSpacePageV2Query>(OffsiteSpacePageV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OffsiteSpacePageV2', 'query');
    },
    OffsiteSpaceDetailsWhosHereV2(variables: OffsiteSpaceDetailsWhosHereV2QueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OffsiteSpaceDetailsWhosHereV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<OffsiteSpaceDetailsWhosHereV2Query>(OffsiteSpaceDetailsWhosHereV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OffsiteSpaceDetailsWhosHereV2', 'query');
    },
    SpaceDetailsCurrentUserMonthlyBillingV2(variables?: SpaceDetailsCurrentUserMonthlyBillingV2QueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SpaceDetailsCurrentUserMonthlyBillingV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpaceDetailsCurrentUserMonthlyBillingV2Query>(SpaceDetailsCurrentUserMonthlyBillingV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SpaceDetailsCurrentUserMonthlyBillingV2', 'query');
    },
    CurrentUserOrganizationName(variables?: CurrentUserOrganizationNameQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CurrentUserOrganizationNameQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentUserOrganizationNameQuery>(CurrentUserOrganizationNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CurrentUserOrganizationName', 'query');
    },
    updateOrganizationName(variables: UpdateOrganizationNameMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateOrganizationNameMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrganizationNameMutation>(UpdateOrganizationNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrganizationName', 'mutation');
    },
    updateOrganization(variables: UpdateOrganizationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrganizationMutation>(UpdateOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrganization', 'mutation');
    },
    RecentActivityOrdersSummary(variables?: RecentActivityOrdersSummaryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RecentActivityOrdersSummaryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecentActivityOrdersSummaryQuery>(RecentActivityOrdersSummaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RecentActivityOrdersSummary', 'query');
    },
    ReportingPageOrganizationReporting(variables: ReportingPageOrganizationReportingQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ReportingPageOrganizationReportingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportingPageOrganizationReportingQuery>(ReportingPageOrganizationReportingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ReportingPageOrganizationReporting', 'query');
    },
    ReportingPageOrganizationBudget(variables?: ReportingPageOrganizationBudgetQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ReportingPageOrganizationBudgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportingPageOrganizationBudgetQuery>(ReportingPageOrganizationBudgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ReportingPageOrganizationBudget', 'query');
    },
    ReportingPageOrganizationTotalSpend(variables: ReportingPageOrganizationTotalSpendQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ReportingPageOrganizationTotalSpendQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportingPageOrganizationTotalSpendQuery>(ReportingPageOrganizationTotalSpendDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ReportingPageOrganizationTotalSpend', 'query');
    },
    UpdateOrganizationBudgetReportingBudgetCardHook(variables: UpdateOrganizationBudgetReportingBudgetCardHookMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateOrganizationBudgetReportingBudgetCardHookMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrganizationBudgetReportingBudgetCardHookMutation>(UpdateOrganizationBudgetReportingBudgetCardHookDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateOrganizationBudgetReportingBudgetCardHook', 'mutation');
    },
    ReportingPageCurrentUser(variables?: ReportingPageCurrentUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ReportingPageCurrentUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportingPageCurrentUserQuery>(ReportingPageCurrentUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ReportingPageCurrentUser', 'query');
    },
    SavedSpaces(variables?: SavedSpacesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SavedSpacesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SavedSpacesQuery>(SavedSpacesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SavedSpaces', 'query');
    },
    SavedLocations(variables?: SavedLocationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SavedLocationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SavedLocationsQuery>(SavedLocationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SavedLocations', 'query');
    },
    StepFinal(variables?: StepFinalQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<StepFinalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StepFinalQuery>(StepFinalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'StepFinal', 'query');
    },
    IsEmailTaken(variables: IsEmailTakenQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IsEmailTakenQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IsEmailTakenQuery>(IsEmailTakenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'IsEmailTaken', 'query');
    },
    InviteToTeam(variables: InviteToTeamMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InviteToTeamMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InviteToTeamMutation>(InviteToTeamDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'InviteToTeam', 'mutation');
    },
    StepInviteOthers(variables?: StepInviteOthersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<StepInviteOthersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StepInviteOthersQuery>(StepInviteOthersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'StepInviteOthers', 'query');
    },
    InviteByEmail(variables: InviteByEmailQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InviteByEmailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InviteByEmailQuery>(InviteByEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'InviteByEmail', 'query');
    },
    OrganizationByDomain(variables: OrganizationByDomainQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OrganizationByDomainQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganizationByDomainQuery>(OrganizationByDomainDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OrganizationByDomain', 'query');
    },
    StepTeam(variables?: StepTeamQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<StepTeamQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StepTeamQuery>(StepTeamDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'StepTeam', 'query');
    },
    RegisterGoogleAccountToOrganizationIfExists(variables?: RegisterGoogleAccountToOrganizationIfExistsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RegisterGoogleAccountToOrganizationIfExistsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegisterGoogleAccountToOrganizationIfExistsMutation>(RegisterGoogleAccountToOrganizationIfExistsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RegisterGoogleAccountToOrganizationIfExists', 'mutation');
    },
    TeamUserInfoCurrentUser(variables?: TeamUserInfoCurrentUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TeamUserInfoCurrentUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TeamUserInfoCurrentUserQuery>(TeamUserInfoCurrentUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TeamUserInfoCurrentUser', 'query');
    },
    AddCity(variables: AddCityMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddCityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddCityMutation>(AddCityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddCity', 'mutation');
    },
    OrgUsers(variables: OrgUsersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OrgUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrgUsersQuery>(OrgUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OrgUsers', 'query');
    },
    teamUsers(variables?: TeamUsersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TeamUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TeamUsersQuery>(TeamUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'teamUsers', 'query');
    },
    GetOrgData(variables: GetOrgDataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOrgDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrgDataQuery>(GetOrgDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetOrgData', 'query');
    },
    TodayRequests(variables?: TodayRequestsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TodayRequestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TodayRequestsQuery>(TodayRequestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TodayRequests', 'query');
    },
    TodayCurrentUser(variables?: TodayCurrentUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TodayCurrentUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TodayCurrentUserQuery>(TodayCurrentUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TodayCurrentUser', 'query');
    },
    MenuCardList(variables?: MenuCardListQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MenuCardListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MenuCardListQuery>(MenuCardListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MenuCardList', 'query');
    },
    UserProfile(variables?: UserProfileQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UserProfileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserProfileQuery>(UserProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserProfile', 'query');
    },
    BookingPolicy(variables?: BookingPolicyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BookingPolicyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookingPolicyQuery>(BookingPolicyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BookingPolicy', 'query');
    },
    ProfileUpdateUser(variables: ProfileUpdateUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ProfileUpdateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileUpdateUserMutation>(ProfileUpdateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProfileUpdateUser', 'mutation');
    },
    ProfileCurrentUser(variables?: ProfileCurrentUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ProfileCurrentUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileCurrentUserQuery>(ProfileCurrentUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProfileCurrentUser', 'query');
    },
    PaymentMethod(variables?: PaymentMethodQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PaymentMethodQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentMethodQuery>(PaymentMethodDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PaymentMethod', 'query');
    },
    cancelOrder(variables: CancelOrderMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CancelOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelOrderMutation>(CancelOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cancelOrder', 'mutation');
    },
    ReservationDetailsCurrentUser(variables?: ReservationDetailsCurrentUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ReservationDetailsCurrentUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReservationDetailsCurrentUserQuery>(ReservationDetailsCurrentUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ReservationDetailsCurrentUser', 'query');
    },
    ReservationsPage(variables?: ReservationsPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ReservationsPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReservationsPageQuery>(ReservationsPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ReservationsPage', 'query');
    },
    CurrentUserAnalytics(variables?: CurrentUserAnalyticsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CurrentUserAnalyticsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentUserAnalyticsQuery>(CurrentUserAnalyticsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CurrentUserAnalytics', 'query');
    },
    LinkGoogleAccountToPasswordAccountIfExists(variables?: LinkGoogleAccountToPasswordAccountIfExistsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LinkGoogleAccountToPasswordAccountIfExistsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LinkGoogleAccountToPasswordAccountIfExistsMutation>(LinkGoogleAccountToPasswordAccountIfExistsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LinkGoogleAccountToPasswordAccountIfExists', 'mutation');
    },
    registerPasswordAccountToOrganizationIfExists(variables?: RegisterPasswordAccountToOrganizationIfExistsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RegisterPasswordAccountToOrganizationIfExistsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegisterPasswordAccountToOrganizationIfExistsMutation>(RegisterPasswordAccountToOrganizationIfExistsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registerPasswordAccountToOrganizationIfExists', 'mutation');
    },
    RegisterOktaAccountToOrganizationIfExists(variables?: RegisterOktaAccountToOrganizationIfExistsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RegisterOktaAccountToOrganizationIfExistsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegisterOktaAccountToOrganizationIfExistsMutation>(RegisterOktaAccountToOrganizationIfExistsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RegisterOktaAccountToOrganizationIfExists', 'mutation');
    },
    AuthLoader(variables?: AuthLoaderQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AuthLoaderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthLoaderQuery>(AuthLoaderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AuthLoader', 'query');
    },
    orgByDomain(variables: OrgByDomainQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OrgByDomainQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrgByDomainQuery>(OrgByDomainDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orgByDomain', 'query');
    },
    postAuth(variables?: PostAuthMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PostAuthMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PostAuthMutation>(PostAuthDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'postAuth', 'mutation');
    },
    CurrentUserId(variables?: CurrentUserIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CurrentUserIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentUserIdQuery>(CurrentUserIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CurrentUserId', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;